/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as protectedRouteRouteImport } from './routes/(protected)/route'
import { Route as authRouteRouteImport } from './routes/(auth)/route'
import { Route as protectedIndexRouteImport } from './routes/(protected)/index'
import { Route as TrustSlugRouteImport } from './routes/trust.$slug'
import { Route as OauthConsentRouteImport } from './routes/oauth/consent'
import { Route as IntegrationsGithubAppCallbackRouteImport } from './routes/integrations/github-app-callback'
import { Route as protectedAuditorCenterRouteImport } from './routes/(protected)/auditor-center'
import { Route as authVerifyEmailRouteImport } from './routes/(auth)/verify-email'
import { Route as authShareInviteRouteImport } from './routes/(auth)/share-invite'
import { Route as authResetPasswordRouteImport } from './routes/(auth)/reset-password'
import { Route as authOtpRouteImport } from './routes/(auth)/otp'
import { Route as authLogoutRouteImport } from './routes/(auth)/logout'
import { Route as authLoginRouteImport } from './routes/(auth)/login'
import { Route as authInviteRouteImport } from './routes/(auth)/invite'
import { Route as authAcceptInvitationRouteImport } from './routes/(auth)/accept-invitation'
import { Route as protectedWorkspacesRouteRouteImport } from './routes/(protected)/workspaces/route'
import { Route as protectedPartnerRouteRouteImport } from './routes/(protected)/partner/route'
import { Route as protectedOrgsRouteRouteImport } from './routes/(protected)/orgs/route'
import { Route as authOnboardingRouteRouteImport } from './routes/(auth)/onboarding/route'
import { Route as ExportTopicPdfIndexRouteImport } from './routes/export/topic-pdf/index'
import { Route as ExportTopicEmbedIndexRouteImport } from './routes/export/topic-embed/index'
import { Route as ExportPolicyPdfIndexRouteImport } from './routes/export/policy-pdf/index'
import { Route as ExportOrgChartIndexRouteImport } from './routes/export/org-chart/index'
import { Route as ExportEvidencePdfIndexRouteImport } from './routes/export/evidence-pdf/index'
import { Route as EvidenceVerifyIndexRouteImport } from './routes/evidence/verify/index'
import { Route as DemoTiptapIndexRouteImport } from './routes/demo/tiptap/index'
import { Route as protectedPartnerIndexRouteImport } from './routes/(protected)/partner/index'
import { Route as protectedAuditorCenterIndexRouteImport } from './routes/(protected)/auditor-center/index'
import { Route as TrustResourcesResourceIdRouteImport } from './routes/trust.resources.$resourceId'
import { Route as TrustNdaTokenRouteImport } from './routes/trust.nda.$token'
import { Route as TrustAccessTokenRouteImport } from './routes/trust.access.$token'
import { Route as DemoTiptapAiSuggestionRouteImport } from './routes/demo/tiptap/ai-suggestion'
import { Route as DemoTiptapAiChangesRouteImport } from './routes/demo/tiptap/ai-changes'
import { Route as protectedWorkspacesNewRouteImport } from './routes/(protected)/workspaces/new'
import { Route as protectedPartnerTemplatesRouteImport } from './routes/(protected)/partner/templates'
import { Route as protectedDevPlanRestrictionsTestRouteImport } from './routes/(protected)/dev/plan-restrictions-test'
import { Route as protectedAuditorCenterSecurityRouteImport } from './routes/(protected)/auditor-center/security'
import { Route as protectedAuditorCenterProfileRouteImport } from './routes/(protected)/auditor-center/profile'
import { Route as authOnboardingTeamRouteImport } from './routes/(auth)/onboarding/team'
import { Route as authOnboardingQuickSetupRouteImport } from './routes/(auth)/onboarding/quick-setup'
import { Route as authOnboardingPreferencesRouteImport } from './routes/(auth)/onboarding/preferences'
import { Route as authOnboardingExtensionRouteImport } from './routes/(auth)/onboarding/extension'
import { Route as authNativeLoginRouteImport } from './routes/(auth)/native/login'
import { Route as authNativeAuthCallbackRouteImport } from './routes/(auth)/native/auth-callback'
import { Route as authAuthCallbackProviderRouteImport } from './routes/(auth)/auth-callback/$provider'
import { Route as protectedWorkspacesWorkspaceIdRouteRouteImport } from './routes/(protected)/workspaces/$workspaceId/route'
import { Route as protectedOrgsSlugRouteRouteImport } from './routes/(protected)/orgs/$slug/route'
import { Route as protectedWorkspacesWorkspaceIdIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/index'
import { Route as protectedWorkspaceIntegrationsIndexRouteImport } from './routes/(protected)/workspace/integrations/index'
import { Route as protectedWorkspacesWorkspaceIdVendorsRouteImport } from './routes/(protected)/workspaces/$workspaceId/vendors'
import { Route as protectedWorkspacesWorkspaceIdTrustCenterRouteImport } from './routes/(protected)/workspaces/$workspaceId/trust-center'
import { Route as protectedWorkspacesWorkspaceIdTestsRouteImport } from './routes/(protected)/workspaces/$workspaceId/tests'
import { Route as protectedWorkspacesWorkspaceIdTasksRouteImport } from './routes/(protected)/workspaces/$workspaceId/tasks'
import { Route as protectedWorkspacesWorkspaceIdSystemDescriptionRouteImport } from './routes/(protected)/workspaces/$workspaceId/system-description'
import { Route as protectedWorkspacesWorkspaceIdStatementOfApplicabilityRouteImport } from './routes/(protected)/workspaces/$workspaceId/statement-of-applicability'
import { Route as protectedWorkspacesWorkspaceIdSetupRouteImport } from './routes/(protected)/workspaces/$workspaceId/setup'
import { Route as protectedWorkspacesWorkspaceIdRunbooksRouteImport } from './routes/(protected)/workspaces/$workspaceId/runbooks'
import { Route as protectedWorkspacesWorkspaceIdRisksRouteImport } from './routes/(protected)/workspaces/$workspaceId/risks'
import { Route as protectedWorkspacesWorkspaceIdReadinessRouteImport } from './routes/(protected)/workspaces/$workspaceId/readiness'
import { Route as protectedWorkspacesWorkspaceIdQuestionnairesRouteImport } from './routes/(protected)/workspaces/$workspaceId/questionnaires'
import { Route as protectedWorkspacesWorkspaceIdPoliciesRouteImport } from './routes/(protected)/workspaces/$workspaceId/policies'
import { Route as protectedWorkspacesWorkspaceIdPeopleRouteImport } from './routes/(protected)/workspaces/$workspaceId/people'
import { Route as protectedWorkspacesWorkspaceIdOnboardingRouteImport } from './routes/(protected)/workspaces/$workspaceId/onboarding'
import { Route as protectedWorkspacesWorkspaceIdMonitoringRouteImport } from './routes/(protected)/workspaces/$workspaceId/monitoring'
import { Route as protectedWorkspacesWorkspaceIdIntegrationsRouteImport } from './routes/(protected)/workspaces/$workspaceId/integrations'
import { Route as protectedWorkspacesWorkspaceIdInboxRouteImport } from './routes/(protected)/workspaces/$workspaceId/inbox'
import { Route as protectedWorkspacesWorkspaceIdGuideRouteImport } from './routes/(protected)/workspaces/$workspaceId/guide'
import { Route as protectedWorkspacesWorkspaceIdEvidenceSlotsRouteImport } from './routes/(protected)/workspaces/$workspaceId/evidence-slots'
import { Route as protectedWorkspacesWorkspaceIdEvidenceRouteImport } from './routes/(protected)/workspaces/$workspaceId/evidence'
import { Route as protectedWorkspacesWorkspaceIdDocumentsRouteImport } from './routes/(protected)/workspaces/$workspaceId/documents'
import { Route as protectedWorkspacesWorkspaceIdDashboardRouteImport } from './routes/(protected)/workspaces/$workspaceId/dashboard'
import { Route as protectedWorkspacesWorkspaceIdControlsRouteImport } from './routes/(protected)/workspaces/$workspaceId/controls'
import { Route as protectedWorkspacesWorkspaceIdConnectToolsRouteImport } from './routes/(protected)/workspaces/$workspaceId/connect-tools'
import { Route as protectedWorkspacesWorkspaceIdConnectRepoRouteImport } from './routes/(protected)/workspaces/$workspaceId/connect-repo'
import { Route as protectedWorkspacesWorkspaceIdAssetsRouteImport } from './routes/(protected)/workspaces/$workspaceId/assets'
import { Route as protectedWorkspacesWorkspaceIdApprovalsRouteImport } from './routes/(protected)/workspaces/$workspaceId/approvals'
import { Route as protectedWorkspacesWorkspaceIdAnonymousReportsRouteImport } from './routes/(protected)/workspaces/$workspaceId/anonymous-reports'
import { Route as protectedWorkspaceIntegrationsGithubRouteImport } from './routes/(protected)/workspace/integrations/github'
import { Route as protectedPartnerClientsNewRouteImport } from './routes/(protected)/partner/clients/new'
import { Route as protectedPartnerClientsClientIdRouteImport } from './routes/(protected)/partner/clients/$clientId'
import { Route as protectedWorkspacesWorkspaceIdSettingsRouteRouteImport } from './routes/(protected)/workspaces/$workspaceId/settings/route'
import { Route as protectedWorkspacesWorkspaceIdEmployeeCenterRouteRouteImport } from './routes/(protected)/workspaces/$workspaceId/employee-center/route'
import { Route as protectedWorkspacesWorkspaceIdAuditorCenterRouteRouteImport } from './routes/(protected)/workspaces/$workspaceId/auditor-center/route'
import { Route as protectedWorkspacesWorkspaceIdTemplatesIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/templates/index'
import { Route as protectedWorkspacesWorkspaceIdSettingsIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/settings/index'
import { Route as protectedWorkspacesWorkspaceIdRunsIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/runs/index'
import { Route as protectedWorkspacesWorkspaceIdPopulationsIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/populations/index'
import { Route as protectedWorkspacesWorkspaceIdFrameworksIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/frameworks/index'
import { Route as protectedWorkspacesWorkspaceIdEmployeeCenterIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/employee-center/index'
import { Route as protectedWorkspacesWorkspaceIdAuditsIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/audits/index'
import { Route as protectedWorkspacesWorkspaceIdAuditorCenterIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/auditor-center/index'
import { Route as protectedWorkspacesWorkspaceIdVendorsVendorIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/vendors_.$vendorId'
import { Route as protectedWorkspacesWorkspaceIdTemplatesPublicRouteImport } from './routes/(protected)/workspaces/$workspaceId/templates/public'
import { Route as protectedWorkspacesWorkspaceIdTemplatesNewRouteImport } from './routes/(protected)/workspaces/$workspaceId/templates/new'
import { Route as protectedWorkspacesWorkspaceIdTasksDetailRouteImport } from './routes/(protected)/workspaces/$workspaceId/tasks_.detail'
import { Route as protectedWorkspacesWorkspaceIdTasksTaskIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/tasks_.$taskId'
import { Route as protectedWorkspacesWorkspaceIdSubmissionsSubmissionIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/submissions/$submissionId'
import { Route as protectedWorkspacesWorkspaceIdSettingsWritingRouteImport } from './routes/(protected)/workspaces/$workspaceId/settings/writing'
import { Route as protectedWorkspacesWorkspaceIdSettingsThemeRouteImport } from './routes/(protected)/workspaces/$workspaceId/settings/theme'
import { Route as protectedWorkspacesWorkspaceIdSettingsTemplatesRouteImport } from './routes/(protected)/workspaces/$workspaceId/settings/templates'
import { Route as protectedWorkspacesWorkspaceIdSettingsSigningRouteImport } from './routes/(protected)/workspaces/$workspaceId/settings/signing'
import { Route as protectedWorkspacesWorkspaceIdSettingsSecurityRouteImport } from './routes/(protected)/workspaces/$workspaceId/settings/security'
import { Route as protectedWorkspacesWorkspaceIdSettingsReviewRouteImport } from './routes/(protected)/workspaces/$workspaceId/settings/review'
import { Route as protectedWorkspacesWorkspaceIdSettingsRequestIntakeRouteImport } from './routes/(protected)/workspaces/$workspaceId/settings/request-intake'
import { Route as protectedWorkspacesWorkspaceIdSettingsPropertiesRouteImport } from './routes/(protected)/workspaces/$workspaceId/settings/properties'
import { Route as protectedWorkspacesWorkspaceIdSettingsProgramRouteImport } from './routes/(protected)/workspaces/$workspaceId/settings/program'
import { Route as protectedWorkspacesWorkspaceIdSettingsProfileRouteImport } from './routes/(protected)/workspaces/$workspaceId/settings/profile'
import { Route as protectedWorkspacesWorkspaceIdSettingsProcedureTriggersRouteImport } from './routes/(protected)/workspaces/$workspaceId/settings/procedure-triggers'
import { Route as protectedWorkspacesWorkspaceIdSettingsPersonasRouteImport } from './routes/(protected)/workspaces/$workspaceId/settings/personas'
import { Route as protectedWorkspacesWorkspaceIdSettingsPersonalTokensRouteImport } from './routes/(protected)/workspaces/$workspaceId/settings/personal-tokens'
import { Route as protectedWorkspacesWorkspaceIdSettingsNotificationsRouteImport } from './routes/(protected)/workspaces/$workspaceId/settings/notifications'
import { Route as protectedWorkspacesWorkspaceIdSettingsMembersRouteImport } from './routes/(protected)/workspaces/$workspaceId/settings/members'
import { Route as protectedWorkspacesWorkspaceIdSettingsMcpServerRouteImport } from './routes/(protected)/workspaces/$workspaceId/settings/mcp-server'
import { Route as protectedWorkspacesWorkspaceIdSettingsIntegrationsRouteImport } from './routes/(protected)/workspaces/$workspaceId/settings/integrations'
import { Route as protectedWorkspacesWorkspaceIdSettingsImportsRouteImport } from './routes/(protected)/workspaces/$workspaceId/settings/imports'
import { Route as protectedWorkspacesWorkspaceIdSettingsGovernanceRouteImport } from './routes/(protected)/workspaces/$workspaceId/settings/governance'
import { Route as protectedWorkspacesWorkspaceIdSettingsGeneralRouteImport } from './routes/(protected)/workspaces/$workspaceId/settings/general'
import { Route as protectedWorkspacesWorkspaceIdSettingsExceptionsRouteImport } from './routes/(protected)/workspaces/$workspaceId/settings/exceptions'
import { Route as protectedWorkspacesWorkspaceIdSettingsEmailRouteImport } from './routes/(protected)/workspaces/$workspaceId/settings/email'
import { Route as protectedWorkspacesWorkspaceIdSettingsDataExportRouteImport } from './routes/(protected)/workspaces/$workspaceId/settings/data-export'
import { Route as protectedWorkspacesWorkspaceIdSettingsConfigurationRouteImport } from './routes/(protected)/workspaces/$workspaceId/settings/configuration'
import { Route as protectedWorkspacesWorkspaceIdSettingsComplianceRolesRouteImport } from './routes/(protected)/workspaces/$workspaceId/settings/compliance-roles'
import { Route as protectedWorkspacesWorkspaceIdSettingsChecksRouteImport } from './routes/(protected)/workspaces/$workspaceId/settings/checks'
import { Route as protectedWorkspacesWorkspaceIdSettingsChatRouteImport } from './routes/(protected)/workspaces/$workspaceId/settings/chat'
import { Route as protectedWorkspacesWorkspaceIdSettingsBrowserExtensionRouteImport } from './routes/(protected)/workspaces/$workspaceId/settings/browser-extension'
import { Route as protectedWorkspacesWorkspaceIdSettingsBillingRouteImport } from './routes/(protected)/workspaces/$workspaceId/settings/billing'
import { Route as protectedWorkspacesWorkspaceIdSettingsAuthRouteImport } from './routes/(protected)/workspaces/$workspaceId/settings/auth'
import { Route as protectedWorkspacesWorkspaceIdSettingsAuditLogsRouteImport } from './routes/(protected)/workspaces/$workspaceId/settings/audit-logs'
import { Route as protectedWorkspacesWorkspaceIdSettingsApiKeysRouteImport } from './routes/(protected)/workspaces/$workspaceId/settings/api-keys'
import { Route as protectedWorkspacesWorkspaceIdRunsExecutionIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/runs/$executionId'
import { Route as protectedWorkspacesWorkspaceIdRunbooksNewRouteImport } from './routes/(protected)/workspaces/$workspaceId/runbooks_.new'
import { Route as protectedWorkspacesWorkspaceIdRunbooksRunbookIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/runbooks_.$runbookId'
import { Route as protectedWorkspacesWorkspaceIdRisksRiskIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/risks_.$riskId'
import { Route as protectedWorkspacesWorkspaceIdReviewsAccessRouteImport } from './routes/(protected)/workspaces/$workspaceId/reviews.access'
import { Route as protectedWorkspacesWorkspaceIdQuestionnairesIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/questionnaires_.$id'
import { Route as protectedWorkspacesWorkspaceIdPoliciesPolicySlugRouteImport } from './routes/(protected)/workspaces/$workspaceId/policies_.$policySlug'
import { Route as protectedWorkspacesWorkspaceIdPeople_trainingProgramIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/people_training.$programId'
import { Route as protectedWorkspacesWorkspaceIdPeople_groupsGroupIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/people_groups.$groupId'
import { Route as protectedWorkspacesWorkspaceIdPeopleEmployeeIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/people_.$employeeId'
import { Route as protectedWorkspacesWorkspaceIdPeopleMeRouteImport } from './routes/(protected)/workspaces/$workspaceId/people.me'
import { Route as protectedWorkspacesWorkspaceIdIntegrationsProviderSlugRouteImport } from './routes/(protected)/workspaces/$workspaceId/integrations_.$providerSlug'
import { Route as protectedWorkspacesWorkspaceIdEvidenceCreatingRouteImport } from './routes/(protected)/workspaces/$workspaceId/evidence_.creating'
import { Route as protectedWorkspacesWorkspaceIdEvidenceViewerEvidencePackIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/evidence-viewer/$evidencePackId'
import { Route as protectedWorkspacesWorkspaceIdEmployeeCenterTrainingRouteImport } from './routes/(protected)/workspaces/$workspaceId/employee-center/training'
import { Route as protectedWorkspacesWorkspaceIdEmployeeCenterTasksRouteImport } from './routes/(protected)/workspaces/$workspaceId/employee-center/tasks'
import { Route as protectedWorkspacesWorkspaceIdEmployeeCenterRequestsRouteImport } from './routes/(protected)/workspaces/$workspaceId/employee-center/requests'
import { Route as protectedWorkspacesWorkspaceIdEmployeeCenterPendingPoliciesRouteImport } from './routes/(protected)/workspaces/$workspaceId/employee-center/pending-policies'
import { Route as protectedWorkspacesWorkspaceIdEmployeeCenterOrgChartRouteImport } from './routes/(protected)/workspaces/$workspaceId/employee-center/org-chart'
import { Route as protectedWorkspacesWorkspaceIdEmployeeCenterInboxRouteImport } from './routes/(protected)/workspaces/$workspaceId/employee-center/inbox'
import { Route as protectedWorkspacesWorkspaceIdEmployeeCenterDevicesRouteImport } from './routes/(protected)/workspaces/$workspaceId/employee-center/devices'
import { Route as protectedWorkspacesWorkspaceIdEmployeeCenterAnonymousReportingRouteImport } from './routes/(protected)/workspaces/$workspaceId/employee-center/anonymous-reporting'
import { Route as protectedWorkspacesWorkspaceIdEmployeeCenterAcknowledgmentsRouteImport } from './routes/(protected)/workspaces/$workspaceId/employee-center/acknowledgments'
import { Route as protectedWorkspacesWorkspaceIdDocumentsDocIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/documents_.$docId'
import { Route as protectedWorkspacesWorkspaceIdDevicesDeviceIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/devices_.$deviceId'
import { Route as protectedWorkspacesWorkspaceIdDevToolUiRouteImport } from './routes/(protected)/workspaces/$workspaceId/dev/tool-ui'
import { Route as protectedWorkspacesWorkspaceIdDeprecatedComplianceRouteOldRouteImport } from './routes/(protected)/workspaces/$workspaceId/deprecated/compliance-route-old'
import { Route as protectedWorkspacesWorkspaceIdControlsControlDefIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/controls_.$controlDefId'
import { Route as protectedWorkspacesWorkspaceIdChatThreadIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/chat_.$threadId'
import { Route as protectedWorkspacesWorkspaceIdAuditsAuditCycleIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/audits/$auditCycleId'
import { Route as protectedWorkspacesWorkspaceIdAuditorCenterApiAccessRouteImport } from './routes/(protected)/workspaces/$workspaceId/auditor-center/api-access'
import { Route as protectedWorkspacesWorkspaceIdAssetsAssetIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/assets_.$assetId'
import { Route as protectedWorkspacesWorkspaceIdAnonymousReportsReportIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/anonymous-reports_.$reportId'
import { Route as protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRouteImport } from './routes/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/route'
import { Route as protectedWorkspacesWorkspaceIdTestsTestIdIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/tests_/$testId/index'
import { Route as protectedWorkspacesWorkspaceIdTemplatesTemplateIdIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/templates/$templateId/index'
import { Route as protectedWorkspacesWorkspaceIdFrameworksFrameworkIdIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/frameworks/$frameworkId/index'
import { Route as protectedWorkspacesWorkspaceIdDeprecatedSourcesIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/deprecated/sources/index'
import { Route as protectedWorkspacesWorkspaceIdAutomationExecutionIdIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/automation/$executionId/index'
import { Route as protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/index'
import { Route as protectedWorkspacesWorkspaceIdTestsTestIdSubmissionsRouteImport } from './routes/(protected)/workspaces/$workspaceId/tests_/$testId/submissions'
import { Route as protectedWorkspacesWorkspaceIdTemplatesTemplateIdEditRouteImport } from './routes/(protected)/workspaces/$workspaceId/templates/$templateId/edit'
import { Route as protectedWorkspacesWorkspaceIdRisksAssessmentsDraftIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/risks_.assessments.$draftId'
import { Route as protectedWorkspacesWorkspaceIdReviewsAccessRolesRouteImport } from './routes/(protected)/workspaces/$workspaceId/reviews.access_.roles'
import { Route as protectedWorkspacesWorkspaceIdReviewsAccessCycleIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/reviews.access_.$cycleId'
import { Route as protectedWorkspacesWorkspaceIdRecordingsFlowIdEditRouteImport } from './routes/(protected)/workspaces/$workspaceId/recordings_.$flowId.edit'
import { Route as protectedWorkspacesWorkspaceIdIntegrationsCustomApplicationIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/integrations_.custom.$applicationId'
import { Route as protectedWorkspacesWorkspaceIdEmployeeCenterTrainingProgramIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/employee-center/training_.$programId'
import { Route as protectedWorkspacesWorkspaceIdEmployeeCenterTestsTestIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/employee-center/tests_.$testId'
import { Route as protectedWorkspacesWorkspaceIdEmployeeCenterTasksTaskIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/employee-center/tasks_.$taskId'
import { Route as protectedWorkspacesWorkspaceIdEmployeeCenterRequestsTaskIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/employee-center/requests_.$taskId'
import { Route as protectedWorkspacesWorkspaceIdEmployeeCenterPendingPoliciesTemplateIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/employee-center/pending-policies_.$templateId'
import { Route as protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdVendorsRouteImport } from './routes/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/vendors'
import { Route as protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdTimelineRouteImport } from './routes/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/timeline'
import { Route as protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRisksRouteImport } from './routes/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/risks'
import { Route as protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRequestListRouteImport } from './routes/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/request-list'
import { Route as protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPopulationsRouteImport } from './routes/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/populations'
import { Route as protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPeopleRouteImport } from './routes/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/people'
import { Route as protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdOpenRequestsRouteImport } from './routes/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/open-requests'
import { Route as protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsRouteImport } from './routes/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations'
import { Route as protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdEvidenceRouteImport } from './routes/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/evidence'
import { Route as protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdDashboardRouteImport } from './routes/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/dashboard'
import { Route as protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdControlsRouteImport } from './routes/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/controls'
import { Route as protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAssetsRouteImport } from './routes/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/assets'
import { Route as protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdApiAccessRouteImport } from './routes/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/api-access'
import { Route as protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesRouteRouteImport } from './routes/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId_/policies/route'
import { Route as protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceRouteRouteImport } from './routes/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/audit-evidence/route'
import { Route as protectedWorkspacesWorkspaceIdTemplatesControlControlIdIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/templates/control/$controlId/index'
import { Route as protectedWorkspacesWorkspaceIdFrameworksFrameworkIdControlsIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/frameworks/$frameworkId/controls/index'
import { Route as protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId_/policies/index'
import { Route as protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceIndexRouteImport } from './routes/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/audit-evidence/index'
import { Route as protectedWorkspacesWorkspaceIdVendorsVendorIdAssessmentsAssessmentIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/vendors_.$vendorId_.assessments.$assessmentId'
import { Route as protectedWorkspacesWorkspaceIdReviewsAccessPeriodPeriodKeyRouteImport } from './routes/(protected)/workspaces/$workspaceId/reviews.access_.period.$periodKey'
import { Route as protectedWorkspacesWorkspaceIdIntegrationsProviderSlugServicesServiceIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/integrations_.$providerSlug_.services.$serviceId'
import { Route as protectedWorkspacesWorkspaceIdIntegrationsProviderSlugAccountsConnectionIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/integrations_.$providerSlug_.accounts.$connectionId'
import { Route as protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesPolicySlugRouteImport } from './routes/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId_/policies/$policySlug'
import { Route as protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdVendorsVendorIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/vendors_.$vendorId'
import { Route as protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRisksRiskIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/risks_.$riskId'
import { Route as protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPopulationsPopulationIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/populations_.$populationId'
import { Route as protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPeopleEmployeeIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/people_/$employeeId'
import { Route as protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsProviderSlugRouteImport } from './routes/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations_.$providerSlug'
import { Route as protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAssetsAssetIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/assets_.$assetId'
import { Route as protectedWorkspacesWorkspaceIdIntegrationsCustomApplicationIdDatasetsDatasetIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/integrations_.custom.$applicationId_.datasets.$datasetId'
import { Route as protectedWorkspacesWorkspaceIdDeprecatedWorkflowsWorkflowIdExecutionsJobIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/deprecated/workflows/$workflowId/executions/$jobId'
import { Route as protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceEvidenceKindEvidenceItemIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/audit-evidence/$evidenceKind/$evidenceItemId'
import { Route as protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdVendorsVendorIdReviewsAssessmentIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/vendors_.$vendorId_.reviews.$assessmentId'
import { Route as protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPopulationsPopulationIdRoundsSampleIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/populations_.$populationId_.rounds.$sampleId'
import { Route as protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsProviderSlugServicesServiceIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations_.$providerSlug_.services.$serviceId'
import { Route as protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsProviderSlugAccountsConnectionIdRouteImport } from './routes/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations_.$providerSlug_.accounts.$connectionId'

const ExtensionUninstalledLazyRouteImport = createFileRoute(
  '/extension-uninstalled',
)()
const SharedShareIdLazyRouteImport = createFileRoute('/shared/$shareId')()
const errors503LazyRouteImport = createFileRoute('/(errors)/503')()
const errors500LazyRouteImport = createFileRoute('/(errors)/500')()
const errors404LazyRouteImport = createFileRoute('/(errors)/404')()
const errors403LazyRouteImport = createFileRoute('/(errors)/403')()
const errors401LazyRouteImport = createFileRoute('/(errors)/401')()
const authVerifyOtpLazyRouteImport = createFileRoute('/(auth)/verify-otp')()
const authVerify2faLazyRouteImport = createFileRoute('/(auth)/verify-2fa')()
const authSignupLazyRouteImport = createFileRoute('/(auth)/signup')()
const authSetupMfaLazyRouteImport = createFileRoute('/(auth)/setup-mfa')()
const authLogin2LazyRouteImport = createFileRoute('/(auth)/login-2')()
const authForgotPasswordLazyRouteImport = createFileRoute(
  '/(auth)/forgot-password',
)()
const protectedWorkspacesIndexLazyRouteImport = createFileRoute(
  '/(protected)/workspaces/',
)()
const protectedOrgsIndexLazyRouteImport =
  createFileRoute('/(protected)/orgs/')()
const protectedOnboardingIndexLazyRouteImport = createFileRoute(
  '/(protected)/onboarding/',
)()
const protectedOnboardingOrganizationIdWorkspaceLazyRouteImport =
  createFileRoute('/(protected)/onboarding/$organizationId/workspace')()
const protectedWorkspacesWorkspaceIdAutomationIndexLazyRouteImport =
  createFileRoute('/(protected)/workspaces/$workspaceId/automation/')()
const protectedWorkspacesWorkspaceIdDeprecatedAgentReliabilityLazyRouteImport =
  createFileRoute(
    '/(protected)/workspaces/$workspaceId/deprecated/agent-reliability',
  )()
const protectedWorkspacesWorkspaceIdAutomationIdentitiesLazyRouteImport =
  createFileRoute(
    '/(protected)/workspaces/$workspaceId/automation/identities',
  )()
const protectedWorkspacesWorkspaceIdDeprecatedIntegrationsOldIndexLazyRouteImport =
  createFileRoute(
    '/(protected)/workspaces/$workspaceId/deprecated/integrations-old/',
  )()

const ExtensionUninstalledLazyRoute =
  ExtensionUninstalledLazyRouteImport.update({
    id: '/extension-uninstalled',
    path: '/extension-uninstalled',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/extension-uninstalled.lazy').then((d) => d.Route),
  )
const protectedRouteRoute = protectedRouteRouteImport.update({
  id: '/(protected)',
  getParentRoute: () => rootRouteImport,
} as any)
const authRouteRoute = authRouteRouteImport.update({
  id: '/(auth)',
  getParentRoute: () => rootRouteImport,
} as any)
const protectedIndexRoute = protectedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => protectedRouteRoute,
} as any)
const SharedShareIdLazyRoute = SharedShareIdLazyRouteImport.update({
  id: '/shared/$shareId',
  path: '/shared/$shareId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/shared.$shareId.lazy').then((d) => d.Route),
)
const errors503LazyRoute = errors503LazyRouteImport
  .update({
    id: '/(errors)/503',
    path: '/503',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/503.lazy').then((d) => d.Route))
const errors500LazyRoute = errors500LazyRouteImport
  .update({
    id: '/(errors)/500',
    path: '/500',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/500.lazy').then((d) => d.Route))
const errors404LazyRoute = errors404LazyRouteImport
  .update({
    id: '/(errors)/404',
    path: '/404',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/404.lazy').then((d) => d.Route))
const errors403LazyRoute = errors403LazyRouteImport
  .update({
    id: '/(errors)/403',
    path: '/403',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/403.lazy').then((d) => d.Route))
const errors401LazyRoute = errors401LazyRouteImport
  .update({
    id: '/(errors)/401',
    path: '/401',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(errors)/401.lazy').then((d) => d.Route))
const authVerifyOtpLazyRoute = authVerifyOtpLazyRouteImport
  .update({
    id: '/verify-otp',
    path: '/verify-otp',
    getParentRoute: () => authRouteRoute,
  } as any)
  .lazy(() => import('./routes/(auth)/verify-otp.lazy').then((d) => d.Route))
const authVerify2faLazyRoute = authVerify2faLazyRouteImport
  .update({
    id: '/verify-2fa',
    path: '/verify-2fa',
    getParentRoute: () => authRouteRoute,
  } as any)
  .lazy(() => import('./routes/(auth)/verify-2fa.lazy').then((d) => d.Route))
const authSignupLazyRoute = authSignupLazyRouteImport
  .update({
    id: '/signup',
    path: '/signup',
    getParentRoute: () => authRouteRoute,
  } as any)
  .lazy(() => import('./routes/(auth)/signup.lazy').then((d) => d.Route))
const authSetupMfaLazyRoute = authSetupMfaLazyRouteImport
  .update({
    id: '/setup-mfa',
    path: '/setup-mfa',
    getParentRoute: () => authRouteRoute,
  } as any)
  .lazy(() => import('./routes/(auth)/setup-mfa.lazy').then((d) => d.Route))
const authLogin2LazyRoute = authLogin2LazyRouteImport
  .update({
    id: '/login-2',
    path: '/login-2',
    getParentRoute: () => authRouteRoute,
  } as any)
  .lazy(() => import('./routes/(auth)/login-2.lazy').then((d) => d.Route))
const authForgotPasswordLazyRoute = authForgotPasswordLazyRouteImport
  .update({
    id: '/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => authRouteRoute,
  } as any)
  .lazy(() =>
    import('./routes/(auth)/forgot-password.lazy').then((d) => d.Route),
  )
const TrustSlugRoute = TrustSlugRouteImport.update({
  id: '/trust/$slug',
  path: '/trust/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthConsentRoute = OauthConsentRouteImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsGithubAppCallbackRoute =
  IntegrationsGithubAppCallbackRouteImport.update({
    id: '/integrations/github-app-callback',
    path: '/integrations/github-app-callback',
    getParentRoute: () => rootRouteImport,
  } as any)
const protectedAuditorCenterRoute = protectedAuditorCenterRouteImport.update({
  id: '/auditor-center',
  path: '/auditor-center',
  getParentRoute: () => protectedRouteRoute,
} as any)
const authVerifyEmailRoute = authVerifyEmailRouteImport
  .update({
    id: '/verify-email',
    path: '/verify-email',
    getParentRoute: () => authRouteRoute,
  } as any)
  .lazy(() => import('./routes/(auth)/verify-email.lazy').then((d) => d.Route))
const authShareInviteRoute = authShareInviteRouteImport.update({
  id: '/share-invite',
  path: '/share-invite',
  getParentRoute: () => authRouteRoute,
} as any)
const authResetPasswordRoute = authResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => authRouteRoute,
} as any)
const authOtpRoute = authOtpRouteImport.update({
  id: '/otp',
  path: '/otp',
  getParentRoute: () => authRouteRoute,
} as any)
const authLogoutRoute = authLogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => authRouteRoute,
} as any)
const authLoginRoute = authLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => authRouteRoute,
} as any)
const authInviteRoute = authInviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => authRouteRoute,
} as any)
const authAcceptInvitationRoute = authAcceptInvitationRouteImport.update({
  id: '/accept-invitation',
  path: '/accept-invitation',
  getParentRoute: () => authRouteRoute,
} as any)
const protectedWorkspacesRouteRoute =
  protectedWorkspacesRouteRouteImport.update({
    id: '/workspaces',
    path: '/workspaces',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedPartnerRouteRoute = protectedPartnerRouteRouteImport.update({
  id: '/partner',
  path: '/partner',
  getParentRoute: () => protectedRouteRoute,
} as any)
const protectedOrgsRouteRoute = protectedOrgsRouteRouteImport.update({
  id: '/orgs',
  path: '/orgs',
  getParentRoute: () => protectedRouteRoute,
} as any)
const authOnboardingRouteRoute = authOnboardingRouteRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => authRouteRoute,
} as any)
const protectedWorkspacesIndexLazyRoute =
  protectedWorkspacesIndexLazyRouteImport
    .update({
      id: '/',
      path: '/',
      getParentRoute: () => protectedWorkspacesRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/index.lazy').then((d) => d.Route),
    )
const protectedOrgsIndexLazyRoute = protectedOrgsIndexLazyRouteImport
  .update({
    id: '/',
    path: '/',
    getParentRoute: () => protectedOrgsRouteRoute,
  } as any)
  .lazy(() =>
    import('./routes/(protected)/orgs/index.lazy').then((d) => d.Route),
  )
const protectedOnboardingIndexLazyRoute =
  protectedOnboardingIndexLazyRouteImport
    .update({
      id: '/onboarding/',
      path: '/onboarding/',
      getParentRoute: () => protectedRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/onboarding/index.lazy').then((d) => d.Route),
    )
const ExportTopicPdfIndexRoute = ExportTopicPdfIndexRouteImport.update({
  id: '/export/topic-pdf/',
  path: '/export/topic-pdf/',
  getParentRoute: () => rootRouteImport,
} as any)
const ExportTopicEmbedIndexRoute = ExportTopicEmbedIndexRouteImport.update({
  id: '/export/topic-embed/',
  path: '/export/topic-embed/',
  getParentRoute: () => rootRouteImport,
} as any)
const ExportPolicyPdfIndexRoute = ExportPolicyPdfIndexRouteImport.update({
  id: '/export/policy-pdf/',
  path: '/export/policy-pdf/',
  getParentRoute: () => rootRouteImport,
} as any)
const ExportOrgChartIndexRoute = ExportOrgChartIndexRouteImport.update({
  id: '/export/org-chart/',
  path: '/export/org-chart/',
  getParentRoute: () => rootRouteImport,
} as any)
const ExportEvidencePdfIndexRoute = ExportEvidencePdfIndexRouteImport.update({
  id: '/export/evidence-pdf/',
  path: '/export/evidence-pdf/',
  getParentRoute: () => rootRouteImport,
} as any)
const EvidenceVerifyIndexRoute = EvidenceVerifyIndexRouteImport.update({
  id: '/evidence/verify/',
  path: '/evidence/verify/',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoTiptapIndexRoute = DemoTiptapIndexRouteImport.update({
  id: '/demo/tiptap/',
  path: '/demo/tiptap/',
  getParentRoute: () => rootRouteImport,
} as any)
const protectedPartnerIndexRoute = protectedPartnerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => protectedPartnerRouteRoute,
} as any)
const protectedAuditorCenterIndexRoute =
  protectedAuditorCenterIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => protectedAuditorCenterRoute,
  } as any)
const TrustResourcesResourceIdRoute =
  TrustResourcesResourceIdRouteImport.update({
    id: '/trust/resources/$resourceId',
    path: '/trust/resources/$resourceId',
    getParentRoute: () => rootRouteImport,
  } as any)
const TrustNdaTokenRoute = TrustNdaTokenRouteImport.update({
  id: '/trust/nda/$token',
  path: '/trust/nda/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const TrustAccessTokenRoute = TrustAccessTokenRouteImport.update({
  id: '/trust/access/$token',
  path: '/trust/access/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoTiptapAiSuggestionRoute = DemoTiptapAiSuggestionRouteImport.update({
  id: '/demo/tiptap/ai-suggestion',
  path: '/demo/tiptap/ai-suggestion',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoTiptapAiChangesRoute = DemoTiptapAiChangesRouteImport.update({
  id: '/demo/tiptap/ai-changes',
  path: '/demo/tiptap/ai-changes',
  getParentRoute: () => rootRouteImport,
} as any)
const protectedWorkspacesNewRoute = protectedWorkspacesNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => protectedWorkspacesRouteRoute,
} as any)
const protectedPartnerTemplatesRoute =
  protectedPartnerTemplatesRouteImport.update({
    id: '/templates',
    path: '/templates',
    getParentRoute: () => protectedPartnerRouteRoute,
  } as any)
const protectedDevPlanRestrictionsTestRoute =
  protectedDevPlanRestrictionsTestRouteImport.update({
    id: '/dev/plan-restrictions-test',
    path: '/dev/plan-restrictions-test',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedAuditorCenterSecurityRoute =
  protectedAuditorCenterSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => protectedAuditorCenterRoute,
  } as any)
const protectedAuditorCenterProfileRoute =
  protectedAuditorCenterProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => protectedAuditorCenterRoute,
  } as any)
const authOnboardingTeamRoute = authOnboardingTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => authOnboardingRouteRoute,
} as any)
const authOnboardingQuickSetupRoute =
  authOnboardingQuickSetupRouteImport.update({
    id: '/quick-setup',
    path: '/quick-setup',
    getParentRoute: () => authOnboardingRouteRoute,
  } as any)
const authOnboardingPreferencesRoute =
  authOnboardingPreferencesRouteImport.update({
    id: '/preferences',
    path: '/preferences',
    getParentRoute: () => authOnboardingRouteRoute,
  } as any)
const authOnboardingExtensionRoute = authOnboardingExtensionRouteImport.update({
  id: '/extension',
  path: '/extension',
  getParentRoute: () => authOnboardingRouteRoute,
} as any)
const authNativeLoginRoute = authNativeLoginRouteImport.update({
  id: '/native/login',
  path: '/native/login',
  getParentRoute: () => authRouteRoute,
} as any)
const authNativeAuthCallbackRoute = authNativeAuthCallbackRouteImport.update({
  id: '/native/auth-callback',
  path: '/native/auth-callback',
  getParentRoute: () => authRouteRoute,
} as any)
const authAuthCallbackProviderRoute =
  authAuthCallbackProviderRouteImport.update({
    id: '/auth-callback/$provider',
    path: '/auth-callback/$provider',
    getParentRoute: () => authRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdRouteRoute =
  protectedWorkspacesWorkspaceIdRouteRouteImport.update({
    id: '/$workspaceId',
    path: '/$workspaceId',
    getParentRoute: () => protectedWorkspacesRouteRoute,
  } as any)
const protectedOrgsSlugRouteRoute = protectedOrgsSlugRouteRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => protectedOrgsRouteRoute,
} as any)
const protectedWorkspacesWorkspaceIdIndexRoute =
  protectedWorkspacesWorkspaceIdIndexRouteImport
    .update({
      id: '/',
      path: '/',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/index.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspaceIntegrationsIndexRoute =
  protectedWorkspaceIntegrationsIndexRouteImport.update({
    id: '/workspace/integrations/',
    path: '/workspace/integrations/',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedOnboardingOrganizationIdWorkspaceLazyRoute =
  protectedOnboardingOrganizationIdWorkspaceLazyRouteImport
    .update({
      id: '/onboarding/$organizationId/workspace',
      path: '/onboarding/$organizationId/workspace',
      getParentRoute: () => protectedRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/onboarding/$organizationId.workspace.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdVendorsRoute =
  protectedWorkspacesWorkspaceIdVendorsRouteImport.update({
    id: '/vendors',
    path: '/vendors',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdTrustCenterRoute =
  protectedWorkspacesWorkspaceIdTrustCenterRouteImport
    .update({
      id: '/trust-center',
      path: '/trust-center',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/trust-center.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdTestsRoute =
  protectedWorkspacesWorkspaceIdTestsRouteImport
    .update({
      id: '/tests',
      path: '/tests',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/tests.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdTasksRoute =
  protectedWorkspacesWorkspaceIdTasksRouteImport
    .update({
      id: '/tasks',
      path: '/tasks',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/tasks.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdSystemDescriptionRoute =
  protectedWorkspacesWorkspaceIdSystemDescriptionRouteImport.update({
    id: '/system-description',
    path: '/system-description',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdStatementOfApplicabilityRoute =
  protectedWorkspacesWorkspaceIdStatementOfApplicabilityRouteImport.update({
    id: '/statement-of-applicability',
    path: '/statement-of-applicability',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSetupRoute =
  protectedWorkspacesWorkspaceIdSetupRouteImport.update({
    id: '/setup',
    path: '/setup',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdRunbooksRoute =
  protectedWorkspacesWorkspaceIdRunbooksRouteImport.update({
    id: '/runbooks',
    path: '/runbooks',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdRisksRoute =
  protectedWorkspacesWorkspaceIdRisksRouteImport
    .update({
      id: '/risks',
      path: '/risks',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/risks.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdReadinessRoute =
  protectedWorkspacesWorkspaceIdReadinessRouteImport
    .update({
      id: '/readiness',
      path: '/readiness',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/readiness.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdQuestionnairesRoute =
  protectedWorkspacesWorkspaceIdQuestionnairesRouteImport
    .update({
      id: '/questionnaires',
      path: '/questionnaires',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/questionnaires.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdPoliciesRoute =
  protectedWorkspacesWorkspaceIdPoliciesRouteImport.update({
    id: '/policies',
    path: '/policies',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdPeopleRoute =
  protectedWorkspacesWorkspaceIdPeopleRouteImport
    .update({
      id: '/people',
      path: '/people',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/people.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdOnboardingRoute =
  protectedWorkspacesWorkspaceIdOnboardingRouteImport.update({
    id: '/onboarding',
    path: '/onboarding',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdMonitoringRoute =
  protectedWorkspacesWorkspaceIdMonitoringRouteImport
    .update({
      id: '/monitoring',
      path: '/monitoring',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/monitoring.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdIntegrationsRoute =
  protectedWorkspacesWorkspaceIdIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdInboxRoute =
  protectedWorkspacesWorkspaceIdInboxRouteImport
    .update({
      id: '/inbox',
      path: '/inbox',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/inbox.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdGuideRoute =
  protectedWorkspacesWorkspaceIdGuideRouteImport.update({
    id: '/guide',
    path: '/guide',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdEvidenceSlotsRoute =
  protectedWorkspacesWorkspaceIdEvidenceSlotsRouteImport
    .update({
      id: '/evidence-slots',
      path: '/evidence-slots',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/evidence-slots.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdEvidenceRoute =
  protectedWorkspacesWorkspaceIdEvidenceRouteImport.update({
    id: '/evidence',
    path: '/evidence',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdDocumentsRoute =
  protectedWorkspacesWorkspaceIdDocumentsRouteImport
    .update({
      id: '/documents',
      path: '/documents',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/documents.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdDashboardRoute =
  protectedWorkspacesWorkspaceIdDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdControlsRoute =
  protectedWorkspacesWorkspaceIdControlsRouteImport
    .update({
      id: '/controls',
      path: '/controls',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/controls.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdConnectToolsRoute =
  protectedWorkspacesWorkspaceIdConnectToolsRouteImport.update({
    id: '/connect-tools',
    path: '/connect-tools',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdConnectRepoRoute =
  protectedWorkspacesWorkspaceIdConnectRepoRouteImport.update({
    id: '/connect-repo',
    path: '/connect-repo',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdAssetsRoute =
  protectedWorkspacesWorkspaceIdAssetsRouteImport.update({
    id: '/assets',
    path: '/assets',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdApprovalsRoute =
  protectedWorkspacesWorkspaceIdApprovalsRouteImport.update({
    id: '/approvals',
    path: '/approvals',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdAnonymousReportsRoute =
  protectedWorkspacesWorkspaceIdAnonymousReportsRouteImport.update({
    id: '/anonymous-reports',
    path: '/anonymous-reports',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspaceIntegrationsGithubRoute =
  protectedWorkspaceIntegrationsGithubRouteImport.update({
    id: '/workspace/integrations/github',
    path: '/workspace/integrations/github',
    getParentRoute: () => protectedRouteRoute,
  } as any)
const protectedPartnerClientsNewRoute =
  protectedPartnerClientsNewRouteImport.update({
    id: '/clients/new',
    path: '/clients/new',
    getParentRoute: () => protectedPartnerRouteRoute,
  } as any)
const protectedPartnerClientsClientIdRoute =
  protectedPartnerClientsClientIdRouteImport.update({
    id: '/clients/$clientId',
    path: '/clients/$clientId',
    getParentRoute: () => protectedPartnerRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSettingsRouteRoute =
  protectedWorkspacesWorkspaceIdSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdEmployeeCenterRouteRoute =
  protectedWorkspacesWorkspaceIdEmployeeCenterRouteRouteImport.update({
    id: '/employee-center',
    path: '/employee-center',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdAuditorCenterRouteRoute =
  protectedWorkspacesWorkspaceIdAuditorCenterRouteRouteImport.update({
    id: '/auditor-center',
    path: '/auditor-center',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdAutomationIndexLazyRoute =
  protectedWorkspacesWorkspaceIdAutomationIndexLazyRouteImport
    .update({
      id: '/automation/',
      path: '/automation/',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/automation/index.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdTemplatesIndexRoute =
  protectedWorkspacesWorkspaceIdTemplatesIndexRouteImport.update({
    id: '/templates/',
    path: '/templates/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSettingsIndexRoute =
  protectedWorkspacesWorkspaceIdSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdRunsIndexRoute =
  protectedWorkspacesWorkspaceIdRunsIndexRouteImport.update({
    id: '/runs/',
    path: '/runs/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdPopulationsIndexRoute =
  protectedWorkspacesWorkspaceIdPopulationsIndexRouteImport.update({
    id: '/populations/',
    path: '/populations/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdFrameworksIndexRoute =
  protectedWorkspacesWorkspaceIdFrameworksIndexRouteImport.update({
    id: '/frameworks/',
    path: '/frameworks/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdEmployeeCenterIndexRoute =
  protectedWorkspacesWorkspaceIdEmployeeCenterIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      protectedWorkspacesWorkspaceIdEmployeeCenterRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdAuditsIndexRoute =
  protectedWorkspacesWorkspaceIdAuditsIndexRouteImport
    .update({
      id: '/audits/',
      path: '/audits/',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/audits/index.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdAuditorCenterIndexRoute =
  protectedWorkspacesWorkspaceIdAuditorCenterIndexRouteImport
    .update({
      id: '/',
      path: '/',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdAuditorCenterRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/auditor-center/index.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdDeprecatedAgentReliabilityLazyRoute =
  protectedWorkspacesWorkspaceIdDeprecatedAgentReliabilityLazyRouteImport
    .update({
      id: '/deprecated/agent-reliability',
      path: '/deprecated/agent-reliability',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/deprecated/agent-reliability.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdAutomationIdentitiesLazyRoute =
  protectedWorkspacesWorkspaceIdAutomationIdentitiesLazyRouteImport
    .update({
      id: '/automation/identities',
      path: '/automation/identities',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/automation/identities.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdVendorsVendorIdRoute =
  protectedWorkspacesWorkspaceIdVendorsVendorIdRouteImport.update({
    id: '/vendors_/$vendorId',
    path: '/vendors/$vendorId',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdTemplatesPublicRoute =
  protectedWorkspacesWorkspaceIdTemplatesPublicRouteImport.update({
    id: '/templates/public',
    path: '/templates/public',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdTemplatesNewRoute =
  protectedWorkspacesWorkspaceIdTemplatesNewRouteImport.update({
    id: '/templates/new',
    path: '/templates/new',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdTasksDetailRoute =
  protectedWorkspacesWorkspaceIdTasksDetailRouteImport.update({
    id: '/tasks_/detail',
    path: '/tasks/detail',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdTasksTaskIdRoute =
  protectedWorkspacesWorkspaceIdTasksTaskIdRouteImport
    .update({
      id: '/tasks_/$taskId',
      path: '/tasks/$taskId',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/tasks_.$taskId.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdSubmissionsSubmissionIdRoute =
  protectedWorkspacesWorkspaceIdSubmissionsSubmissionIdRouteImport.update({
    id: '/submissions/$submissionId',
    path: '/submissions/$submissionId',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSettingsWritingRoute =
  protectedWorkspacesWorkspaceIdSettingsWritingRouteImport.update({
    id: '/writing',
    path: '/writing',
    getParentRoute: () => protectedWorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSettingsThemeRoute =
  protectedWorkspacesWorkspaceIdSettingsThemeRouteImport.update({
    id: '/theme',
    path: '/theme',
    getParentRoute: () => protectedWorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSettingsTemplatesRoute =
  protectedWorkspacesWorkspaceIdSettingsTemplatesRouteImport.update({
    id: '/templates',
    path: '/templates',
    getParentRoute: () => protectedWorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSettingsSigningRoute =
  protectedWorkspacesWorkspaceIdSettingsSigningRouteImport.update({
    id: '/signing',
    path: '/signing',
    getParentRoute: () => protectedWorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSettingsSecurityRoute =
  protectedWorkspacesWorkspaceIdSettingsSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => protectedWorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSettingsReviewRoute =
  protectedWorkspacesWorkspaceIdSettingsReviewRouteImport.update({
    id: '/review',
    path: '/review',
    getParentRoute: () => protectedWorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSettingsRequestIntakeRoute =
  protectedWorkspacesWorkspaceIdSettingsRequestIntakeRouteImport.update({
    id: '/request-intake',
    path: '/request-intake',
    getParentRoute: () => protectedWorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSettingsPropertiesRoute =
  protectedWorkspacesWorkspaceIdSettingsPropertiesRouteImport.update({
    id: '/properties',
    path: '/properties',
    getParentRoute: () => protectedWorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSettingsProgramRoute =
  protectedWorkspacesWorkspaceIdSettingsProgramRouteImport.update({
    id: '/program',
    path: '/program',
    getParentRoute: () => protectedWorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSettingsProfileRoute =
  protectedWorkspacesWorkspaceIdSettingsProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => protectedWorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSettingsProcedureTriggersRoute =
  protectedWorkspacesWorkspaceIdSettingsProcedureTriggersRouteImport.update({
    id: '/procedure-triggers',
    path: '/procedure-triggers',
    getParentRoute: () => protectedWorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSettingsPersonasRoute =
  protectedWorkspacesWorkspaceIdSettingsPersonasRouteImport.update({
    id: '/personas',
    path: '/personas',
    getParentRoute: () => protectedWorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSettingsPersonalTokensRoute =
  protectedWorkspacesWorkspaceIdSettingsPersonalTokensRouteImport.update({
    id: '/personal-tokens',
    path: '/personal-tokens',
    getParentRoute: () => protectedWorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSettingsNotificationsRoute =
  protectedWorkspacesWorkspaceIdSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => protectedWorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSettingsMembersRoute =
  protectedWorkspacesWorkspaceIdSettingsMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => protectedWorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSettingsMcpServerRoute =
  protectedWorkspacesWorkspaceIdSettingsMcpServerRouteImport.update({
    id: '/mcp-server',
    path: '/mcp-server',
    getParentRoute: () => protectedWorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSettingsIntegrationsRoute =
  protectedWorkspacesWorkspaceIdSettingsIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => protectedWorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSettingsImportsRoute =
  protectedWorkspacesWorkspaceIdSettingsImportsRouteImport.update({
    id: '/imports',
    path: '/imports',
    getParentRoute: () => protectedWorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSettingsGovernanceRoute =
  protectedWorkspacesWorkspaceIdSettingsGovernanceRouteImport.update({
    id: '/governance',
    path: '/governance',
    getParentRoute: () => protectedWorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSettingsGeneralRoute =
  protectedWorkspacesWorkspaceIdSettingsGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => protectedWorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSettingsExceptionsRoute =
  protectedWorkspacesWorkspaceIdSettingsExceptionsRouteImport.update({
    id: '/exceptions',
    path: '/exceptions',
    getParentRoute: () => protectedWorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSettingsEmailRoute =
  protectedWorkspacesWorkspaceIdSettingsEmailRouteImport.update({
    id: '/email',
    path: '/email',
    getParentRoute: () => protectedWorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSettingsDataExportRoute =
  protectedWorkspacesWorkspaceIdSettingsDataExportRouteImport.update({
    id: '/data-export',
    path: '/data-export',
    getParentRoute: () => protectedWorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSettingsConfigurationRoute =
  protectedWorkspacesWorkspaceIdSettingsConfigurationRouteImport.update({
    id: '/configuration',
    path: '/configuration',
    getParentRoute: () => protectedWorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSettingsComplianceRolesRoute =
  protectedWorkspacesWorkspaceIdSettingsComplianceRolesRouteImport.update({
    id: '/compliance-roles',
    path: '/compliance-roles',
    getParentRoute: () => protectedWorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSettingsChecksRoute =
  protectedWorkspacesWorkspaceIdSettingsChecksRouteImport.update({
    id: '/checks',
    path: '/checks',
    getParentRoute: () => protectedWorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSettingsChatRoute =
  protectedWorkspacesWorkspaceIdSettingsChatRouteImport.update({
    id: '/chat',
    path: '/chat',
    getParentRoute: () => protectedWorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSettingsBrowserExtensionRoute =
  protectedWorkspacesWorkspaceIdSettingsBrowserExtensionRouteImport.update({
    id: '/browser-extension',
    path: '/browser-extension',
    getParentRoute: () => protectedWorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSettingsBillingRoute =
  protectedWorkspacesWorkspaceIdSettingsBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => protectedWorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSettingsAuthRoute =
  protectedWorkspacesWorkspaceIdSettingsAuthRouteImport.update({
    id: '/auth',
    path: '/auth',
    getParentRoute: () => protectedWorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSettingsAuditLogsRoute =
  protectedWorkspacesWorkspaceIdSettingsAuditLogsRouteImport.update({
    id: '/audit-logs',
    path: '/audit-logs',
    getParentRoute: () => protectedWorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdSettingsApiKeysRoute =
  protectedWorkspacesWorkspaceIdSettingsApiKeysRouteImport.update({
    id: '/api-keys',
    path: '/api-keys',
    getParentRoute: () => protectedWorkspacesWorkspaceIdSettingsRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdRunsExecutionIdRoute =
  protectedWorkspacesWorkspaceIdRunsExecutionIdRouteImport.update({
    id: '/runs/$executionId',
    path: '/runs/$executionId',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdRunbooksNewRoute =
  protectedWorkspacesWorkspaceIdRunbooksNewRouteImport.update({
    id: '/runbooks_/new',
    path: '/runbooks/new',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdRunbooksRunbookIdRoute =
  protectedWorkspacesWorkspaceIdRunbooksRunbookIdRouteImport.update({
    id: '/runbooks_/$runbookId',
    path: '/runbooks/$runbookId',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdRisksRiskIdRoute =
  protectedWorkspacesWorkspaceIdRisksRiskIdRouteImport.update({
    id: '/risks_/$riskId',
    path: '/risks/$riskId',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdReviewsAccessRoute =
  protectedWorkspacesWorkspaceIdReviewsAccessRouteImport.update({
    id: '/reviews/access',
    path: '/reviews/access',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdQuestionnairesIdRoute =
  protectedWorkspacesWorkspaceIdQuestionnairesIdRouteImport.update({
    id: '/questionnaires_/$id',
    path: '/questionnaires/$id',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdPoliciesPolicySlugRoute =
  protectedWorkspacesWorkspaceIdPoliciesPolicySlugRouteImport.update({
    id: '/policies_/$policySlug',
    path: '/policies/$policySlug',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdPeople_trainingProgramIdRoute =
  protectedWorkspacesWorkspaceIdPeople_trainingProgramIdRouteImport.update({
    id: '/people_training/$programId',
    path: '/people_training/$programId',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdPeople_groupsGroupIdRoute =
  protectedWorkspacesWorkspaceIdPeople_groupsGroupIdRouteImport.update({
    id: '/people_groups/$groupId',
    path: '/people_groups/$groupId',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdPeopleEmployeeIdRoute =
  protectedWorkspacesWorkspaceIdPeopleEmployeeIdRouteImport.update({
    id: '/people_/$employeeId',
    path: '/people/$employeeId',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdPeopleMeRoute =
  protectedWorkspacesWorkspaceIdPeopleMeRouteImport.update({
    id: '/me',
    path: '/me',
    getParentRoute: () => protectedWorkspacesWorkspaceIdPeopleRoute,
  } as any)
const protectedWorkspacesWorkspaceIdIntegrationsProviderSlugRoute =
  protectedWorkspacesWorkspaceIdIntegrationsProviderSlugRouteImport.update({
    id: '/integrations_/$providerSlug',
    path: '/integrations/$providerSlug',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdEvidenceCreatingRoute =
  protectedWorkspacesWorkspaceIdEvidenceCreatingRouteImport.update({
    id: '/evidence_/creating',
    path: '/evidence/creating',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdEvidenceViewerEvidencePackIdRoute =
  protectedWorkspacesWorkspaceIdEvidenceViewerEvidencePackIdRouteImport.update({
    id: '/evidence-viewer/$evidencePackId',
    path: '/evidence-viewer/$evidencePackId',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdEmployeeCenterTrainingRoute =
  protectedWorkspacesWorkspaceIdEmployeeCenterTrainingRouteImport.update({
    id: '/training',
    path: '/training',
    getParentRoute: () =>
      protectedWorkspacesWorkspaceIdEmployeeCenterRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdEmployeeCenterTasksRoute =
  protectedWorkspacesWorkspaceIdEmployeeCenterTasksRouteImport.update({
    id: '/tasks',
    path: '/tasks',
    getParentRoute: () =>
      protectedWorkspacesWorkspaceIdEmployeeCenterRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdEmployeeCenterRequestsRoute =
  protectedWorkspacesWorkspaceIdEmployeeCenterRequestsRouteImport.update({
    id: '/requests',
    path: '/requests',
    getParentRoute: () =>
      protectedWorkspacesWorkspaceIdEmployeeCenterRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdEmployeeCenterPendingPoliciesRoute =
  protectedWorkspacesWorkspaceIdEmployeeCenterPendingPoliciesRouteImport.update(
    {
      id: '/pending-policies',
      path: '/pending-policies',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdEmployeeCenterRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdEmployeeCenterOrgChartRoute =
  protectedWorkspacesWorkspaceIdEmployeeCenterOrgChartRouteImport.update({
    id: '/org-chart',
    path: '/org-chart',
    getParentRoute: () =>
      protectedWorkspacesWorkspaceIdEmployeeCenterRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdEmployeeCenterInboxRoute =
  protectedWorkspacesWorkspaceIdEmployeeCenterInboxRouteImport.update({
    id: '/inbox',
    path: '/inbox',
    getParentRoute: () =>
      protectedWorkspacesWorkspaceIdEmployeeCenterRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdEmployeeCenterDevicesRoute =
  protectedWorkspacesWorkspaceIdEmployeeCenterDevicesRouteImport.update({
    id: '/devices',
    path: '/devices',
    getParentRoute: () =>
      protectedWorkspacesWorkspaceIdEmployeeCenterRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdEmployeeCenterAnonymousReportingRoute =
  protectedWorkspacesWorkspaceIdEmployeeCenterAnonymousReportingRouteImport.update(
    {
      id: '/anonymous-reporting',
      path: '/anonymous-reporting',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdEmployeeCenterRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdEmployeeCenterAcknowledgmentsRoute =
  protectedWorkspacesWorkspaceIdEmployeeCenterAcknowledgmentsRouteImport.update(
    {
      id: '/acknowledgments',
      path: '/acknowledgments',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdEmployeeCenterRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdDocumentsDocIdRoute =
  protectedWorkspacesWorkspaceIdDocumentsDocIdRouteImport.update({
    id: '/documents_/$docId',
    path: '/documents/$docId',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdDevicesDeviceIdRoute =
  protectedWorkspacesWorkspaceIdDevicesDeviceIdRouteImport.update({
    id: '/devices_/$deviceId',
    path: '/devices/$deviceId',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdDevToolUiRoute =
  protectedWorkspacesWorkspaceIdDevToolUiRouteImport.update({
    id: '/dev/tool-ui',
    path: '/dev/tool-ui',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdDeprecatedComplianceRouteOldRoute =
  protectedWorkspacesWorkspaceIdDeprecatedComplianceRouteOldRouteImport.update({
    id: '/deprecated/compliance-route-old',
    path: '/deprecated/compliance-route-old',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdControlsControlDefIdRoute =
  protectedWorkspacesWorkspaceIdControlsControlDefIdRouteImport.update({
    id: '/controls_/$controlDefId',
    path: '/controls/$controlDefId',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdChatThreadIdRoute =
  protectedWorkspacesWorkspaceIdChatThreadIdRouteImport
    .update({
      id: '/chat_/$threadId',
      path: '/chat/$threadId',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/chat_.$threadId.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdAuditsAuditCycleIdRoute =
  protectedWorkspacesWorkspaceIdAuditsAuditCycleIdRouteImport.update({
    id: '/audits/$auditCycleId',
    path: '/audits/$auditCycleId',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdAuditorCenterApiAccessRoute =
  protectedWorkspacesWorkspaceIdAuditorCenterApiAccessRouteImport.update({
    id: '/api-access',
    path: '/api-access',
    getParentRoute: () => protectedWorkspacesWorkspaceIdAuditorCenterRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdAssetsAssetIdRoute =
  protectedWorkspacesWorkspaceIdAssetsAssetIdRouteImport.update({
    id: '/assets_/$assetId',
    path: '/assets/$assetId',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdAnonymousReportsReportIdRoute =
  protectedWorkspacesWorkspaceIdAnonymousReportsReportIdRouteImport.update({
    id: '/anonymous-reports_/$reportId',
    path: '/anonymous-reports/$reportId',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute =
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRouteImport.update(
    {
      id: '/$auditCycleId',
      path: '/$auditCycleId',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdAuditorCenterRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdDeprecatedIntegrationsOldIndexLazyRoute =
  protectedWorkspacesWorkspaceIdDeprecatedIntegrationsOldIndexLazyRouteImport
    .update({
      id: '/deprecated/integrations-old/',
      path: '/deprecated/integrations-old/',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any)
    .lazy(() =>
      import('./routes/(protected)/workspaces/$workspaceId/deprecated/integrations-old/index.lazy').then(
        (d) => d.Route,
      ),
    )
const protectedWorkspacesWorkspaceIdTestsTestIdIndexRoute =
  protectedWorkspacesWorkspaceIdTestsTestIdIndexRouteImport.update({
    id: '/tests_/$testId/',
    path: '/tests/$testId/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdTemplatesTemplateIdIndexRoute =
  protectedWorkspacesWorkspaceIdTemplatesTemplateIdIndexRouteImport.update({
    id: '/templates/$templateId/',
    path: '/templates/$templateId/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdFrameworksFrameworkIdIndexRoute =
  protectedWorkspacesWorkspaceIdFrameworksFrameworkIdIndexRouteImport.update({
    id: '/frameworks/$frameworkId/',
    path: '/frameworks/$frameworkId/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdDeprecatedSourcesIndexRoute =
  protectedWorkspacesWorkspaceIdDeprecatedSourcesIndexRouteImport.update({
    id: '/deprecated/sources/',
    path: '/deprecated/sources/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdAutomationExecutionIdIndexRoute =
  protectedWorkspacesWorkspaceIdAutomationExecutionIdIndexRouteImport.update({
    id: '/automation/$executionId/',
    path: '/automation/$executionId/',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIndexRoute =
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdTestsTestIdSubmissionsRoute =
  protectedWorkspacesWorkspaceIdTestsTestIdSubmissionsRouteImport.update({
    id: '/tests_/$testId/submissions',
    path: '/tests/$testId/submissions',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdTemplatesTemplateIdEditRoute =
  protectedWorkspacesWorkspaceIdTemplatesTemplateIdEditRouteImport.update({
    id: '/templates/$templateId/edit',
    path: '/templates/$templateId/edit',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdRisksAssessmentsDraftIdRoute =
  protectedWorkspacesWorkspaceIdRisksAssessmentsDraftIdRouteImport.update({
    id: '/risks_/assessments/$draftId',
    path: '/risks/assessments/$draftId',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdReviewsAccessRolesRoute =
  protectedWorkspacesWorkspaceIdReviewsAccessRolesRouteImport.update({
    id: '/reviews/access_/roles',
    path: '/reviews/access/roles',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdReviewsAccessCycleIdRoute =
  protectedWorkspacesWorkspaceIdReviewsAccessCycleIdRouteImport.update({
    id: '/reviews/access_/$cycleId',
    path: '/reviews/access/$cycleId',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdRecordingsFlowIdEditRoute =
  protectedWorkspacesWorkspaceIdRecordingsFlowIdEditRouteImport.update({
    id: '/recordings_/$flowId/edit',
    path: '/recordings/$flowId/edit',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdIntegrationsCustomApplicationIdRoute =
  protectedWorkspacesWorkspaceIdIntegrationsCustomApplicationIdRouteImport.update(
    {
      id: '/integrations_/custom/$applicationId',
      path: '/integrations/custom/$applicationId',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdEmployeeCenterTrainingProgramIdRoute =
  protectedWorkspacesWorkspaceIdEmployeeCenterTrainingProgramIdRouteImport.update(
    {
      id: '/training_/$programId',
      path: '/training/$programId',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdEmployeeCenterRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdEmployeeCenterTestsTestIdRoute =
  protectedWorkspacesWorkspaceIdEmployeeCenterTestsTestIdRouteImport.update({
    id: '/tests_/$testId',
    path: '/tests/$testId',
    getParentRoute: () =>
      protectedWorkspacesWorkspaceIdEmployeeCenterRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdEmployeeCenterTasksTaskIdRoute =
  protectedWorkspacesWorkspaceIdEmployeeCenterTasksTaskIdRouteImport.update({
    id: '/tasks_/$taskId',
    path: '/tasks/$taskId',
    getParentRoute: () =>
      protectedWorkspacesWorkspaceIdEmployeeCenterRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdEmployeeCenterRequestsTaskIdRoute =
  protectedWorkspacesWorkspaceIdEmployeeCenterRequestsTaskIdRouteImport.update({
    id: '/requests_/$taskId',
    path: '/requests/$taskId',
    getParentRoute: () =>
      protectedWorkspacesWorkspaceIdEmployeeCenterRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdEmployeeCenterPendingPoliciesTemplateIdRoute =
  protectedWorkspacesWorkspaceIdEmployeeCenterPendingPoliciesTemplateIdRouteImport.update(
    {
      id: '/pending-policies_/$templateId',
      path: '/pending-policies/$templateId',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdEmployeeCenterRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdVendorsRoute =
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdVendorsRouteImport.update(
    {
      id: '/vendors',
      path: '/vendors',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdTimelineRoute =
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdTimelineRouteImport.update(
    {
      id: '/timeline',
      path: '/timeline',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRisksRoute =
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRisksRouteImport.update(
    {
      id: '/risks',
      path: '/risks',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRequestListRoute =
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRequestListRouteImport.update(
    {
      id: '/request-list',
      path: '/request-list',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPopulationsRoute =
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPopulationsRouteImport.update(
    {
      id: '/populations',
      path: '/populations',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPeopleRoute =
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPeopleRouteImport.update(
    {
      id: '/people',
      path: '/people',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdOpenRequestsRoute =
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdOpenRequestsRouteImport.update(
    {
      id: '/open-requests',
      path: '/open-requests',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsRoute =
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsRouteImport.update(
    {
      id: '/integrations',
      path: '/integrations',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdEvidenceRoute =
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdEvidenceRouteImport.update(
    {
      id: '/evidence',
      path: '/evidence',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdDashboardRoute =
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdDashboardRouteImport.update(
    {
      id: '/dashboard',
      path: '/dashboard',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdControlsRoute =
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdControlsRouteImport.update(
    {
      id: '/controls',
      path: '/controls',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAssetsRoute =
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAssetsRouteImport.update(
    {
      id: '/assets',
      path: '/assets',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdApiAccessRoute =
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdApiAccessRouteImport.update(
    {
      id: '/api-access',
      path: '/api-access',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesRouteRoute =
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesRouteRouteImport.update(
    {
      id: '/$auditCycleId_/policies',
      path: '/$auditCycleId/policies',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdAuditorCenterRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceRouteRoute =
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceRouteRouteImport.update(
    {
      id: '/audit-evidence',
      path: '/audit-evidence',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdTemplatesControlControlIdIndexRoute =
  protectedWorkspacesWorkspaceIdTemplatesControlControlIdIndexRouteImport.update(
    {
      id: '/templates/control/$controlId/',
      path: '/templates/control/$controlId/',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdFrameworksFrameworkIdControlsIndexRoute =
  protectedWorkspacesWorkspaceIdFrameworksFrameworkIdControlsIndexRouteImport.update(
    {
      id: '/frameworks/$frameworkId/controls/',
      path: '/frameworks/$frameworkId/controls/',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesIndexRoute =
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceIndexRoute =
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdVendorsVendorIdAssessmentsAssessmentIdRoute =
  protectedWorkspacesWorkspaceIdVendorsVendorIdAssessmentsAssessmentIdRouteImport.update(
    {
      id: '/vendors_/$vendorId_/assessments/$assessmentId',
      path: '/vendors/$vendorId/assessments/$assessmentId',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdReviewsAccessPeriodPeriodKeyRoute =
  protectedWorkspacesWorkspaceIdReviewsAccessPeriodPeriodKeyRouteImport.update({
    id: '/reviews/access_/period/$periodKey',
    path: '/reviews/access/period/$periodKey',
    getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
  } as any)
const protectedWorkspacesWorkspaceIdIntegrationsProviderSlugServicesServiceIdRoute =
  protectedWorkspacesWorkspaceIdIntegrationsProviderSlugServicesServiceIdRouteImport.update(
    {
      id: '/integrations_/$providerSlug_/services/$serviceId',
      path: '/integrations/$providerSlug/services/$serviceId',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdIntegrationsProviderSlugAccountsConnectionIdRoute =
  protectedWorkspacesWorkspaceIdIntegrationsProviderSlugAccountsConnectionIdRouteImport.update(
    {
      id: '/integrations_/$providerSlug_/accounts/$connectionId',
      path: '/integrations/$providerSlug/accounts/$connectionId',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesPolicySlugRoute =
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesPolicySlugRouteImport.update(
    {
      id: '/$policySlug',
      path: '/$policySlug',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdVendorsVendorIdRoute =
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdVendorsVendorIdRouteImport.update(
    {
      id: '/vendors_/$vendorId',
      path: '/vendors/$vendorId',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRisksRiskIdRoute =
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRisksRiskIdRouteImport.update(
    {
      id: '/risks_/$riskId',
      path: '/risks/$riskId',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPopulationsPopulationIdRoute =
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPopulationsPopulationIdRouteImport.update(
    {
      id: '/populations_/$populationId',
      path: '/populations/$populationId',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPeopleEmployeeIdRoute =
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPeopleEmployeeIdRouteImport.update(
    {
      id: '/people_/$employeeId',
      path: '/people/$employeeId',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsProviderSlugRoute =
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsProviderSlugRouteImport.update(
    {
      id: '/integrations_/$providerSlug',
      path: '/integrations/$providerSlug',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAssetsAssetIdRoute =
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAssetsAssetIdRouteImport.update(
    {
      id: '/assets_/$assetId',
      path: '/assets/$assetId',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdIntegrationsCustomApplicationIdDatasetsDatasetIdRoute =
  protectedWorkspacesWorkspaceIdIntegrationsCustomApplicationIdDatasetsDatasetIdRouteImport.update(
    {
      id: '/integrations_/custom/$applicationId_/datasets/$datasetId',
      path: '/integrations/custom/$applicationId/datasets/$datasetId',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdDeprecatedWorkflowsWorkflowIdExecutionsJobIdRoute =
  protectedWorkspacesWorkspaceIdDeprecatedWorkflowsWorkflowIdExecutionsJobIdRouteImport.update(
    {
      id: '/deprecated/workflows/$workflowId/executions/$jobId',
      path: '/deprecated/workflows/$workflowId/executions/$jobId',
      getParentRoute: () => protectedWorkspacesWorkspaceIdRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceEvidenceKindEvidenceItemIdRoute =
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceEvidenceKindEvidenceItemIdRouteImport.update(
    {
      id: '/$evidenceKind/$evidenceItemId',
      path: '/$evidenceKind/$evidenceItemId',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdVendorsVendorIdReviewsAssessmentIdRoute =
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdVendorsVendorIdReviewsAssessmentIdRouteImport.update(
    {
      id: '/vendors_/$vendorId_/reviews/$assessmentId',
      path: '/vendors/$vendorId/reviews/$assessmentId',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPopulationsPopulationIdRoundsSampleIdRoute =
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPopulationsPopulationIdRoundsSampleIdRouteImport.update(
    {
      id: '/populations_/$populationId_/rounds/$sampleId',
      path: '/populations/$populationId/rounds/$sampleId',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsProviderSlugServicesServiceIdRoute =
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsProviderSlugServicesServiceIdRouteImport.update(
    {
      id: '/integrations_/$providerSlug_/services/$serviceId',
      path: '/integrations/$providerSlug/services/$serviceId',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute,
    } as any,
  )
const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsProviderSlugAccountsConnectionIdRoute =
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsProviderSlugAccountsConnectionIdRouteImport.update(
    {
      id: '/integrations_/$providerSlug_/accounts/$connectionId',
      path: '/integrations/$providerSlug/accounts/$connectionId',
      getParentRoute: () =>
        protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/extension-uninstalled': typeof ExtensionUninstalledLazyRoute
  '/onboarding': typeof authOnboardingRouteRouteWithChildren
  '/orgs': typeof protectedOrgsRouteRouteWithChildren
  '/partner': typeof protectedPartnerRouteRouteWithChildren
  '/workspaces': typeof protectedWorkspacesRouteRouteWithChildren
  '/accept-invitation': typeof authAcceptInvitationRoute
  '/invite': typeof authInviteRoute
  '/login': typeof authLoginRoute
  '/logout': typeof authLogoutRoute
  '/otp': typeof authOtpRoute
  '/reset-password': typeof authResetPasswordRoute
  '/share-invite': typeof authShareInviteRoute
  '/verify-email': typeof authVerifyEmailRoute
  '/auditor-center': typeof protectedAuditorCenterRouteWithChildren
  '/integrations/github-app-callback': typeof IntegrationsGithubAppCallbackRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/trust/$slug': typeof TrustSlugRoute
  '/forgot-password': typeof authForgotPasswordLazyRoute
  '/login-2': typeof authLogin2LazyRoute
  '/setup-mfa': typeof authSetupMfaLazyRoute
  '/signup': typeof authSignupLazyRoute
  '/verify-2fa': typeof authVerify2faLazyRoute
  '/verify-otp': typeof authVerifyOtpLazyRoute
  '/401': typeof errors401LazyRoute
  '/403': typeof errors403LazyRoute
  '/404': typeof errors404LazyRoute
  '/500': typeof errors500LazyRoute
  '/503': typeof errors503LazyRoute
  '/shared/$shareId': typeof SharedShareIdLazyRoute
  '/': typeof protectedIndexRoute
  '/orgs/$slug': typeof protectedOrgsSlugRouteRoute
  '/workspaces/$workspaceId': typeof protectedWorkspacesWorkspaceIdRouteRouteWithChildren
  '/auth-callback/$provider': typeof authAuthCallbackProviderRoute
  '/native/auth-callback': typeof authNativeAuthCallbackRoute
  '/native/login': typeof authNativeLoginRoute
  '/onboarding/extension': typeof authOnboardingExtensionRoute
  '/onboarding/preferences': typeof authOnboardingPreferencesRoute
  '/onboarding/quick-setup': typeof authOnboardingQuickSetupRoute
  '/onboarding/team': typeof authOnboardingTeamRoute
  '/auditor-center/profile': typeof protectedAuditorCenterProfileRoute
  '/auditor-center/security': typeof protectedAuditorCenterSecurityRoute
  '/dev/plan-restrictions-test': typeof protectedDevPlanRestrictionsTestRoute
  '/partner/templates': typeof protectedPartnerTemplatesRoute
  '/workspaces/new': typeof protectedWorkspacesNewRoute
  '/demo/tiptap/ai-changes': typeof DemoTiptapAiChangesRoute
  '/demo/tiptap/ai-suggestion': typeof DemoTiptapAiSuggestionRoute
  '/trust/access/$token': typeof TrustAccessTokenRoute
  '/trust/nda/$token': typeof TrustNdaTokenRoute
  '/trust/resources/$resourceId': typeof TrustResourcesResourceIdRoute
  '/auditor-center/': typeof protectedAuditorCenterIndexRoute
  '/partner/': typeof protectedPartnerIndexRoute
  '/demo/tiptap/': typeof DemoTiptapIndexRoute
  '/evidence/verify/': typeof EvidenceVerifyIndexRoute
  '/export/evidence-pdf/': typeof ExportEvidencePdfIndexRoute
  '/export/org-chart/': typeof ExportOrgChartIndexRoute
  '/export/policy-pdf/': typeof ExportPolicyPdfIndexRoute
  '/export/topic-embed/': typeof ExportTopicEmbedIndexRoute
  '/export/topic-pdf/': typeof ExportTopicPdfIndexRoute
  '/onboarding/': typeof protectedOnboardingIndexLazyRoute
  '/orgs/': typeof protectedOrgsIndexLazyRoute
  '/workspaces/': typeof protectedWorkspacesIndexLazyRoute
  '/workspaces/$workspaceId/auditor-center': typeof protectedWorkspacesWorkspaceIdAuditorCenterRouteRouteWithChildren
  '/workspaces/$workspaceId/employee-center': typeof protectedWorkspacesWorkspaceIdEmployeeCenterRouteRouteWithChildren
  '/workspaces/$workspaceId/settings': typeof protectedWorkspacesWorkspaceIdSettingsRouteRouteWithChildren
  '/partner/clients/$clientId': typeof protectedPartnerClientsClientIdRoute
  '/partner/clients/new': typeof protectedPartnerClientsNewRoute
  '/workspace/integrations/github': typeof protectedWorkspaceIntegrationsGithubRoute
  '/workspaces/$workspaceId/anonymous-reports': typeof protectedWorkspacesWorkspaceIdAnonymousReportsRoute
  '/workspaces/$workspaceId/approvals': typeof protectedWorkspacesWorkspaceIdApprovalsRoute
  '/workspaces/$workspaceId/assets': typeof protectedWorkspacesWorkspaceIdAssetsRoute
  '/workspaces/$workspaceId/connect-repo': typeof protectedWorkspacesWorkspaceIdConnectRepoRoute
  '/workspaces/$workspaceId/connect-tools': typeof protectedWorkspacesWorkspaceIdConnectToolsRoute
  '/workspaces/$workspaceId/controls': typeof protectedWorkspacesWorkspaceIdControlsRoute
  '/workspaces/$workspaceId/dashboard': typeof protectedWorkspacesWorkspaceIdDashboardRoute
  '/workspaces/$workspaceId/documents': typeof protectedWorkspacesWorkspaceIdDocumentsRoute
  '/workspaces/$workspaceId/evidence': typeof protectedWorkspacesWorkspaceIdEvidenceRoute
  '/workspaces/$workspaceId/evidence-slots': typeof protectedWorkspacesWorkspaceIdEvidenceSlotsRoute
  '/workspaces/$workspaceId/guide': typeof protectedWorkspacesWorkspaceIdGuideRoute
  '/workspaces/$workspaceId/inbox': typeof protectedWorkspacesWorkspaceIdInboxRoute
  '/workspaces/$workspaceId/integrations': typeof protectedWorkspacesWorkspaceIdIntegrationsRoute
  '/workspaces/$workspaceId/monitoring': typeof protectedWorkspacesWorkspaceIdMonitoringRoute
  '/workspaces/$workspaceId/onboarding': typeof protectedWorkspacesWorkspaceIdOnboardingRoute
  '/workspaces/$workspaceId/people': typeof protectedWorkspacesWorkspaceIdPeopleRouteWithChildren
  '/workspaces/$workspaceId/policies': typeof protectedWorkspacesWorkspaceIdPoliciesRoute
  '/workspaces/$workspaceId/questionnaires': typeof protectedWorkspacesWorkspaceIdQuestionnairesRoute
  '/workspaces/$workspaceId/readiness': typeof protectedWorkspacesWorkspaceIdReadinessRoute
  '/workspaces/$workspaceId/risks': typeof protectedWorkspacesWorkspaceIdRisksRoute
  '/workspaces/$workspaceId/runbooks': typeof protectedWorkspacesWorkspaceIdRunbooksRoute
  '/workspaces/$workspaceId/setup': typeof protectedWorkspacesWorkspaceIdSetupRoute
  '/workspaces/$workspaceId/statement-of-applicability': typeof protectedWorkspacesWorkspaceIdStatementOfApplicabilityRoute
  '/workspaces/$workspaceId/system-description': typeof protectedWorkspacesWorkspaceIdSystemDescriptionRoute
  '/workspaces/$workspaceId/tasks': typeof protectedWorkspacesWorkspaceIdTasksRoute
  '/workspaces/$workspaceId/tests': typeof protectedWorkspacesWorkspaceIdTestsRoute
  '/workspaces/$workspaceId/trust-center': typeof protectedWorkspacesWorkspaceIdTrustCenterRoute
  '/workspaces/$workspaceId/vendors': typeof protectedWorkspacesWorkspaceIdVendorsRoute
  '/onboarding/$organizationId/workspace': typeof protectedOnboardingOrganizationIdWorkspaceLazyRoute
  '/workspace/integrations/': typeof protectedWorkspaceIntegrationsIndexRoute
  '/workspaces/$workspaceId/': typeof protectedWorkspacesWorkspaceIdIndexRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRouteWithChildren
  '/workspaces/$workspaceId/anonymous-reports/$reportId': typeof protectedWorkspacesWorkspaceIdAnonymousReportsReportIdRoute
  '/workspaces/$workspaceId/assets/$assetId': typeof protectedWorkspacesWorkspaceIdAssetsAssetIdRoute
  '/workspaces/$workspaceId/auditor-center/api-access': typeof protectedWorkspacesWorkspaceIdAuditorCenterApiAccessRoute
  '/workspaces/$workspaceId/audits/$auditCycleId': typeof protectedWorkspacesWorkspaceIdAuditsAuditCycleIdRoute
  '/workspaces/$workspaceId/chat/$threadId': typeof protectedWorkspacesWorkspaceIdChatThreadIdRoute
  '/workspaces/$workspaceId/controls/$controlDefId': typeof protectedWorkspacesWorkspaceIdControlsControlDefIdRoute
  '/workspaces/$workspaceId/deprecated/compliance-route-old': typeof protectedWorkspacesWorkspaceIdDeprecatedComplianceRouteOldRoute
  '/workspaces/$workspaceId/dev/tool-ui': typeof protectedWorkspacesWorkspaceIdDevToolUiRoute
  '/workspaces/$workspaceId/devices/$deviceId': typeof protectedWorkspacesWorkspaceIdDevicesDeviceIdRoute
  '/workspaces/$workspaceId/documents/$docId': typeof protectedWorkspacesWorkspaceIdDocumentsDocIdRoute
  '/workspaces/$workspaceId/employee-center/acknowledgments': typeof protectedWorkspacesWorkspaceIdEmployeeCenterAcknowledgmentsRoute
  '/workspaces/$workspaceId/employee-center/anonymous-reporting': typeof protectedWorkspacesWorkspaceIdEmployeeCenterAnonymousReportingRoute
  '/workspaces/$workspaceId/employee-center/devices': typeof protectedWorkspacesWorkspaceIdEmployeeCenterDevicesRoute
  '/workspaces/$workspaceId/employee-center/inbox': typeof protectedWorkspacesWorkspaceIdEmployeeCenterInboxRoute
  '/workspaces/$workspaceId/employee-center/org-chart': typeof protectedWorkspacesWorkspaceIdEmployeeCenterOrgChartRoute
  '/workspaces/$workspaceId/employee-center/pending-policies': typeof protectedWorkspacesWorkspaceIdEmployeeCenterPendingPoliciesRoute
  '/workspaces/$workspaceId/employee-center/requests': typeof protectedWorkspacesWorkspaceIdEmployeeCenterRequestsRoute
  '/workspaces/$workspaceId/employee-center/tasks': typeof protectedWorkspacesWorkspaceIdEmployeeCenterTasksRoute
  '/workspaces/$workspaceId/employee-center/training': typeof protectedWorkspacesWorkspaceIdEmployeeCenterTrainingRoute
  '/workspaces/$workspaceId/evidence-viewer/$evidencePackId': typeof protectedWorkspacesWorkspaceIdEvidenceViewerEvidencePackIdRoute
  '/workspaces/$workspaceId/evidence/creating': typeof protectedWorkspacesWorkspaceIdEvidenceCreatingRoute
  '/workspaces/$workspaceId/integrations/$providerSlug': typeof protectedWorkspacesWorkspaceIdIntegrationsProviderSlugRoute
  '/workspaces/$workspaceId/people/me': typeof protectedWorkspacesWorkspaceIdPeopleMeRoute
  '/workspaces/$workspaceId/people/$employeeId': typeof protectedWorkspacesWorkspaceIdPeopleEmployeeIdRoute
  '/workspaces/$workspaceId/people_groups/$groupId': typeof protectedWorkspacesWorkspaceIdPeople_groupsGroupIdRoute
  '/workspaces/$workspaceId/people_training/$programId': typeof protectedWorkspacesWorkspaceIdPeople_trainingProgramIdRoute
  '/workspaces/$workspaceId/policies/$policySlug': typeof protectedWorkspacesWorkspaceIdPoliciesPolicySlugRoute
  '/workspaces/$workspaceId/questionnaires/$id': typeof protectedWorkspacesWorkspaceIdQuestionnairesIdRoute
  '/workspaces/$workspaceId/reviews/access': typeof protectedWorkspacesWorkspaceIdReviewsAccessRoute
  '/workspaces/$workspaceId/risks/$riskId': typeof protectedWorkspacesWorkspaceIdRisksRiskIdRoute
  '/workspaces/$workspaceId/runbooks/$runbookId': typeof protectedWorkspacesWorkspaceIdRunbooksRunbookIdRoute
  '/workspaces/$workspaceId/runbooks/new': typeof protectedWorkspacesWorkspaceIdRunbooksNewRoute
  '/workspaces/$workspaceId/runs/$executionId': typeof protectedWorkspacesWorkspaceIdRunsExecutionIdRoute
  '/workspaces/$workspaceId/settings/api-keys': typeof protectedWorkspacesWorkspaceIdSettingsApiKeysRoute
  '/workspaces/$workspaceId/settings/audit-logs': typeof protectedWorkspacesWorkspaceIdSettingsAuditLogsRoute
  '/workspaces/$workspaceId/settings/auth': typeof protectedWorkspacesWorkspaceIdSettingsAuthRoute
  '/workspaces/$workspaceId/settings/billing': typeof protectedWorkspacesWorkspaceIdSettingsBillingRoute
  '/workspaces/$workspaceId/settings/browser-extension': typeof protectedWorkspacesWorkspaceIdSettingsBrowserExtensionRoute
  '/workspaces/$workspaceId/settings/chat': typeof protectedWorkspacesWorkspaceIdSettingsChatRoute
  '/workspaces/$workspaceId/settings/checks': typeof protectedWorkspacesWorkspaceIdSettingsChecksRoute
  '/workspaces/$workspaceId/settings/compliance-roles': typeof protectedWorkspacesWorkspaceIdSettingsComplianceRolesRoute
  '/workspaces/$workspaceId/settings/configuration': typeof protectedWorkspacesWorkspaceIdSettingsConfigurationRoute
  '/workspaces/$workspaceId/settings/data-export': typeof protectedWorkspacesWorkspaceIdSettingsDataExportRoute
  '/workspaces/$workspaceId/settings/email': typeof protectedWorkspacesWorkspaceIdSettingsEmailRoute
  '/workspaces/$workspaceId/settings/exceptions': typeof protectedWorkspacesWorkspaceIdSettingsExceptionsRoute
  '/workspaces/$workspaceId/settings/general': typeof protectedWorkspacesWorkspaceIdSettingsGeneralRoute
  '/workspaces/$workspaceId/settings/governance': typeof protectedWorkspacesWorkspaceIdSettingsGovernanceRoute
  '/workspaces/$workspaceId/settings/imports': typeof protectedWorkspacesWorkspaceIdSettingsImportsRoute
  '/workspaces/$workspaceId/settings/integrations': typeof protectedWorkspacesWorkspaceIdSettingsIntegrationsRoute
  '/workspaces/$workspaceId/settings/mcp-server': typeof protectedWorkspacesWorkspaceIdSettingsMcpServerRoute
  '/workspaces/$workspaceId/settings/members': typeof protectedWorkspacesWorkspaceIdSettingsMembersRoute
  '/workspaces/$workspaceId/settings/notifications': typeof protectedWorkspacesWorkspaceIdSettingsNotificationsRoute
  '/workspaces/$workspaceId/settings/personal-tokens': typeof protectedWorkspacesWorkspaceIdSettingsPersonalTokensRoute
  '/workspaces/$workspaceId/settings/personas': typeof protectedWorkspacesWorkspaceIdSettingsPersonasRoute
  '/workspaces/$workspaceId/settings/procedure-triggers': typeof protectedWorkspacesWorkspaceIdSettingsProcedureTriggersRoute
  '/workspaces/$workspaceId/settings/profile': typeof protectedWorkspacesWorkspaceIdSettingsProfileRoute
  '/workspaces/$workspaceId/settings/program': typeof protectedWorkspacesWorkspaceIdSettingsProgramRoute
  '/workspaces/$workspaceId/settings/properties': typeof protectedWorkspacesWorkspaceIdSettingsPropertiesRoute
  '/workspaces/$workspaceId/settings/request-intake': typeof protectedWorkspacesWorkspaceIdSettingsRequestIntakeRoute
  '/workspaces/$workspaceId/settings/review': typeof protectedWorkspacesWorkspaceIdSettingsReviewRoute
  '/workspaces/$workspaceId/settings/security': typeof protectedWorkspacesWorkspaceIdSettingsSecurityRoute
  '/workspaces/$workspaceId/settings/signing': typeof protectedWorkspacesWorkspaceIdSettingsSigningRoute
  '/workspaces/$workspaceId/settings/templates': typeof protectedWorkspacesWorkspaceIdSettingsTemplatesRoute
  '/workspaces/$workspaceId/settings/theme': typeof protectedWorkspacesWorkspaceIdSettingsThemeRoute
  '/workspaces/$workspaceId/settings/writing': typeof protectedWorkspacesWorkspaceIdSettingsWritingRoute
  '/workspaces/$workspaceId/submissions/$submissionId': typeof protectedWorkspacesWorkspaceIdSubmissionsSubmissionIdRoute
  '/workspaces/$workspaceId/tasks/$taskId': typeof protectedWorkspacesWorkspaceIdTasksTaskIdRoute
  '/workspaces/$workspaceId/tasks/detail': typeof protectedWorkspacesWorkspaceIdTasksDetailRoute
  '/workspaces/$workspaceId/templates/new': typeof protectedWorkspacesWorkspaceIdTemplatesNewRoute
  '/workspaces/$workspaceId/templates/public': typeof protectedWorkspacesWorkspaceIdTemplatesPublicRoute
  '/workspaces/$workspaceId/vendors/$vendorId': typeof protectedWorkspacesWorkspaceIdVendorsVendorIdRoute
  '/workspaces/$workspaceId/automation/identities': typeof protectedWorkspacesWorkspaceIdAutomationIdentitiesLazyRoute
  '/workspaces/$workspaceId/deprecated/agent-reliability': typeof protectedWorkspacesWorkspaceIdDeprecatedAgentReliabilityLazyRoute
  '/workspaces/$workspaceId/auditor-center/': typeof protectedWorkspacesWorkspaceIdAuditorCenterIndexRoute
  '/workspaces/$workspaceId/audits/': typeof protectedWorkspacesWorkspaceIdAuditsIndexRoute
  '/workspaces/$workspaceId/employee-center/': typeof protectedWorkspacesWorkspaceIdEmployeeCenterIndexRoute
  '/workspaces/$workspaceId/frameworks/': typeof protectedWorkspacesWorkspaceIdFrameworksIndexRoute
  '/workspaces/$workspaceId/populations/': typeof protectedWorkspacesWorkspaceIdPopulationsIndexRoute
  '/workspaces/$workspaceId/runs/': typeof protectedWorkspacesWorkspaceIdRunsIndexRoute
  '/workspaces/$workspaceId/settings/': typeof protectedWorkspacesWorkspaceIdSettingsIndexRoute
  '/workspaces/$workspaceId/templates/': typeof protectedWorkspacesWorkspaceIdTemplatesIndexRoute
  '/workspaces/$workspaceId/automation/': typeof protectedWorkspacesWorkspaceIdAutomationIndexLazyRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/audit-evidence': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceRouteRouteWithChildren
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/policies': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesRouteRouteWithChildren
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/api-access': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdApiAccessRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/assets': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAssetsRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/controls': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdControlsRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/dashboard': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdDashboardRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/evidence': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdEvidenceRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/open-requests': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdOpenRequestsRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/people': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPeopleRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/populations': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPopulationsRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/request-list': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRequestListRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/risks': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRisksRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/timeline': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdTimelineRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/vendors': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdVendorsRoute
  '/workspaces/$workspaceId/employee-center/pending-policies/$templateId': typeof protectedWorkspacesWorkspaceIdEmployeeCenterPendingPoliciesTemplateIdRoute
  '/workspaces/$workspaceId/employee-center/requests/$taskId': typeof protectedWorkspacesWorkspaceIdEmployeeCenterRequestsTaskIdRoute
  '/workspaces/$workspaceId/employee-center/tasks/$taskId': typeof protectedWorkspacesWorkspaceIdEmployeeCenterTasksTaskIdRoute
  '/workspaces/$workspaceId/employee-center/tests/$testId': typeof protectedWorkspacesWorkspaceIdEmployeeCenterTestsTestIdRoute
  '/workspaces/$workspaceId/employee-center/training/$programId': typeof protectedWorkspacesWorkspaceIdEmployeeCenterTrainingProgramIdRoute
  '/workspaces/$workspaceId/integrations/custom/$applicationId': typeof protectedWorkspacesWorkspaceIdIntegrationsCustomApplicationIdRoute
  '/workspaces/$workspaceId/recordings/$flowId/edit': typeof protectedWorkspacesWorkspaceIdRecordingsFlowIdEditRoute
  '/workspaces/$workspaceId/reviews/access/$cycleId': typeof protectedWorkspacesWorkspaceIdReviewsAccessCycleIdRoute
  '/workspaces/$workspaceId/reviews/access/roles': typeof protectedWorkspacesWorkspaceIdReviewsAccessRolesRoute
  '/workspaces/$workspaceId/risks/assessments/$draftId': typeof protectedWorkspacesWorkspaceIdRisksAssessmentsDraftIdRoute
  '/workspaces/$workspaceId/templates/$templateId/edit': typeof protectedWorkspacesWorkspaceIdTemplatesTemplateIdEditRoute
  '/workspaces/$workspaceId/tests/$testId/submissions': typeof protectedWorkspacesWorkspaceIdTestsTestIdSubmissionsRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIndexRoute
  '/workspaces/$workspaceId/automation/$executionId/': typeof protectedWorkspacesWorkspaceIdAutomationExecutionIdIndexRoute
  '/workspaces/$workspaceId/deprecated/sources/': typeof protectedWorkspacesWorkspaceIdDeprecatedSourcesIndexRoute
  '/workspaces/$workspaceId/frameworks/$frameworkId/': typeof protectedWorkspacesWorkspaceIdFrameworksFrameworkIdIndexRoute
  '/workspaces/$workspaceId/templates/$templateId/': typeof protectedWorkspacesWorkspaceIdTemplatesTemplateIdIndexRoute
  '/workspaces/$workspaceId/tests/$testId/': typeof protectedWorkspacesWorkspaceIdTestsTestIdIndexRoute
  '/workspaces/$workspaceId/deprecated/integrations-old/': typeof protectedWorkspacesWorkspaceIdDeprecatedIntegrationsOldIndexLazyRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/assets/$assetId': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAssetsAssetIdRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations/$providerSlug': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsProviderSlugRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/people/$employeeId': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPeopleEmployeeIdRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/populations/$populationId': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPopulationsPopulationIdRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/risks/$riskId': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRisksRiskIdRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/vendors/$vendorId': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdVendorsVendorIdRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/policies/$policySlug': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesPolicySlugRoute
  '/workspaces/$workspaceId/integrations/$providerSlug/accounts/$connectionId': typeof protectedWorkspacesWorkspaceIdIntegrationsProviderSlugAccountsConnectionIdRoute
  '/workspaces/$workspaceId/integrations/$providerSlug/services/$serviceId': typeof protectedWorkspacesWorkspaceIdIntegrationsProviderSlugServicesServiceIdRoute
  '/workspaces/$workspaceId/reviews/access/period/$periodKey': typeof protectedWorkspacesWorkspaceIdReviewsAccessPeriodPeriodKeyRoute
  '/workspaces/$workspaceId/vendors/$vendorId/assessments/$assessmentId': typeof protectedWorkspacesWorkspaceIdVendorsVendorIdAssessmentsAssessmentIdRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/audit-evidence/': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceIndexRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/policies/': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesIndexRoute
  '/workspaces/$workspaceId/frameworks/$frameworkId/controls/': typeof protectedWorkspacesWorkspaceIdFrameworksFrameworkIdControlsIndexRoute
  '/workspaces/$workspaceId/templates/control/$controlId/': typeof protectedWorkspacesWorkspaceIdTemplatesControlControlIdIndexRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/audit-evidence/$evidenceKind/$evidenceItemId': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceEvidenceKindEvidenceItemIdRoute
  '/workspaces/$workspaceId/deprecated/workflows/$workflowId/executions/$jobId': typeof protectedWorkspacesWorkspaceIdDeprecatedWorkflowsWorkflowIdExecutionsJobIdRoute
  '/workspaces/$workspaceId/integrations/custom/$applicationId/datasets/$datasetId': typeof protectedWorkspacesWorkspaceIdIntegrationsCustomApplicationIdDatasetsDatasetIdRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations/$providerSlug/accounts/$connectionId': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsProviderSlugAccountsConnectionIdRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations/$providerSlug/services/$serviceId': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsProviderSlugServicesServiceIdRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/populations/$populationId/rounds/$sampleId': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPopulationsPopulationIdRoundsSampleIdRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/vendors/$vendorId/reviews/$assessmentId': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdVendorsVendorIdReviewsAssessmentIdRoute
}
export interface FileRoutesByTo {
  '/extension-uninstalled': typeof ExtensionUninstalledLazyRoute
  '/onboarding': typeof protectedOnboardingIndexLazyRoute
  '/accept-invitation': typeof authAcceptInvitationRoute
  '/invite': typeof authInviteRoute
  '/login': typeof authLoginRoute
  '/logout': typeof authLogoutRoute
  '/otp': typeof authOtpRoute
  '/reset-password': typeof authResetPasswordRoute
  '/share-invite': typeof authShareInviteRoute
  '/verify-email': typeof authVerifyEmailRoute
  '/integrations/github-app-callback': typeof IntegrationsGithubAppCallbackRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/trust/$slug': typeof TrustSlugRoute
  '/forgot-password': typeof authForgotPasswordLazyRoute
  '/login-2': typeof authLogin2LazyRoute
  '/setup-mfa': typeof authSetupMfaLazyRoute
  '/signup': typeof authSignupLazyRoute
  '/verify-2fa': typeof authVerify2faLazyRoute
  '/verify-otp': typeof authVerifyOtpLazyRoute
  '/401': typeof errors401LazyRoute
  '/403': typeof errors403LazyRoute
  '/404': typeof errors404LazyRoute
  '/500': typeof errors500LazyRoute
  '/503': typeof errors503LazyRoute
  '/shared/$shareId': typeof SharedShareIdLazyRoute
  '/': typeof protectedIndexRoute
  '/orgs/$slug': typeof protectedOrgsSlugRouteRoute
  '/auth-callback/$provider': typeof authAuthCallbackProviderRoute
  '/native/auth-callback': typeof authNativeAuthCallbackRoute
  '/native/login': typeof authNativeLoginRoute
  '/onboarding/extension': typeof authOnboardingExtensionRoute
  '/onboarding/preferences': typeof authOnboardingPreferencesRoute
  '/onboarding/quick-setup': typeof authOnboardingQuickSetupRoute
  '/onboarding/team': typeof authOnboardingTeamRoute
  '/auditor-center/profile': typeof protectedAuditorCenterProfileRoute
  '/auditor-center/security': typeof protectedAuditorCenterSecurityRoute
  '/dev/plan-restrictions-test': typeof protectedDevPlanRestrictionsTestRoute
  '/partner/templates': typeof protectedPartnerTemplatesRoute
  '/workspaces/new': typeof protectedWorkspacesNewRoute
  '/demo/tiptap/ai-changes': typeof DemoTiptapAiChangesRoute
  '/demo/tiptap/ai-suggestion': typeof DemoTiptapAiSuggestionRoute
  '/trust/access/$token': typeof TrustAccessTokenRoute
  '/trust/nda/$token': typeof TrustNdaTokenRoute
  '/trust/resources/$resourceId': typeof TrustResourcesResourceIdRoute
  '/auditor-center': typeof protectedAuditorCenterIndexRoute
  '/partner': typeof protectedPartnerIndexRoute
  '/demo/tiptap': typeof DemoTiptapIndexRoute
  '/evidence/verify': typeof EvidenceVerifyIndexRoute
  '/export/evidence-pdf': typeof ExportEvidencePdfIndexRoute
  '/export/org-chart': typeof ExportOrgChartIndexRoute
  '/export/policy-pdf': typeof ExportPolicyPdfIndexRoute
  '/export/topic-embed': typeof ExportTopicEmbedIndexRoute
  '/export/topic-pdf': typeof ExportTopicPdfIndexRoute
  '/orgs': typeof protectedOrgsIndexLazyRoute
  '/workspaces': typeof protectedWorkspacesIndexLazyRoute
  '/partner/clients/$clientId': typeof protectedPartnerClientsClientIdRoute
  '/partner/clients/new': typeof protectedPartnerClientsNewRoute
  '/workspace/integrations/github': typeof protectedWorkspaceIntegrationsGithubRoute
  '/workspaces/$workspaceId/anonymous-reports': typeof protectedWorkspacesWorkspaceIdAnonymousReportsRoute
  '/workspaces/$workspaceId/approvals': typeof protectedWorkspacesWorkspaceIdApprovalsRoute
  '/workspaces/$workspaceId/assets': typeof protectedWorkspacesWorkspaceIdAssetsRoute
  '/workspaces/$workspaceId/connect-repo': typeof protectedWorkspacesWorkspaceIdConnectRepoRoute
  '/workspaces/$workspaceId/connect-tools': typeof protectedWorkspacesWorkspaceIdConnectToolsRoute
  '/workspaces/$workspaceId/controls': typeof protectedWorkspacesWorkspaceIdControlsRoute
  '/workspaces/$workspaceId/dashboard': typeof protectedWorkspacesWorkspaceIdDashboardRoute
  '/workspaces/$workspaceId/documents': typeof protectedWorkspacesWorkspaceIdDocumentsRoute
  '/workspaces/$workspaceId/evidence': typeof protectedWorkspacesWorkspaceIdEvidenceRoute
  '/workspaces/$workspaceId/evidence-slots': typeof protectedWorkspacesWorkspaceIdEvidenceSlotsRoute
  '/workspaces/$workspaceId/guide': typeof protectedWorkspacesWorkspaceIdGuideRoute
  '/workspaces/$workspaceId/inbox': typeof protectedWorkspacesWorkspaceIdInboxRoute
  '/workspaces/$workspaceId/integrations': typeof protectedWorkspacesWorkspaceIdIntegrationsRoute
  '/workspaces/$workspaceId/monitoring': typeof protectedWorkspacesWorkspaceIdMonitoringRoute
  '/workspaces/$workspaceId/onboarding': typeof protectedWorkspacesWorkspaceIdOnboardingRoute
  '/workspaces/$workspaceId/people': typeof protectedWorkspacesWorkspaceIdPeopleRouteWithChildren
  '/workspaces/$workspaceId/policies': typeof protectedWorkspacesWorkspaceIdPoliciesRoute
  '/workspaces/$workspaceId/questionnaires': typeof protectedWorkspacesWorkspaceIdQuestionnairesRoute
  '/workspaces/$workspaceId/readiness': typeof protectedWorkspacesWorkspaceIdReadinessRoute
  '/workspaces/$workspaceId/risks': typeof protectedWorkspacesWorkspaceIdRisksRoute
  '/workspaces/$workspaceId/runbooks': typeof protectedWorkspacesWorkspaceIdRunbooksRoute
  '/workspaces/$workspaceId/setup': typeof protectedWorkspacesWorkspaceIdSetupRoute
  '/workspaces/$workspaceId/statement-of-applicability': typeof protectedWorkspacesWorkspaceIdStatementOfApplicabilityRoute
  '/workspaces/$workspaceId/system-description': typeof protectedWorkspacesWorkspaceIdSystemDescriptionRoute
  '/workspaces/$workspaceId/tasks': typeof protectedWorkspacesWorkspaceIdTasksRoute
  '/workspaces/$workspaceId/tests': typeof protectedWorkspacesWorkspaceIdTestsRoute
  '/workspaces/$workspaceId/trust-center': typeof protectedWorkspacesWorkspaceIdTrustCenterRoute
  '/workspaces/$workspaceId/vendors': typeof protectedWorkspacesWorkspaceIdVendorsRoute
  '/onboarding/$organizationId/workspace': typeof protectedOnboardingOrganizationIdWorkspaceLazyRoute
  '/workspace/integrations': typeof protectedWorkspaceIntegrationsIndexRoute
  '/workspaces/$workspaceId': typeof protectedWorkspacesWorkspaceIdIndexRoute
  '/workspaces/$workspaceId/anonymous-reports/$reportId': typeof protectedWorkspacesWorkspaceIdAnonymousReportsReportIdRoute
  '/workspaces/$workspaceId/assets/$assetId': typeof protectedWorkspacesWorkspaceIdAssetsAssetIdRoute
  '/workspaces/$workspaceId/auditor-center/api-access': typeof protectedWorkspacesWorkspaceIdAuditorCenterApiAccessRoute
  '/workspaces/$workspaceId/audits/$auditCycleId': typeof protectedWorkspacesWorkspaceIdAuditsAuditCycleIdRoute
  '/workspaces/$workspaceId/chat/$threadId': typeof protectedWorkspacesWorkspaceIdChatThreadIdRoute
  '/workspaces/$workspaceId/controls/$controlDefId': typeof protectedWorkspacesWorkspaceIdControlsControlDefIdRoute
  '/workspaces/$workspaceId/deprecated/compliance-route-old': typeof protectedWorkspacesWorkspaceIdDeprecatedComplianceRouteOldRoute
  '/workspaces/$workspaceId/dev/tool-ui': typeof protectedWorkspacesWorkspaceIdDevToolUiRoute
  '/workspaces/$workspaceId/devices/$deviceId': typeof protectedWorkspacesWorkspaceIdDevicesDeviceIdRoute
  '/workspaces/$workspaceId/documents/$docId': typeof protectedWorkspacesWorkspaceIdDocumentsDocIdRoute
  '/workspaces/$workspaceId/employee-center/acknowledgments': typeof protectedWorkspacesWorkspaceIdEmployeeCenterAcknowledgmentsRoute
  '/workspaces/$workspaceId/employee-center/anonymous-reporting': typeof protectedWorkspacesWorkspaceIdEmployeeCenterAnonymousReportingRoute
  '/workspaces/$workspaceId/employee-center/devices': typeof protectedWorkspacesWorkspaceIdEmployeeCenterDevicesRoute
  '/workspaces/$workspaceId/employee-center/inbox': typeof protectedWorkspacesWorkspaceIdEmployeeCenterInboxRoute
  '/workspaces/$workspaceId/employee-center/org-chart': typeof protectedWorkspacesWorkspaceIdEmployeeCenterOrgChartRoute
  '/workspaces/$workspaceId/employee-center/pending-policies': typeof protectedWorkspacesWorkspaceIdEmployeeCenterPendingPoliciesRoute
  '/workspaces/$workspaceId/employee-center/requests': typeof protectedWorkspacesWorkspaceIdEmployeeCenterRequestsRoute
  '/workspaces/$workspaceId/employee-center/tasks': typeof protectedWorkspacesWorkspaceIdEmployeeCenterTasksRoute
  '/workspaces/$workspaceId/employee-center/training': typeof protectedWorkspacesWorkspaceIdEmployeeCenterTrainingRoute
  '/workspaces/$workspaceId/evidence-viewer/$evidencePackId': typeof protectedWorkspacesWorkspaceIdEvidenceViewerEvidencePackIdRoute
  '/workspaces/$workspaceId/evidence/creating': typeof protectedWorkspacesWorkspaceIdEvidenceCreatingRoute
  '/workspaces/$workspaceId/integrations/$providerSlug': typeof protectedWorkspacesWorkspaceIdIntegrationsProviderSlugRoute
  '/workspaces/$workspaceId/people/me': typeof protectedWorkspacesWorkspaceIdPeopleMeRoute
  '/workspaces/$workspaceId/people/$employeeId': typeof protectedWorkspacesWorkspaceIdPeopleEmployeeIdRoute
  '/workspaces/$workspaceId/people_groups/$groupId': typeof protectedWorkspacesWorkspaceIdPeople_groupsGroupIdRoute
  '/workspaces/$workspaceId/people_training/$programId': typeof protectedWorkspacesWorkspaceIdPeople_trainingProgramIdRoute
  '/workspaces/$workspaceId/policies/$policySlug': typeof protectedWorkspacesWorkspaceIdPoliciesPolicySlugRoute
  '/workspaces/$workspaceId/questionnaires/$id': typeof protectedWorkspacesWorkspaceIdQuestionnairesIdRoute
  '/workspaces/$workspaceId/reviews/access': typeof protectedWorkspacesWorkspaceIdReviewsAccessRoute
  '/workspaces/$workspaceId/risks/$riskId': typeof protectedWorkspacesWorkspaceIdRisksRiskIdRoute
  '/workspaces/$workspaceId/runbooks/$runbookId': typeof protectedWorkspacesWorkspaceIdRunbooksRunbookIdRoute
  '/workspaces/$workspaceId/runbooks/new': typeof protectedWorkspacesWorkspaceIdRunbooksNewRoute
  '/workspaces/$workspaceId/runs/$executionId': typeof protectedWorkspacesWorkspaceIdRunsExecutionIdRoute
  '/workspaces/$workspaceId/settings/api-keys': typeof protectedWorkspacesWorkspaceIdSettingsApiKeysRoute
  '/workspaces/$workspaceId/settings/audit-logs': typeof protectedWorkspacesWorkspaceIdSettingsAuditLogsRoute
  '/workspaces/$workspaceId/settings/auth': typeof protectedWorkspacesWorkspaceIdSettingsAuthRoute
  '/workspaces/$workspaceId/settings/billing': typeof protectedWorkspacesWorkspaceIdSettingsBillingRoute
  '/workspaces/$workspaceId/settings/browser-extension': typeof protectedWorkspacesWorkspaceIdSettingsBrowserExtensionRoute
  '/workspaces/$workspaceId/settings/chat': typeof protectedWorkspacesWorkspaceIdSettingsChatRoute
  '/workspaces/$workspaceId/settings/checks': typeof protectedWorkspacesWorkspaceIdSettingsChecksRoute
  '/workspaces/$workspaceId/settings/compliance-roles': typeof protectedWorkspacesWorkspaceIdSettingsComplianceRolesRoute
  '/workspaces/$workspaceId/settings/configuration': typeof protectedWorkspacesWorkspaceIdSettingsConfigurationRoute
  '/workspaces/$workspaceId/settings/data-export': typeof protectedWorkspacesWorkspaceIdSettingsDataExportRoute
  '/workspaces/$workspaceId/settings/email': typeof protectedWorkspacesWorkspaceIdSettingsEmailRoute
  '/workspaces/$workspaceId/settings/exceptions': typeof protectedWorkspacesWorkspaceIdSettingsExceptionsRoute
  '/workspaces/$workspaceId/settings/general': typeof protectedWorkspacesWorkspaceIdSettingsGeneralRoute
  '/workspaces/$workspaceId/settings/governance': typeof protectedWorkspacesWorkspaceIdSettingsGovernanceRoute
  '/workspaces/$workspaceId/settings/imports': typeof protectedWorkspacesWorkspaceIdSettingsImportsRoute
  '/workspaces/$workspaceId/settings/integrations': typeof protectedWorkspacesWorkspaceIdSettingsIntegrationsRoute
  '/workspaces/$workspaceId/settings/mcp-server': typeof protectedWorkspacesWorkspaceIdSettingsMcpServerRoute
  '/workspaces/$workspaceId/settings/members': typeof protectedWorkspacesWorkspaceIdSettingsMembersRoute
  '/workspaces/$workspaceId/settings/notifications': typeof protectedWorkspacesWorkspaceIdSettingsNotificationsRoute
  '/workspaces/$workspaceId/settings/personal-tokens': typeof protectedWorkspacesWorkspaceIdSettingsPersonalTokensRoute
  '/workspaces/$workspaceId/settings/personas': typeof protectedWorkspacesWorkspaceIdSettingsPersonasRoute
  '/workspaces/$workspaceId/settings/procedure-triggers': typeof protectedWorkspacesWorkspaceIdSettingsProcedureTriggersRoute
  '/workspaces/$workspaceId/settings/profile': typeof protectedWorkspacesWorkspaceIdSettingsProfileRoute
  '/workspaces/$workspaceId/settings/program': typeof protectedWorkspacesWorkspaceIdSettingsProgramRoute
  '/workspaces/$workspaceId/settings/properties': typeof protectedWorkspacesWorkspaceIdSettingsPropertiesRoute
  '/workspaces/$workspaceId/settings/request-intake': typeof protectedWorkspacesWorkspaceIdSettingsRequestIntakeRoute
  '/workspaces/$workspaceId/settings/review': typeof protectedWorkspacesWorkspaceIdSettingsReviewRoute
  '/workspaces/$workspaceId/settings/security': typeof protectedWorkspacesWorkspaceIdSettingsSecurityRoute
  '/workspaces/$workspaceId/settings/signing': typeof protectedWorkspacesWorkspaceIdSettingsSigningRoute
  '/workspaces/$workspaceId/settings/templates': typeof protectedWorkspacesWorkspaceIdSettingsTemplatesRoute
  '/workspaces/$workspaceId/settings/theme': typeof protectedWorkspacesWorkspaceIdSettingsThemeRoute
  '/workspaces/$workspaceId/settings/writing': typeof protectedWorkspacesWorkspaceIdSettingsWritingRoute
  '/workspaces/$workspaceId/submissions/$submissionId': typeof protectedWorkspacesWorkspaceIdSubmissionsSubmissionIdRoute
  '/workspaces/$workspaceId/tasks/$taskId': typeof protectedWorkspacesWorkspaceIdTasksTaskIdRoute
  '/workspaces/$workspaceId/tasks/detail': typeof protectedWorkspacesWorkspaceIdTasksDetailRoute
  '/workspaces/$workspaceId/templates/new': typeof protectedWorkspacesWorkspaceIdTemplatesNewRoute
  '/workspaces/$workspaceId/templates/public': typeof protectedWorkspacesWorkspaceIdTemplatesPublicRoute
  '/workspaces/$workspaceId/vendors/$vendorId': typeof protectedWorkspacesWorkspaceIdVendorsVendorIdRoute
  '/workspaces/$workspaceId/automation/identities': typeof protectedWorkspacesWorkspaceIdAutomationIdentitiesLazyRoute
  '/workspaces/$workspaceId/deprecated/agent-reliability': typeof protectedWorkspacesWorkspaceIdDeprecatedAgentReliabilityLazyRoute
  '/workspaces/$workspaceId/auditor-center': typeof protectedWorkspacesWorkspaceIdAuditorCenterIndexRoute
  '/workspaces/$workspaceId/audits': typeof protectedWorkspacesWorkspaceIdAuditsIndexRoute
  '/workspaces/$workspaceId/employee-center': typeof protectedWorkspacesWorkspaceIdEmployeeCenterIndexRoute
  '/workspaces/$workspaceId/frameworks': typeof protectedWorkspacesWorkspaceIdFrameworksIndexRoute
  '/workspaces/$workspaceId/populations': typeof protectedWorkspacesWorkspaceIdPopulationsIndexRoute
  '/workspaces/$workspaceId/runs': typeof protectedWorkspacesWorkspaceIdRunsIndexRoute
  '/workspaces/$workspaceId/settings': typeof protectedWorkspacesWorkspaceIdSettingsIndexRoute
  '/workspaces/$workspaceId/templates': typeof protectedWorkspacesWorkspaceIdTemplatesIndexRoute
  '/workspaces/$workspaceId/automation': typeof protectedWorkspacesWorkspaceIdAutomationIndexLazyRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/api-access': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdApiAccessRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/assets': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAssetsRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/controls': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdControlsRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/dashboard': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdDashboardRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/evidence': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdEvidenceRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/open-requests': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdOpenRequestsRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/people': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPeopleRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/populations': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPopulationsRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/request-list': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRequestListRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/risks': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRisksRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/timeline': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdTimelineRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/vendors': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdVendorsRoute
  '/workspaces/$workspaceId/employee-center/pending-policies/$templateId': typeof protectedWorkspacesWorkspaceIdEmployeeCenterPendingPoliciesTemplateIdRoute
  '/workspaces/$workspaceId/employee-center/requests/$taskId': typeof protectedWorkspacesWorkspaceIdEmployeeCenterRequestsTaskIdRoute
  '/workspaces/$workspaceId/employee-center/tasks/$taskId': typeof protectedWorkspacesWorkspaceIdEmployeeCenterTasksTaskIdRoute
  '/workspaces/$workspaceId/employee-center/tests/$testId': typeof protectedWorkspacesWorkspaceIdEmployeeCenterTestsTestIdRoute
  '/workspaces/$workspaceId/employee-center/training/$programId': typeof protectedWorkspacesWorkspaceIdEmployeeCenterTrainingProgramIdRoute
  '/workspaces/$workspaceId/integrations/custom/$applicationId': typeof protectedWorkspacesWorkspaceIdIntegrationsCustomApplicationIdRoute
  '/workspaces/$workspaceId/recordings/$flowId/edit': typeof protectedWorkspacesWorkspaceIdRecordingsFlowIdEditRoute
  '/workspaces/$workspaceId/reviews/access/$cycleId': typeof protectedWorkspacesWorkspaceIdReviewsAccessCycleIdRoute
  '/workspaces/$workspaceId/reviews/access/roles': typeof protectedWorkspacesWorkspaceIdReviewsAccessRolesRoute
  '/workspaces/$workspaceId/risks/assessments/$draftId': typeof protectedWorkspacesWorkspaceIdRisksAssessmentsDraftIdRoute
  '/workspaces/$workspaceId/templates/$templateId/edit': typeof protectedWorkspacesWorkspaceIdTemplatesTemplateIdEditRoute
  '/workspaces/$workspaceId/tests/$testId/submissions': typeof protectedWorkspacesWorkspaceIdTestsTestIdSubmissionsRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIndexRoute
  '/workspaces/$workspaceId/automation/$executionId': typeof protectedWorkspacesWorkspaceIdAutomationExecutionIdIndexRoute
  '/workspaces/$workspaceId/deprecated/sources': typeof protectedWorkspacesWorkspaceIdDeprecatedSourcesIndexRoute
  '/workspaces/$workspaceId/frameworks/$frameworkId': typeof protectedWorkspacesWorkspaceIdFrameworksFrameworkIdIndexRoute
  '/workspaces/$workspaceId/templates/$templateId': typeof protectedWorkspacesWorkspaceIdTemplatesTemplateIdIndexRoute
  '/workspaces/$workspaceId/tests/$testId': typeof protectedWorkspacesWorkspaceIdTestsTestIdIndexRoute
  '/workspaces/$workspaceId/deprecated/integrations-old': typeof protectedWorkspacesWorkspaceIdDeprecatedIntegrationsOldIndexLazyRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/assets/$assetId': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAssetsAssetIdRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations/$providerSlug': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsProviderSlugRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/people/$employeeId': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPeopleEmployeeIdRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/populations/$populationId': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPopulationsPopulationIdRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/risks/$riskId': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRisksRiskIdRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/vendors/$vendorId': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdVendorsVendorIdRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/policies/$policySlug': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesPolicySlugRoute
  '/workspaces/$workspaceId/integrations/$providerSlug/accounts/$connectionId': typeof protectedWorkspacesWorkspaceIdIntegrationsProviderSlugAccountsConnectionIdRoute
  '/workspaces/$workspaceId/integrations/$providerSlug/services/$serviceId': typeof protectedWorkspacesWorkspaceIdIntegrationsProviderSlugServicesServiceIdRoute
  '/workspaces/$workspaceId/reviews/access/period/$periodKey': typeof protectedWorkspacesWorkspaceIdReviewsAccessPeriodPeriodKeyRoute
  '/workspaces/$workspaceId/vendors/$vendorId/assessments/$assessmentId': typeof protectedWorkspacesWorkspaceIdVendorsVendorIdAssessmentsAssessmentIdRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/audit-evidence': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceIndexRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/policies': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesIndexRoute
  '/workspaces/$workspaceId/frameworks/$frameworkId/controls': typeof protectedWorkspacesWorkspaceIdFrameworksFrameworkIdControlsIndexRoute
  '/workspaces/$workspaceId/templates/control/$controlId': typeof protectedWorkspacesWorkspaceIdTemplatesControlControlIdIndexRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/audit-evidence/$evidenceKind/$evidenceItemId': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceEvidenceKindEvidenceItemIdRoute
  '/workspaces/$workspaceId/deprecated/workflows/$workflowId/executions/$jobId': typeof protectedWorkspacesWorkspaceIdDeprecatedWorkflowsWorkflowIdExecutionsJobIdRoute
  '/workspaces/$workspaceId/integrations/custom/$applicationId/datasets/$datasetId': typeof protectedWorkspacesWorkspaceIdIntegrationsCustomApplicationIdDatasetsDatasetIdRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations/$providerSlug/accounts/$connectionId': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsProviderSlugAccountsConnectionIdRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations/$providerSlug/services/$serviceId': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsProviderSlugServicesServiceIdRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/populations/$populationId/rounds/$sampleId': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPopulationsPopulationIdRoundsSampleIdRoute
  '/workspaces/$workspaceId/auditor-center/$auditCycleId/vendors/$vendorId/reviews/$assessmentId': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdVendorsVendorIdReviewsAssessmentIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(auth)': typeof authRouteRouteWithChildren
  '/(protected)': typeof protectedRouteRouteWithChildren
  '/extension-uninstalled': typeof ExtensionUninstalledLazyRoute
  '/(auth)/onboarding': typeof authOnboardingRouteRouteWithChildren
  '/(protected)/orgs': typeof protectedOrgsRouteRouteWithChildren
  '/(protected)/partner': typeof protectedPartnerRouteRouteWithChildren
  '/(protected)/workspaces': typeof protectedWorkspacesRouteRouteWithChildren
  '/(auth)/accept-invitation': typeof authAcceptInvitationRoute
  '/(auth)/invite': typeof authInviteRoute
  '/(auth)/login': typeof authLoginRoute
  '/(auth)/logout': typeof authLogoutRoute
  '/(auth)/otp': typeof authOtpRoute
  '/(auth)/reset-password': typeof authResetPasswordRoute
  '/(auth)/share-invite': typeof authShareInviteRoute
  '/(auth)/verify-email': typeof authVerifyEmailRoute
  '/(protected)/auditor-center': typeof protectedAuditorCenterRouteWithChildren
  '/integrations/github-app-callback': typeof IntegrationsGithubAppCallbackRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/trust/$slug': typeof TrustSlugRoute
  '/(auth)/forgot-password': typeof authForgotPasswordLazyRoute
  '/(auth)/login-2': typeof authLogin2LazyRoute
  '/(auth)/setup-mfa': typeof authSetupMfaLazyRoute
  '/(auth)/signup': typeof authSignupLazyRoute
  '/(auth)/verify-2fa': typeof authVerify2faLazyRoute
  '/(auth)/verify-otp': typeof authVerifyOtpLazyRoute
  '/(errors)/401': typeof errors401LazyRoute
  '/(errors)/403': typeof errors403LazyRoute
  '/(errors)/404': typeof errors404LazyRoute
  '/(errors)/500': typeof errors500LazyRoute
  '/(errors)/503': typeof errors503LazyRoute
  '/shared/$shareId': typeof SharedShareIdLazyRoute
  '/(protected)/': typeof protectedIndexRoute
  '/(protected)/orgs/$slug': typeof protectedOrgsSlugRouteRoute
  '/(protected)/workspaces/$workspaceId': typeof protectedWorkspacesWorkspaceIdRouteRouteWithChildren
  '/(auth)/auth-callback/$provider': typeof authAuthCallbackProviderRoute
  '/(auth)/native/auth-callback': typeof authNativeAuthCallbackRoute
  '/(auth)/native/login': typeof authNativeLoginRoute
  '/(auth)/onboarding/extension': typeof authOnboardingExtensionRoute
  '/(auth)/onboarding/preferences': typeof authOnboardingPreferencesRoute
  '/(auth)/onboarding/quick-setup': typeof authOnboardingQuickSetupRoute
  '/(auth)/onboarding/team': typeof authOnboardingTeamRoute
  '/(protected)/auditor-center/profile': typeof protectedAuditorCenterProfileRoute
  '/(protected)/auditor-center/security': typeof protectedAuditorCenterSecurityRoute
  '/(protected)/dev/plan-restrictions-test': typeof protectedDevPlanRestrictionsTestRoute
  '/(protected)/partner/templates': typeof protectedPartnerTemplatesRoute
  '/(protected)/workspaces/new': typeof protectedWorkspacesNewRoute
  '/demo/tiptap/ai-changes': typeof DemoTiptapAiChangesRoute
  '/demo/tiptap/ai-suggestion': typeof DemoTiptapAiSuggestionRoute
  '/trust/access/$token': typeof TrustAccessTokenRoute
  '/trust/nda/$token': typeof TrustNdaTokenRoute
  '/trust/resources/$resourceId': typeof TrustResourcesResourceIdRoute
  '/(protected)/auditor-center/': typeof protectedAuditorCenterIndexRoute
  '/(protected)/partner/': typeof protectedPartnerIndexRoute
  '/demo/tiptap/': typeof DemoTiptapIndexRoute
  '/evidence/verify/': typeof EvidenceVerifyIndexRoute
  '/export/evidence-pdf/': typeof ExportEvidencePdfIndexRoute
  '/export/org-chart/': typeof ExportOrgChartIndexRoute
  '/export/policy-pdf/': typeof ExportPolicyPdfIndexRoute
  '/export/topic-embed/': typeof ExportTopicEmbedIndexRoute
  '/export/topic-pdf/': typeof ExportTopicPdfIndexRoute
  '/(protected)/onboarding/': typeof protectedOnboardingIndexLazyRoute
  '/(protected)/orgs/': typeof protectedOrgsIndexLazyRoute
  '/(protected)/workspaces/': typeof protectedWorkspacesIndexLazyRoute
  '/(protected)/workspaces/$workspaceId/auditor-center': typeof protectedWorkspacesWorkspaceIdAuditorCenterRouteRouteWithChildren
  '/(protected)/workspaces/$workspaceId/employee-center': typeof protectedWorkspacesWorkspaceIdEmployeeCenterRouteRouteWithChildren
  '/(protected)/workspaces/$workspaceId/settings': typeof protectedWorkspacesWorkspaceIdSettingsRouteRouteWithChildren
  '/(protected)/partner/clients/$clientId': typeof protectedPartnerClientsClientIdRoute
  '/(protected)/partner/clients/new': typeof protectedPartnerClientsNewRoute
  '/(protected)/workspace/integrations/github': typeof protectedWorkspaceIntegrationsGithubRoute
  '/(protected)/workspaces/$workspaceId/anonymous-reports': typeof protectedWorkspacesWorkspaceIdAnonymousReportsRoute
  '/(protected)/workspaces/$workspaceId/approvals': typeof protectedWorkspacesWorkspaceIdApprovalsRoute
  '/(protected)/workspaces/$workspaceId/assets': typeof protectedWorkspacesWorkspaceIdAssetsRoute
  '/(protected)/workspaces/$workspaceId/connect-repo': typeof protectedWorkspacesWorkspaceIdConnectRepoRoute
  '/(protected)/workspaces/$workspaceId/connect-tools': typeof protectedWorkspacesWorkspaceIdConnectToolsRoute
  '/(protected)/workspaces/$workspaceId/controls': typeof protectedWorkspacesWorkspaceIdControlsRoute
  '/(protected)/workspaces/$workspaceId/dashboard': typeof protectedWorkspacesWorkspaceIdDashboardRoute
  '/(protected)/workspaces/$workspaceId/documents': typeof protectedWorkspacesWorkspaceIdDocumentsRoute
  '/(protected)/workspaces/$workspaceId/evidence': typeof protectedWorkspacesWorkspaceIdEvidenceRoute
  '/(protected)/workspaces/$workspaceId/evidence-slots': typeof protectedWorkspacesWorkspaceIdEvidenceSlotsRoute
  '/(protected)/workspaces/$workspaceId/guide': typeof protectedWorkspacesWorkspaceIdGuideRoute
  '/(protected)/workspaces/$workspaceId/inbox': typeof protectedWorkspacesWorkspaceIdInboxRoute
  '/(protected)/workspaces/$workspaceId/integrations': typeof protectedWorkspacesWorkspaceIdIntegrationsRoute
  '/(protected)/workspaces/$workspaceId/monitoring': typeof protectedWorkspacesWorkspaceIdMonitoringRoute
  '/(protected)/workspaces/$workspaceId/onboarding': typeof protectedWorkspacesWorkspaceIdOnboardingRoute
  '/(protected)/workspaces/$workspaceId/people': typeof protectedWorkspacesWorkspaceIdPeopleRouteWithChildren
  '/(protected)/workspaces/$workspaceId/policies': typeof protectedWorkspacesWorkspaceIdPoliciesRoute
  '/(protected)/workspaces/$workspaceId/questionnaires': typeof protectedWorkspacesWorkspaceIdQuestionnairesRoute
  '/(protected)/workspaces/$workspaceId/readiness': typeof protectedWorkspacesWorkspaceIdReadinessRoute
  '/(protected)/workspaces/$workspaceId/risks': typeof protectedWorkspacesWorkspaceIdRisksRoute
  '/(protected)/workspaces/$workspaceId/runbooks': typeof protectedWorkspacesWorkspaceIdRunbooksRoute
  '/(protected)/workspaces/$workspaceId/setup': typeof protectedWorkspacesWorkspaceIdSetupRoute
  '/(protected)/workspaces/$workspaceId/statement-of-applicability': typeof protectedWorkspacesWorkspaceIdStatementOfApplicabilityRoute
  '/(protected)/workspaces/$workspaceId/system-description': typeof protectedWorkspacesWorkspaceIdSystemDescriptionRoute
  '/(protected)/workspaces/$workspaceId/tasks': typeof protectedWorkspacesWorkspaceIdTasksRoute
  '/(protected)/workspaces/$workspaceId/tests': typeof protectedWorkspacesWorkspaceIdTestsRoute
  '/(protected)/workspaces/$workspaceId/trust-center': typeof protectedWorkspacesWorkspaceIdTrustCenterRoute
  '/(protected)/workspaces/$workspaceId/vendors': typeof protectedWorkspacesWorkspaceIdVendorsRoute
  '/(protected)/onboarding/$organizationId/workspace': typeof protectedOnboardingOrganizationIdWorkspaceLazyRoute
  '/(protected)/workspace/integrations/': typeof protectedWorkspaceIntegrationsIndexRoute
  '/(protected)/workspaces/$workspaceId/': typeof protectedWorkspacesWorkspaceIdIndexRoute
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRouteWithChildren
  '/(protected)/workspaces/$workspaceId/anonymous-reports_/$reportId': typeof protectedWorkspacesWorkspaceIdAnonymousReportsReportIdRoute
  '/(protected)/workspaces/$workspaceId/assets_/$assetId': typeof protectedWorkspacesWorkspaceIdAssetsAssetIdRoute
  '/(protected)/workspaces/$workspaceId/auditor-center/api-access': typeof protectedWorkspacesWorkspaceIdAuditorCenterApiAccessRoute
  '/(protected)/workspaces/$workspaceId/audits/$auditCycleId': typeof protectedWorkspacesWorkspaceIdAuditsAuditCycleIdRoute
  '/(protected)/workspaces/$workspaceId/chat_/$threadId': typeof protectedWorkspacesWorkspaceIdChatThreadIdRoute
  '/(protected)/workspaces/$workspaceId/controls_/$controlDefId': typeof protectedWorkspacesWorkspaceIdControlsControlDefIdRoute
  '/(protected)/workspaces/$workspaceId/deprecated/compliance-route-old': typeof protectedWorkspacesWorkspaceIdDeprecatedComplianceRouteOldRoute
  '/(protected)/workspaces/$workspaceId/dev/tool-ui': typeof protectedWorkspacesWorkspaceIdDevToolUiRoute
  '/(protected)/workspaces/$workspaceId/devices_/$deviceId': typeof protectedWorkspacesWorkspaceIdDevicesDeviceIdRoute
  '/(protected)/workspaces/$workspaceId/documents_/$docId': typeof protectedWorkspacesWorkspaceIdDocumentsDocIdRoute
  '/(protected)/workspaces/$workspaceId/employee-center/acknowledgments': typeof protectedWorkspacesWorkspaceIdEmployeeCenterAcknowledgmentsRoute
  '/(protected)/workspaces/$workspaceId/employee-center/anonymous-reporting': typeof protectedWorkspacesWorkspaceIdEmployeeCenterAnonymousReportingRoute
  '/(protected)/workspaces/$workspaceId/employee-center/devices': typeof protectedWorkspacesWorkspaceIdEmployeeCenterDevicesRoute
  '/(protected)/workspaces/$workspaceId/employee-center/inbox': typeof protectedWorkspacesWorkspaceIdEmployeeCenterInboxRoute
  '/(protected)/workspaces/$workspaceId/employee-center/org-chart': typeof protectedWorkspacesWorkspaceIdEmployeeCenterOrgChartRoute
  '/(protected)/workspaces/$workspaceId/employee-center/pending-policies': typeof protectedWorkspacesWorkspaceIdEmployeeCenterPendingPoliciesRoute
  '/(protected)/workspaces/$workspaceId/employee-center/requests': typeof protectedWorkspacesWorkspaceIdEmployeeCenterRequestsRoute
  '/(protected)/workspaces/$workspaceId/employee-center/tasks': typeof protectedWorkspacesWorkspaceIdEmployeeCenterTasksRoute
  '/(protected)/workspaces/$workspaceId/employee-center/training': typeof protectedWorkspacesWorkspaceIdEmployeeCenterTrainingRoute
  '/(protected)/workspaces/$workspaceId/evidence-viewer/$evidencePackId': typeof protectedWorkspacesWorkspaceIdEvidenceViewerEvidencePackIdRoute
  '/(protected)/workspaces/$workspaceId/evidence_/creating': typeof protectedWorkspacesWorkspaceIdEvidenceCreatingRoute
  '/(protected)/workspaces/$workspaceId/integrations_/$providerSlug': typeof protectedWorkspacesWorkspaceIdIntegrationsProviderSlugRoute
  '/(protected)/workspaces/$workspaceId/people/me': typeof protectedWorkspacesWorkspaceIdPeopleMeRoute
  '/(protected)/workspaces/$workspaceId/people_/$employeeId': typeof protectedWorkspacesWorkspaceIdPeopleEmployeeIdRoute
  '/(protected)/workspaces/$workspaceId/people_groups/$groupId': typeof protectedWorkspacesWorkspaceIdPeople_groupsGroupIdRoute
  '/(protected)/workspaces/$workspaceId/people_training/$programId': typeof protectedWorkspacesWorkspaceIdPeople_trainingProgramIdRoute
  '/(protected)/workspaces/$workspaceId/policies_/$policySlug': typeof protectedWorkspacesWorkspaceIdPoliciesPolicySlugRoute
  '/(protected)/workspaces/$workspaceId/questionnaires_/$id': typeof protectedWorkspacesWorkspaceIdQuestionnairesIdRoute
  '/(protected)/workspaces/$workspaceId/reviews/access': typeof protectedWorkspacesWorkspaceIdReviewsAccessRoute
  '/(protected)/workspaces/$workspaceId/risks_/$riskId': typeof protectedWorkspacesWorkspaceIdRisksRiskIdRoute
  '/(protected)/workspaces/$workspaceId/runbooks_/$runbookId': typeof protectedWorkspacesWorkspaceIdRunbooksRunbookIdRoute
  '/(protected)/workspaces/$workspaceId/runbooks_/new': typeof protectedWorkspacesWorkspaceIdRunbooksNewRoute
  '/(protected)/workspaces/$workspaceId/runs/$executionId': typeof protectedWorkspacesWorkspaceIdRunsExecutionIdRoute
  '/(protected)/workspaces/$workspaceId/settings/api-keys': typeof protectedWorkspacesWorkspaceIdSettingsApiKeysRoute
  '/(protected)/workspaces/$workspaceId/settings/audit-logs': typeof protectedWorkspacesWorkspaceIdSettingsAuditLogsRoute
  '/(protected)/workspaces/$workspaceId/settings/auth': typeof protectedWorkspacesWorkspaceIdSettingsAuthRoute
  '/(protected)/workspaces/$workspaceId/settings/billing': typeof protectedWorkspacesWorkspaceIdSettingsBillingRoute
  '/(protected)/workspaces/$workspaceId/settings/browser-extension': typeof protectedWorkspacesWorkspaceIdSettingsBrowserExtensionRoute
  '/(protected)/workspaces/$workspaceId/settings/chat': typeof protectedWorkspacesWorkspaceIdSettingsChatRoute
  '/(protected)/workspaces/$workspaceId/settings/checks': typeof protectedWorkspacesWorkspaceIdSettingsChecksRoute
  '/(protected)/workspaces/$workspaceId/settings/compliance-roles': typeof protectedWorkspacesWorkspaceIdSettingsComplianceRolesRoute
  '/(protected)/workspaces/$workspaceId/settings/configuration': typeof protectedWorkspacesWorkspaceIdSettingsConfigurationRoute
  '/(protected)/workspaces/$workspaceId/settings/data-export': typeof protectedWorkspacesWorkspaceIdSettingsDataExportRoute
  '/(protected)/workspaces/$workspaceId/settings/email': typeof protectedWorkspacesWorkspaceIdSettingsEmailRoute
  '/(protected)/workspaces/$workspaceId/settings/exceptions': typeof protectedWorkspacesWorkspaceIdSettingsExceptionsRoute
  '/(protected)/workspaces/$workspaceId/settings/general': typeof protectedWorkspacesWorkspaceIdSettingsGeneralRoute
  '/(protected)/workspaces/$workspaceId/settings/governance': typeof protectedWorkspacesWorkspaceIdSettingsGovernanceRoute
  '/(protected)/workspaces/$workspaceId/settings/imports': typeof protectedWorkspacesWorkspaceIdSettingsImportsRoute
  '/(protected)/workspaces/$workspaceId/settings/integrations': typeof protectedWorkspacesWorkspaceIdSettingsIntegrationsRoute
  '/(protected)/workspaces/$workspaceId/settings/mcp-server': typeof protectedWorkspacesWorkspaceIdSettingsMcpServerRoute
  '/(protected)/workspaces/$workspaceId/settings/members': typeof protectedWorkspacesWorkspaceIdSettingsMembersRoute
  '/(protected)/workspaces/$workspaceId/settings/notifications': typeof protectedWorkspacesWorkspaceIdSettingsNotificationsRoute
  '/(protected)/workspaces/$workspaceId/settings/personal-tokens': typeof protectedWorkspacesWorkspaceIdSettingsPersonalTokensRoute
  '/(protected)/workspaces/$workspaceId/settings/personas': typeof protectedWorkspacesWorkspaceIdSettingsPersonasRoute
  '/(protected)/workspaces/$workspaceId/settings/procedure-triggers': typeof protectedWorkspacesWorkspaceIdSettingsProcedureTriggersRoute
  '/(protected)/workspaces/$workspaceId/settings/profile': typeof protectedWorkspacesWorkspaceIdSettingsProfileRoute
  '/(protected)/workspaces/$workspaceId/settings/program': typeof protectedWorkspacesWorkspaceIdSettingsProgramRoute
  '/(protected)/workspaces/$workspaceId/settings/properties': typeof protectedWorkspacesWorkspaceIdSettingsPropertiesRoute
  '/(protected)/workspaces/$workspaceId/settings/request-intake': typeof protectedWorkspacesWorkspaceIdSettingsRequestIntakeRoute
  '/(protected)/workspaces/$workspaceId/settings/review': typeof protectedWorkspacesWorkspaceIdSettingsReviewRoute
  '/(protected)/workspaces/$workspaceId/settings/security': typeof protectedWorkspacesWorkspaceIdSettingsSecurityRoute
  '/(protected)/workspaces/$workspaceId/settings/signing': typeof protectedWorkspacesWorkspaceIdSettingsSigningRoute
  '/(protected)/workspaces/$workspaceId/settings/templates': typeof protectedWorkspacesWorkspaceIdSettingsTemplatesRoute
  '/(protected)/workspaces/$workspaceId/settings/theme': typeof protectedWorkspacesWorkspaceIdSettingsThemeRoute
  '/(protected)/workspaces/$workspaceId/settings/writing': typeof protectedWorkspacesWorkspaceIdSettingsWritingRoute
  '/(protected)/workspaces/$workspaceId/submissions/$submissionId': typeof protectedWorkspacesWorkspaceIdSubmissionsSubmissionIdRoute
  '/(protected)/workspaces/$workspaceId/tasks_/$taskId': typeof protectedWorkspacesWorkspaceIdTasksTaskIdRoute
  '/(protected)/workspaces/$workspaceId/tasks_/detail': typeof protectedWorkspacesWorkspaceIdTasksDetailRoute
  '/(protected)/workspaces/$workspaceId/templates/new': typeof protectedWorkspacesWorkspaceIdTemplatesNewRoute
  '/(protected)/workspaces/$workspaceId/templates/public': typeof protectedWorkspacesWorkspaceIdTemplatesPublicRoute
  '/(protected)/workspaces/$workspaceId/vendors_/$vendorId': typeof protectedWorkspacesWorkspaceIdVendorsVendorIdRoute
  '/(protected)/workspaces/$workspaceId/automation/identities': typeof protectedWorkspacesWorkspaceIdAutomationIdentitiesLazyRoute
  '/(protected)/workspaces/$workspaceId/deprecated/agent-reliability': typeof protectedWorkspacesWorkspaceIdDeprecatedAgentReliabilityLazyRoute
  '/(protected)/workspaces/$workspaceId/auditor-center/': typeof protectedWorkspacesWorkspaceIdAuditorCenterIndexRoute
  '/(protected)/workspaces/$workspaceId/audits/': typeof protectedWorkspacesWorkspaceIdAuditsIndexRoute
  '/(protected)/workspaces/$workspaceId/employee-center/': typeof protectedWorkspacesWorkspaceIdEmployeeCenterIndexRoute
  '/(protected)/workspaces/$workspaceId/frameworks/': typeof protectedWorkspacesWorkspaceIdFrameworksIndexRoute
  '/(protected)/workspaces/$workspaceId/populations/': typeof protectedWorkspacesWorkspaceIdPopulationsIndexRoute
  '/(protected)/workspaces/$workspaceId/runs/': typeof protectedWorkspacesWorkspaceIdRunsIndexRoute
  '/(protected)/workspaces/$workspaceId/settings/': typeof protectedWorkspacesWorkspaceIdSettingsIndexRoute
  '/(protected)/workspaces/$workspaceId/templates/': typeof protectedWorkspacesWorkspaceIdTemplatesIndexRoute
  '/(protected)/workspaces/$workspaceId/automation/': typeof protectedWorkspacesWorkspaceIdAutomationIndexLazyRoute
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/audit-evidence': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceRouteRouteWithChildren
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId_/policies': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesRouteRouteWithChildren
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/api-access': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdApiAccessRoute
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/assets': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAssetsRoute
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/controls': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdControlsRoute
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/dashboard': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdDashboardRoute
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/evidence': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdEvidenceRoute
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsRoute
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/open-requests': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdOpenRequestsRoute
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/people': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPeopleRoute
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/populations': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPopulationsRoute
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/request-list': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRequestListRoute
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/risks': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRisksRoute
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/timeline': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdTimelineRoute
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/vendors': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdVendorsRoute
  '/(protected)/workspaces/$workspaceId/employee-center/pending-policies_/$templateId': typeof protectedWorkspacesWorkspaceIdEmployeeCenterPendingPoliciesTemplateIdRoute
  '/(protected)/workspaces/$workspaceId/employee-center/requests_/$taskId': typeof protectedWorkspacesWorkspaceIdEmployeeCenterRequestsTaskIdRoute
  '/(protected)/workspaces/$workspaceId/employee-center/tasks_/$taskId': typeof protectedWorkspacesWorkspaceIdEmployeeCenterTasksTaskIdRoute
  '/(protected)/workspaces/$workspaceId/employee-center/tests_/$testId': typeof protectedWorkspacesWorkspaceIdEmployeeCenterTestsTestIdRoute
  '/(protected)/workspaces/$workspaceId/employee-center/training_/$programId': typeof protectedWorkspacesWorkspaceIdEmployeeCenterTrainingProgramIdRoute
  '/(protected)/workspaces/$workspaceId/integrations_/custom/$applicationId': typeof protectedWorkspacesWorkspaceIdIntegrationsCustomApplicationIdRoute
  '/(protected)/workspaces/$workspaceId/recordings_/$flowId/edit': typeof protectedWorkspacesWorkspaceIdRecordingsFlowIdEditRoute
  '/(protected)/workspaces/$workspaceId/reviews/access_/$cycleId': typeof protectedWorkspacesWorkspaceIdReviewsAccessCycleIdRoute
  '/(protected)/workspaces/$workspaceId/reviews/access_/roles': typeof protectedWorkspacesWorkspaceIdReviewsAccessRolesRoute
  '/(protected)/workspaces/$workspaceId/risks_/assessments/$draftId': typeof protectedWorkspacesWorkspaceIdRisksAssessmentsDraftIdRoute
  '/(protected)/workspaces/$workspaceId/templates/$templateId/edit': typeof protectedWorkspacesWorkspaceIdTemplatesTemplateIdEditRoute
  '/(protected)/workspaces/$workspaceId/tests_/$testId/submissions': typeof protectedWorkspacesWorkspaceIdTestsTestIdSubmissionsRoute
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIndexRoute
  '/(protected)/workspaces/$workspaceId/automation/$executionId/': typeof protectedWorkspacesWorkspaceIdAutomationExecutionIdIndexRoute
  '/(protected)/workspaces/$workspaceId/deprecated/sources/': typeof protectedWorkspacesWorkspaceIdDeprecatedSourcesIndexRoute
  '/(protected)/workspaces/$workspaceId/frameworks/$frameworkId/': typeof protectedWorkspacesWorkspaceIdFrameworksFrameworkIdIndexRoute
  '/(protected)/workspaces/$workspaceId/templates/$templateId/': typeof protectedWorkspacesWorkspaceIdTemplatesTemplateIdIndexRoute
  '/(protected)/workspaces/$workspaceId/tests_/$testId/': typeof protectedWorkspacesWorkspaceIdTestsTestIdIndexRoute
  '/(protected)/workspaces/$workspaceId/deprecated/integrations-old/': typeof protectedWorkspacesWorkspaceIdDeprecatedIntegrationsOldIndexLazyRoute
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/assets_/$assetId': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAssetsAssetIdRoute
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations_/$providerSlug': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsProviderSlugRoute
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/people_/$employeeId': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPeopleEmployeeIdRoute
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/populations_/$populationId': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPopulationsPopulationIdRoute
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/risks_/$riskId': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRisksRiskIdRoute
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/vendors_/$vendorId': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdVendorsVendorIdRoute
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId_/policies/$policySlug': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesPolicySlugRoute
  '/(protected)/workspaces/$workspaceId/integrations_/$providerSlug_/accounts/$connectionId': typeof protectedWorkspacesWorkspaceIdIntegrationsProviderSlugAccountsConnectionIdRoute
  '/(protected)/workspaces/$workspaceId/integrations_/$providerSlug_/services/$serviceId': typeof protectedWorkspacesWorkspaceIdIntegrationsProviderSlugServicesServiceIdRoute
  '/(protected)/workspaces/$workspaceId/reviews/access_/period/$periodKey': typeof protectedWorkspacesWorkspaceIdReviewsAccessPeriodPeriodKeyRoute
  '/(protected)/workspaces/$workspaceId/vendors_/$vendorId_/assessments/$assessmentId': typeof protectedWorkspacesWorkspaceIdVendorsVendorIdAssessmentsAssessmentIdRoute
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/audit-evidence/': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceIndexRoute
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId_/policies/': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesIndexRoute
  '/(protected)/workspaces/$workspaceId/frameworks/$frameworkId/controls/': typeof protectedWorkspacesWorkspaceIdFrameworksFrameworkIdControlsIndexRoute
  '/(protected)/workspaces/$workspaceId/templates/control/$controlId/': typeof protectedWorkspacesWorkspaceIdTemplatesControlControlIdIndexRoute
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/audit-evidence/$evidenceKind/$evidenceItemId': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceEvidenceKindEvidenceItemIdRoute
  '/(protected)/workspaces/$workspaceId/deprecated/workflows/$workflowId/executions/$jobId': typeof protectedWorkspacesWorkspaceIdDeprecatedWorkflowsWorkflowIdExecutionsJobIdRoute
  '/(protected)/workspaces/$workspaceId/integrations_/custom/$applicationId_/datasets/$datasetId': typeof protectedWorkspacesWorkspaceIdIntegrationsCustomApplicationIdDatasetsDatasetIdRoute
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations_/$providerSlug_/accounts/$connectionId': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsProviderSlugAccountsConnectionIdRoute
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations_/$providerSlug_/services/$serviceId': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsProviderSlugServicesServiceIdRoute
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/populations_/$populationId_/rounds/$sampleId': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPopulationsPopulationIdRoundsSampleIdRoute
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/vendors_/$vendorId_/reviews/$assessmentId': typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdVendorsVendorIdReviewsAssessmentIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/extension-uninstalled'
    | '/onboarding'
    | '/orgs'
    | '/partner'
    | '/workspaces'
    | '/accept-invitation'
    | '/invite'
    | '/login'
    | '/logout'
    | '/otp'
    | '/reset-password'
    | '/share-invite'
    | '/verify-email'
    | '/auditor-center'
    | '/integrations/github-app-callback'
    | '/oauth/consent'
    | '/trust/$slug'
    | '/forgot-password'
    | '/login-2'
    | '/setup-mfa'
    | '/signup'
    | '/verify-2fa'
    | '/verify-otp'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/shared/$shareId'
    | '/'
    | '/orgs/$slug'
    | '/workspaces/$workspaceId'
    | '/auth-callback/$provider'
    | '/native/auth-callback'
    | '/native/login'
    | '/onboarding/extension'
    | '/onboarding/preferences'
    | '/onboarding/quick-setup'
    | '/onboarding/team'
    | '/auditor-center/profile'
    | '/auditor-center/security'
    | '/dev/plan-restrictions-test'
    | '/partner/templates'
    | '/workspaces/new'
    | '/demo/tiptap/ai-changes'
    | '/demo/tiptap/ai-suggestion'
    | '/trust/access/$token'
    | '/trust/nda/$token'
    | '/trust/resources/$resourceId'
    | '/auditor-center/'
    | '/partner/'
    | '/demo/tiptap/'
    | '/evidence/verify/'
    | '/export/evidence-pdf/'
    | '/export/org-chart/'
    | '/export/policy-pdf/'
    | '/export/topic-embed/'
    | '/export/topic-pdf/'
    | '/onboarding/'
    | '/orgs/'
    | '/workspaces/'
    | '/workspaces/$workspaceId/auditor-center'
    | '/workspaces/$workspaceId/employee-center'
    | '/workspaces/$workspaceId/settings'
    | '/partner/clients/$clientId'
    | '/partner/clients/new'
    | '/workspace/integrations/github'
    | '/workspaces/$workspaceId/anonymous-reports'
    | '/workspaces/$workspaceId/approvals'
    | '/workspaces/$workspaceId/assets'
    | '/workspaces/$workspaceId/connect-repo'
    | '/workspaces/$workspaceId/connect-tools'
    | '/workspaces/$workspaceId/controls'
    | '/workspaces/$workspaceId/dashboard'
    | '/workspaces/$workspaceId/documents'
    | '/workspaces/$workspaceId/evidence'
    | '/workspaces/$workspaceId/evidence-slots'
    | '/workspaces/$workspaceId/guide'
    | '/workspaces/$workspaceId/inbox'
    | '/workspaces/$workspaceId/integrations'
    | '/workspaces/$workspaceId/monitoring'
    | '/workspaces/$workspaceId/onboarding'
    | '/workspaces/$workspaceId/people'
    | '/workspaces/$workspaceId/policies'
    | '/workspaces/$workspaceId/questionnaires'
    | '/workspaces/$workspaceId/readiness'
    | '/workspaces/$workspaceId/risks'
    | '/workspaces/$workspaceId/runbooks'
    | '/workspaces/$workspaceId/setup'
    | '/workspaces/$workspaceId/statement-of-applicability'
    | '/workspaces/$workspaceId/system-description'
    | '/workspaces/$workspaceId/tasks'
    | '/workspaces/$workspaceId/tests'
    | '/workspaces/$workspaceId/trust-center'
    | '/workspaces/$workspaceId/vendors'
    | '/onboarding/$organizationId/workspace'
    | '/workspace/integrations/'
    | '/workspaces/$workspaceId/'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId'
    | '/workspaces/$workspaceId/anonymous-reports/$reportId'
    | '/workspaces/$workspaceId/assets/$assetId'
    | '/workspaces/$workspaceId/auditor-center/api-access'
    | '/workspaces/$workspaceId/audits/$auditCycleId'
    | '/workspaces/$workspaceId/chat/$threadId'
    | '/workspaces/$workspaceId/controls/$controlDefId'
    | '/workspaces/$workspaceId/deprecated/compliance-route-old'
    | '/workspaces/$workspaceId/dev/tool-ui'
    | '/workspaces/$workspaceId/devices/$deviceId'
    | '/workspaces/$workspaceId/documents/$docId'
    | '/workspaces/$workspaceId/employee-center/acknowledgments'
    | '/workspaces/$workspaceId/employee-center/anonymous-reporting'
    | '/workspaces/$workspaceId/employee-center/devices'
    | '/workspaces/$workspaceId/employee-center/inbox'
    | '/workspaces/$workspaceId/employee-center/org-chart'
    | '/workspaces/$workspaceId/employee-center/pending-policies'
    | '/workspaces/$workspaceId/employee-center/requests'
    | '/workspaces/$workspaceId/employee-center/tasks'
    | '/workspaces/$workspaceId/employee-center/training'
    | '/workspaces/$workspaceId/evidence-viewer/$evidencePackId'
    | '/workspaces/$workspaceId/evidence/creating'
    | '/workspaces/$workspaceId/integrations/$providerSlug'
    | '/workspaces/$workspaceId/people/me'
    | '/workspaces/$workspaceId/people/$employeeId'
    | '/workspaces/$workspaceId/people_groups/$groupId'
    | '/workspaces/$workspaceId/people_training/$programId'
    | '/workspaces/$workspaceId/policies/$policySlug'
    | '/workspaces/$workspaceId/questionnaires/$id'
    | '/workspaces/$workspaceId/reviews/access'
    | '/workspaces/$workspaceId/risks/$riskId'
    | '/workspaces/$workspaceId/runbooks/$runbookId'
    | '/workspaces/$workspaceId/runbooks/new'
    | '/workspaces/$workspaceId/runs/$executionId'
    | '/workspaces/$workspaceId/settings/api-keys'
    | '/workspaces/$workspaceId/settings/audit-logs'
    | '/workspaces/$workspaceId/settings/auth'
    | '/workspaces/$workspaceId/settings/billing'
    | '/workspaces/$workspaceId/settings/browser-extension'
    | '/workspaces/$workspaceId/settings/chat'
    | '/workspaces/$workspaceId/settings/checks'
    | '/workspaces/$workspaceId/settings/compliance-roles'
    | '/workspaces/$workspaceId/settings/configuration'
    | '/workspaces/$workspaceId/settings/data-export'
    | '/workspaces/$workspaceId/settings/email'
    | '/workspaces/$workspaceId/settings/exceptions'
    | '/workspaces/$workspaceId/settings/general'
    | '/workspaces/$workspaceId/settings/governance'
    | '/workspaces/$workspaceId/settings/imports'
    | '/workspaces/$workspaceId/settings/integrations'
    | '/workspaces/$workspaceId/settings/mcp-server'
    | '/workspaces/$workspaceId/settings/members'
    | '/workspaces/$workspaceId/settings/notifications'
    | '/workspaces/$workspaceId/settings/personal-tokens'
    | '/workspaces/$workspaceId/settings/personas'
    | '/workspaces/$workspaceId/settings/procedure-triggers'
    | '/workspaces/$workspaceId/settings/profile'
    | '/workspaces/$workspaceId/settings/program'
    | '/workspaces/$workspaceId/settings/properties'
    | '/workspaces/$workspaceId/settings/request-intake'
    | '/workspaces/$workspaceId/settings/review'
    | '/workspaces/$workspaceId/settings/security'
    | '/workspaces/$workspaceId/settings/signing'
    | '/workspaces/$workspaceId/settings/templates'
    | '/workspaces/$workspaceId/settings/theme'
    | '/workspaces/$workspaceId/settings/writing'
    | '/workspaces/$workspaceId/submissions/$submissionId'
    | '/workspaces/$workspaceId/tasks/$taskId'
    | '/workspaces/$workspaceId/tasks/detail'
    | '/workspaces/$workspaceId/templates/new'
    | '/workspaces/$workspaceId/templates/public'
    | '/workspaces/$workspaceId/vendors/$vendorId'
    | '/workspaces/$workspaceId/automation/identities'
    | '/workspaces/$workspaceId/deprecated/agent-reliability'
    | '/workspaces/$workspaceId/auditor-center/'
    | '/workspaces/$workspaceId/audits/'
    | '/workspaces/$workspaceId/employee-center/'
    | '/workspaces/$workspaceId/frameworks/'
    | '/workspaces/$workspaceId/populations/'
    | '/workspaces/$workspaceId/runs/'
    | '/workspaces/$workspaceId/settings/'
    | '/workspaces/$workspaceId/templates/'
    | '/workspaces/$workspaceId/automation/'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/audit-evidence'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/policies'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/api-access'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/assets'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/controls'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/dashboard'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/evidence'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/open-requests'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/people'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/populations'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/request-list'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/risks'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/timeline'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/vendors'
    | '/workspaces/$workspaceId/employee-center/pending-policies/$templateId'
    | '/workspaces/$workspaceId/employee-center/requests/$taskId'
    | '/workspaces/$workspaceId/employee-center/tasks/$taskId'
    | '/workspaces/$workspaceId/employee-center/tests/$testId'
    | '/workspaces/$workspaceId/employee-center/training/$programId'
    | '/workspaces/$workspaceId/integrations/custom/$applicationId'
    | '/workspaces/$workspaceId/recordings/$flowId/edit'
    | '/workspaces/$workspaceId/reviews/access/$cycleId'
    | '/workspaces/$workspaceId/reviews/access/roles'
    | '/workspaces/$workspaceId/risks/assessments/$draftId'
    | '/workspaces/$workspaceId/templates/$templateId/edit'
    | '/workspaces/$workspaceId/tests/$testId/submissions'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/'
    | '/workspaces/$workspaceId/automation/$executionId/'
    | '/workspaces/$workspaceId/deprecated/sources/'
    | '/workspaces/$workspaceId/frameworks/$frameworkId/'
    | '/workspaces/$workspaceId/templates/$templateId/'
    | '/workspaces/$workspaceId/tests/$testId/'
    | '/workspaces/$workspaceId/deprecated/integrations-old/'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/assets/$assetId'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations/$providerSlug'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/people/$employeeId'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/populations/$populationId'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/risks/$riskId'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/vendors/$vendorId'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/policies/$policySlug'
    | '/workspaces/$workspaceId/integrations/$providerSlug/accounts/$connectionId'
    | '/workspaces/$workspaceId/integrations/$providerSlug/services/$serviceId'
    | '/workspaces/$workspaceId/reviews/access/period/$periodKey'
    | '/workspaces/$workspaceId/vendors/$vendorId/assessments/$assessmentId'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/audit-evidence/'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/policies/'
    | '/workspaces/$workspaceId/frameworks/$frameworkId/controls/'
    | '/workspaces/$workspaceId/templates/control/$controlId/'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/audit-evidence/$evidenceKind/$evidenceItemId'
    | '/workspaces/$workspaceId/deprecated/workflows/$workflowId/executions/$jobId'
    | '/workspaces/$workspaceId/integrations/custom/$applicationId/datasets/$datasetId'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations/$providerSlug/accounts/$connectionId'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations/$providerSlug/services/$serviceId'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/populations/$populationId/rounds/$sampleId'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/vendors/$vendorId/reviews/$assessmentId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/extension-uninstalled'
    | '/onboarding'
    | '/accept-invitation'
    | '/invite'
    | '/login'
    | '/logout'
    | '/otp'
    | '/reset-password'
    | '/share-invite'
    | '/verify-email'
    | '/integrations/github-app-callback'
    | '/oauth/consent'
    | '/trust/$slug'
    | '/forgot-password'
    | '/login-2'
    | '/setup-mfa'
    | '/signup'
    | '/verify-2fa'
    | '/verify-otp'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/shared/$shareId'
    | '/'
    | '/orgs/$slug'
    | '/auth-callback/$provider'
    | '/native/auth-callback'
    | '/native/login'
    | '/onboarding/extension'
    | '/onboarding/preferences'
    | '/onboarding/quick-setup'
    | '/onboarding/team'
    | '/auditor-center/profile'
    | '/auditor-center/security'
    | '/dev/plan-restrictions-test'
    | '/partner/templates'
    | '/workspaces/new'
    | '/demo/tiptap/ai-changes'
    | '/demo/tiptap/ai-suggestion'
    | '/trust/access/$token'
    | '/trust/nda/$token'
    | '/trust/resources/$resourceId'
    | '/auditor-center'
    | '/partner'
    | '/demo/tiptap'
    | '/evidence/verify'
    | '/export/evidence-pdf'
    | '/export/org-chart'
    | '/export/policy-pdf'
    | '/export/topic-embed'
    | '/export/topic-pdf'
    | '/orgs'
    | '/workspaces'
    | '/partner/clients/$clientId'
    | '/partner/clients/new'
    | '/workspace/integrations/github'
    | '/workspaces/$workspaceId/anonymous-reports'
    | '/workspaces/$workspaceId/approvals'
    | '/workspaces/$workspaceId/assets'
    | '/workspaces/$workspaceId/connect-repo'
    | '/workspaces/$workspaceId/connect-tools'
    | '/workspaces/$workspaceId/controls'
    | '/workspaces/$workspaceId/dashboard'
    | '/workspaces/$workspaceId/documents'
    | '/workspaces/$workspaceId/evidence'
    | '/workspaces/$workspaceId/evidence-slots'
    | '/workspaces/$workspaceId/guide'
    | '/workspaces/$workspaceId/inbox'
    | '/workspaces/$workspaceId/integrations'
    | '/workspaces/$workspaceId/monitoring'
    | '/workspaces/$workspaceId/onboarding'
    | '/workspaces/$workspaceId/people'
    | '/workspaces/$workspaceId/policies'
    | '/workspaces/$workspaceId/questionnaires'
    | '/workspaces/$workspaceId/readiness'
    | '/workspaces/$workspaceId/risks'
    | '/workspaces/$workspaceId/runbooks'
    | '/workspaces/$workspaceId/setup'
    | '/workspaces/$workspaceId/statement-of-applicability'
    | '/workspaces/$workspaceId/system-description'
    | '/workspaces/$workspaceId/tasks'
    | '/workspaces/$workspaceId/tests'
    | '/workspaces/$workspaceId/trust-center'
    | '/workspaces/$workspaceId/vendors'
    | '/onboarding/$organizationId/workspace'
    | '/workspace/integrations'
    | '/workspaces/$workspaceId'
    | '/workspaces/$workspaceId/anonymous-reports/$reportId'
    | '/workspaces/$workspaceId/assets/$assetId'
    | '/workspaces/$workspaceId/auditor-center/api-access'
    | '/workspaces/$workspaceId/audits/$auditCycleId'
    | '/workspaces/$workspaceId/chat/$threadId'
    | '/workspaces/$workspaceId/controls/$controlDefId'
    | '/workspaces/$workspaceId/deprecated/compliance-route-old'
    | '/workspaces/$workspaceId/dev/tool-ui'
    | '/workspaces/$workspaceId/devices/$deviceId'
    | '/workspaces/$workspaceId/documents/$docId'
    | '/workspaces/$workspaceId/employee-center/acknowledgments'
    | '/workspaces/$workspaceId/employee-center/anonymous-reporting'
    | '/workspaces/$workspaceId/employee-center/devices'
    | '/workspaces/$workspaceId/employee-center/inbox'
    | '/workspaces/$workspaceId/employee-center/org-chart'
    | '/workspaces/$workspaceId/employee-center/pending-policies'
    | '/workspaces/$workspaceId/employee-center/requests'
    | '/workspaces/$workspaceId/employee-center/tasks'
    | '/workspaces/$workspaceId/employee-center/training'
    | '/workspaces/$workspaceId/evidence-viewer/$evidencePackId'
    | '/workspaces/$workspaceId/evidence/creating'
    | '/workspaces/$workspaceId/integrations/$providerSlug'
    | '/workspaces/$workspaceId/people/me'
    | '/workspaces/$workspaceId/people/$employeeId'
    | '/workspaces/$workspaceId/people_groups/$groupId'
    | '/workspaces/$workspaceId/people_training/$programId'
    | '/workspaces/$workspaceId/policies/$policySlug'
    | '/workspaces/$workspaceId/questionnaires/$id'
    | '/workspaces/$workspaceId/reviews/access'
    | '/workspaces/$workspaceId/risks/$riskId'
    | '/workspaces/$workspaceId/runbooks/$runbookId'
    | '/workspaces/$workspaceId/runbooks/new'
    | '/workspaces/$workspaceId/runs/$executionId'
    | '/workspaces/$workspaceId/settings/api-keys'
    | '/workspaces/$workspaceId/settings/audit-logs'
    | '/workspaces/$workspaceId/settings/auth'
    | '/workspaces/$workspaceId/settings/billing'
    | '/workspaces/$workspaceId/settings/browser-extension'
    | '/workspaces/$workspaceId/settings/chat'
    | '/workspaces/$workspaceId/settings/checks'
    | '/workspaces/$workspaceId/settings/compliance-roles'
    | '/workspaces/$workspaceId/settings/configuration'
    | '/workspaces/$workspaceId/settings/data-export'
    | '/workspaces/$workspaceId/settings/email'
    | '/workspaces/$workspaceId/settings/exceptions'
    | '/workspaces/$workspaceId/settings/general'
    | '/workspaces/$workspaceId/settings/governance'
    | '/workspaces/$workspaceId/settings/imports'
    | '/workspaces/$workspaceId/settings/integrations'
    | '/workspaces/$workspaceId/settings/mcp-server'
    | '/workspaces/$workspaceId/settings/members'
    | '/workspaces/$workspaceId/settings/notifications'
    | '/workspaces/$workspaceId/settings/personal-tokens'
    | '/workspaces/$workspaceId/settings/personas'
    | '/workspaces/$workspaceId/settings/procedure-triggers'
    | '/workspaces/$workspaceId/settings/profile'
    | '/workspaces/$workspaceId/settings/program'
    | '/workspaces/$workspaceId/settings/properties'
    | '/workspaces/$workspaceId/settings/request-intake'
    | '/workspaces/$workspaceId/settings/review'
    | '/workspaces/$workspaceId/settings/security'
    | '/workspaces/$workspaceId/settings/signing'
    | '/workspaces/$workspaceId/settings/templates'
    | '/workspaces/$workspaceId/settings/theme'
    | '/workspaces/$workspaceId/settings/writing'
    | '/workspaces/$workspaceId/submissions/$submissionId'
    | '/workspaces/$workspaceId/tasks/$taskId'
    | '/workspaces/$workspaceId/tasks/detail'
    | '/workspaces/$workspaceId/templates/new'
    | '/workspaces/$workspaceId/templates/public'
    | '/workspaces/$workspaceId/vendors/$vendorId'
    | '/workspaces/$workspaceId/automation/identities'
    | '/workspaces/$workspaceId/deprecated/agent-reliability'
    | '/workspaces/$workspaceId/auditor-center'
    | '/workspaces/$workspaceId/audits'
    | '/workspaces/$workspaceId/employee-center'
    | '/workspaces/$workspaceId/frameworks'
    | '/workspaces/$workspaceId/populations'
    | '/workspaces/$workspaceId/runs'
    | '/workspaces/$workspaceId/settings'
    | '/workspaces/$workspaceId/templates'
    | '/workspaces/$workspaceId/automation'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/api-access'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/assets'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/controls'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/dashboard'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/evidence'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/open-requests'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/people'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/populations'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/request-list'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/risks'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/timeline'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/vendors'
    | '/workspaces/$workspaceId/employee-center/pending-policies/$templateId'
    | '/workspaces/$workspaceId/employee-center/requests/$taskId'
    | '/workspaces/$workspaceId/employee-center/tasks/$taskId'
    | '/workspaces/$workspaceId/employee-center/tests/$testId'
    | '/workspaces/$workspaceId/employee-center/training/$programId'
    | '/workspaces/$workspaceId/integrations/custom/$applicationId'
    | '/workspaces/$workspaceId/recordings/$flowId/edit'
    | '/workspaces/$workspaceId/reviews/access/$cycleId'
    | '/workspaces/$workspaceId/reviews/access/roles'
    | '/workspaces/$workspaceId/risks/assessments/$draftId'
    | '/workspaces/$workspaceId/templates/$templateId/edit'
    | '/workspaces/$workspaceId/tests/$testId/submissions'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId'
    | '/workspaces/$workspaceId/automation/$executionId'
    | '/workspaces/$workspaceId/deprecated/sources'
    | '/workspaces/$workspaceId/frameworks/$frameworkId'
    | '/workspaces/$workspaceId/templates/$templateId'
    | '/workspaces/$workspaceId/tests/$testId'
    | '/workspaces/$workspaceId/deprecated/integrations-old'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/assets/$assetId'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations/$providerSlug'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/people/$employeeId'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/populations/$populationId'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/risks/$riskId'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/vendors/$vendorId'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/policies/$policySlug'
    | '/workspaces/$workspaceId/integrations/$providerSlug/accounts/$connectionId'
    | '/workspaces/$workspaceId/integrations/$providerSlug/services/$serviceId'
    | '/workspaces/$workspaceId/reviews/access/period/$periodKey'
    | '/workspaces/$workspaceId/vendors/$vendorId/assessments/$assessmentId'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/audit-evidence'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/policies'
    | '/workspaces/$workspaceId/frameworks/$frameworkId/controls'
    | '/workspaces/$workspaceId/templates/control/$controlId'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/audit-evidence/$evidenceKind/$evidenceItemId'
    | '/workspaces/$workspaceId/deprecated/workflows/$workflowId/executions/$jobId'
    | '/workspaces/$workspaceId/integrations/custom/$applicationId/datasets/$datasetId'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations/$providerSlug/accounts/$connectionId'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations/$providerSlug/services/$serviceId'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/populations/$populationId/rounds/$sampleId'
    | '/workspaces/$workspaceId/auditor-center/$auditCycleId/vendors/$vendorId/reviews/$assessmentId'
  id:
    | '__root__'
    | '/(auth)'
    | '/(protected)'
    | '/extension-uninstalled'
    | '/(auth)/onboarding'
    | '/(protected)/orgs'
    | '/(protected)/partner'
    | '/(protected)/workspaces'
    | '/(auth)/accept-invitation'
    | '/(auth)/invite'
    | '/(auth)/login'
    | '/(auth)/logout'
    | '/(auth)/otp'
    | '/(auth)/reset-password'
    | '/(auth)/share-invite'
    | '/(auth)/verify-email'
    | '/(protected)/auditor-center'
    | '/integrations/github-app-callback'
    | '/oauth/consent'
    | '/trust/$slug'
    | '/(auth)/forgot-password'
    | '/(auth)/login-2'
    | '/(auth)/setup-mfa'
    | '/(auth)/signup'
    | '/(auth)/verify-2fa'
    | '/(auth)/verify-otp'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/shared/$shareId'
    | '/(protected)/'
    | '/(protected)/orgs/$slug'
    | '/(protected)/workspaces/$workspaceId'
    | '/(auth)/auth-callback/$provider'
    | '/(auth)/native/auth-callback'
    | '/(auth)/native/login'
    | '/(auth)/onboarding/extension'
    | '/(auth)/onboarding/preferences'
    | '/(auth)/onboarding/quick-setup'
    | '/(auth)/onboarding/team'
    | '/(protected)/auditor-center/profile'
    | '/(protected)/auditor-center/security'
    | '/(protected)/dev/plan-restrictions-test'
    | '/(protected)/partner/templates'
    | '/(protected)/workspaces/new'
    | '/demo/tiptap/ai-changes'
    | '/demo/tiptap/ai-suggestion'
    | '/trust/access/$token'
    | '/trust/nda/$token'
    | '/trust/resources/$resourceId'
    | '/(protected)/auditor-center/'
    | '/(protected)/partner/'
    | '/demo/tiptap/'
    | '/evidence/verify/'
    | '/export/evidence-pdf/'
    | '/export/org-chart/'
    | '/export/policy-pdf/'
    | '/export/topic-embed/'
    | '/export/topic-pdf/'
    | '/(protected)/onboarding/'
    | '/(protected)/orgs/'
    | '/(protected)/workspaces/'
    | '/(protected)/workspaces/$workspaceId/auditor-center'
    | '/(protected)/workspaces/$workspaceId/employee-center'
    | '/(protected)/workspaces/$workspaceId/settings'
    | '/(protected)/partner/clients/$clientId'
    | '/(protected)/partner/clients/new'
    | '/(protected)/workspace/integrations/github'
    | '/(protected)/workspaces/$workspaceId/anonymous-reports'
    | '/(protected)/workspaces/$workspaceId/approvals'
    | '/(protected)/workspaces/$workspaceId/assets'
    | '/(protected)/workspaces/$workspaceId/connect-repo'
    | '/(protected)/workspaces/$workspaceId/connect-tools'
    | '/(protected)/workspaces/$workspaceId/controls'
    | '/(protected)/workspaces/$workspaceId/dashboard'
    | '/(protected)/workspaces/$workspaceId/documents'
    | '/(protected)/workspaces/$workspaceId/evidence'
    | '/(protected)/workspaces/$workspaceId/evidence-slots'
    | '/(protected)/workspaces/$workspaceId/guide'
    | '/(protected)/workspaces/$workspaceId/inbox'
    | '/(protected)/workspaces/$workspaceId/integrations'
    | '/(protected)/workspaces/$workspaceId/monitoring'
    | '/(protected)/workspaces/$workspaceId/onboarding'
    | '/(protected)/workspaces/$workspaceId/people'
    | '/(protected)/workspaces/$workspaceId/policies'
    | '/(protected)/workspaces/$workspaceId/questionnaires'
    | '/(protected)/workspaces/$workspaceId/readiness'
    | '/(protected)/workspaces/$workspaceId/risks'
    | '/(protected)/workspaces/$workspaceId/runbooks'
    | '/(protected)/workspaces/$workspaceId/setup'
    | '/(protected)/workspaces/$workspaceId/statement-of-applicability'
    | '/(protected)/workspaces/$workspaceId/system-description'
    | '/(protected)/workspaces/$workspaceId/tasks'
    | '/(protected)/workspaces/$workspaceId/tests'
    | '/(protected)/workspaces/$workspaceId/trust-center'
    | '/(protected)/workspaces/$workspaceId/vendors'
    | '/(protected)/onboarding/$organizationId/workspace'
    | '/(protected)/workspace/integrations/'
    | '/(protected)/workspaces/$workspaceId/'
    | '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId'
    | '/(protected)/workspaces/$workspaceId/anonymous-reports_/$reportId'
    | '/(protected)/workspaces/$workspaceId/assets_/$assetId'
    | '/(protected)/workspaces/$workspaceId/auditor-center/api-access'
    | '/(protected)/workspaces/$workspaceId/audits/$auditCycleId'
    | '/(protected)/workspaces/$workspaceId/chat_/$threadId'
    | '/(protected)/workspaces/$workspaceId/controls_/$controlDefId'
    | '/(protected)/workspaces/$workspaceId/deprecated/compliance-route-old'
    | '/(protected)/workspaces/$workspaceId/dev/tool-ui'
    | '/(protected)/workspaces/$workspaceId/devices_/$deviceId'
    | '/(protected)/workspaces/$workspaceId/documents_/$docId'
    | '/(protected)/workspaces/$workspaceId/employee-center/acknowledgments'
    | '/(protected)/workspaces/$workspaceId/employee-center/anonymous-reporting'
    | '/(protected)/workspaces/$workspaceId/employee-center/devices'
    | '/(protected)/workspaces/$workspaceId/employee-center/inbox'
    | '/(protected)/workspaces/$workspaceId/employee-center/org-chart'
    | '/(protected)/workspaces/$workspaceId/employee-center/pending-policies'
    | '/(protected)/workspaces/$workspaceId/employee-center/requests'
    | '/(protected)/workspaces/$workspaceId/employee-center/tasks'
    | '/(protected)/workspaces/$workspaceId/employee-center/training'
    | '/(protected)/workspaces/$workspaceId/evidence-viewer/$evidencePackId'
    | '/(protected)/workspaces/$workspaceId/evidence_/creating'
    | '/(protected)/workspaces/$workspaceId/integrations_/$providerSlug'
    | '/(protected)/workspaces/$workspaceId/people/me'
    | '/(protected)/workspaces/$workspaceId/people_/$employeeId'
    | '/(protected)/workspaces/$workspaceId/people_groups/$groupId'
    | '/(protected)/workspaces/$workspaceId/people_training/$programId'
    | '/(protected)/workspaces/$workspaceId/policies_/$policySlug'
    | '/(protected)/workspaces/$workspaceId/questionnaires_/$id'
    | '/(protected)/workspaces/$workspaceId/reviews/access'
    | '/(protected)/workspaces/$workspaceId/risks_/$riskId'
    | '/(protected)/workspaces/$workspaceId/runbooks_/$runbookId'
    | '/(protected)/workspaces/$workspaceId/runbooks_/new'
    | '/(protected)/workspaces/$workspaceId/runs/$executionId'
    | '/(protected)/workspaces/$workspaceId/settings/api-keys'
    | '/(protected)/workspaces/$workspaceId/settings/audit-logs'
    | '/(protected)/workspaces/$workspaceId/settings/auth'
    | '/(protected)/workspaces/$workspaceId/settings/billing'
    | '/(protected)/workspaces/$workspaceId/settings/browser-extension'
    | '/(protected)/workspaces/$workspaceId/settings/chat'
    | '/(protected)/workspaces/$workspaceId/settings/checks'
    | '/(protected)/workspaces/$workspaceId/settings/compliance-roles'
    | '/(protected)/workspaces/$workspaceId/settings/configuration'
    | '/(protected)/workspaces/$workspaceId/settings/data-export'
    | '/(protected)/workspaces/$workspaceId/settings/email'
    | '/(protected)/workspaces/$workspaceId/settings/exceptions'
    | '/(protected)/workspaces/$workspaceId/settings/general'
    | '/(protected)/workspaces/$workspaceId/settings/governance'
    | '/(protected)/workspaces/$workspaceId/settings/imports'
    | '/(protected)/workspaces/$workspaceId/settings/integrations'
    | '/(protected)/workspaces/$workspaceId/settings/mcp-server'
    | '/(protected)/workspaces/$workspaceId/settings/members'
    | '/(protected)/workspaces/$workspaceId/settings/notifications'
    | '/(protected)/workspaces/$workspaceId/settings/personal-tokens'
    | '/(protected)/workspaces/$workspaceId/settings/personas'
    | '/(protected)/workspaces/$workspaceId/settings/procedure-triggers'
    | '/(protected)/workspaces/$workspaceId/settings/profile'
    | '/(protected)/workspaces/$workspaceId/settings/program'
    | '/(protected)/workspaces/$workspaceId/settings/properties'
    | '/(protected)/workspaces/$workspaceId/settings/request-intake'
    | '/(protected)/workspaces/$workspaceId/settings/review'
    | '/(protected)/workspaces/$workspaceId/settings/security'
    | '/(protected)/workspaces/$workspaceId/settings/signing'
    | '/(protected)/workspaces/$workspaceId/settings/templates'
    | '/(protected)/workspaces/$workspaceId/settings/theme'
    | '/(protected)/workspaces/$workspaceId/settings/writing'
    | '/(protected)/workspaces/$workspaceId/submissions/$submissionId'
    | '/(protected)/workspaces/$workspaceId/tasks_/$taskId'
    | '/(protected)/workspaces/$workspaceId/tasks_/detail'
    | '/(protected)/workspaces/$workspaceId/templates/new'
    | '/(protected)/workspaces/$workspaceId/templates/public'
    | '/(protected)/workspaces/$workspaceId/vendors_/$vendorId'
    | '/(protected)/workspaces/$workspaceId/automation/identities'
    | '/(protected)/workspaces/$workspaceId/deprecated/agent-reliability'
    | '/(protected)/workspaces/$workspaceId/auditor-center/'
    | '/(protected)/workspaces/$workspaceId/audits/'
    | '/(protected)/workspaces/$workspaceId/employee-center/'
    | '/(protected)/workspaces/$workspaceId/frameworks/'
    | '/(protected)/workspaces/$workspaceId/populations/'
    | '/(protected)/workspaces/$workspaceId/runs/'
    | '/(protected)/workspaces/$workspaceId/settings/'
    | '/(protected)/workspaces/$workspaceId/templates/'
    | '/(protected)/workspaces/$workspaceId/automation/'
    | '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/audit-evidence'
    | '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId_/policies'
    | '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/api-access'
    | '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/assets'
    | '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/controls'
    | '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/dashboard'
    | '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/evidence'
    | '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations'
    | '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/open-requests'
    | '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/people'
    | '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/populations'
    | '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/request-list'
    | '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/risks'
    | '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/timeline'
    | '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/vendors'
    | '/(protected)/workspaces/$workspaceId/employee-center/pending-policies_/$templateId'
    | '/(protected)/workspaces/$workspaceId/employee-center/requests_/$taskId'
    | '/(protected)/workspaces/$workspaceId/employee-center/tasks_/$taskId'
    | '/(protected)/workspaces/$workspaceId/employee-center/tests_/$testId'
    | '/(protected)/workspaces/$workspaceId/employee-center/training_/$programId'
    | '/(protected)/workspaces/$workspaceId/integrations_/custom/$applicationId'
    | '/(protected)/workspaces/$workspaceId/recordings_/$flowId/edit'
    | '/(protected)/workspaces/$workspaceId/reviews/access_/$cycleId'
    | '/(protected)/workspaces/$workspaceId/reviews/access_/roles'
    | '/(protected)/workspaces/$workspaceId/risks_/assessments/$draftId'
    | '/(protected)/workspaces/$workspaceId/templates/$templateId/edit'
    | '/(protected)/workspaces/$workspaceId/tests_/$testId/submissions'
    | '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/'
    | '/(protected)/workspaces/$workspaceId/automation/$executionId/'
    | '/(protected)/workspaces/$workspaceId/deprecated/sources/'
    | '/(protected)/workspaces/$workspaceId/frameworks/$frameworkId/'
    | '/(protected)/workspaces/$workspaceId/templates/$templateId/'
    | '/(protected)/workspaces/$workspaceId/tests_/$testId/'
    | '/(protected)/workspaces/$workspaceId/deprecated/integrations-old/'
    | '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/assets_/$assetId'
    | '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations_/$providerSlug'
    | '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/people_/$employeeId'
    | '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/populations_/$populationId'
    | '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/risks_/$riskId'
    | '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/vendors_/$vendorId'
    | '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId_/policies/$policySlug'
    | '/(protected)/workspaces/$workspaceId/integrations_/$providerSlug_/accounts/$connectionId'
    | '/(protected)/workspaces/$workspaceId/integrations_/$providerSlug_/services/$serviceId'
    | '/(protected)/workspaces/$workspaceId/reviews/access_/period/$periodKey'
    | '/(protected)/workspaces/$workspaceId/vendors_/$vendorId_/assessments/$assessmentId'
    | '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/audit-evidence/'
    | '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId_/policies/'
    | '/(protected)/workspaces/$workspaceId/frameworks/$frameworkId/controls/'
    | '/(protected)/workspaces/$workspaceId/templates/control/$controlId/'
    | '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/audit-evidence/$evidenceKind/$evidenceItemId'
    | '/(protected)/workspaces/$workspaceId/deprecated/workflows/$workflowId/executions/$jobId'
    | '/(protected)/workspaces/$workspaceId/integrations_/custom/$applicationId_/datasets/$datasetId'
    | '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations_/$providerSlug_/accounts/$connectionId'
    | '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations_/$providerSlug_/services/$serviceId'
    | '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/populations_/$populationId_/rounds/$sampleId'
    | '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/vendors_/$vendorId_/reviews/$assessmentId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  authRouteRoute: typeof authRouteRouteWithChildren
  protectedRouteRoute: typeof protectedRouteRouteWithChildren
  ExtensionUninstalledLazyRoute: typeof ExtensionUninstalledLazyRoute
  IntegrationsGithubAppCallbackRoute: typeof IntegrationsGithubAppCallbackRoute
  OauthConsentRoute: typeof OauthConsentRoute
  TrustSlugRoute: typeof TrustSlugRoute
  errors401LazyRoute: typeof errors401LazyRoute
  errors403LazyRoute: typeof errors403LazyRoute
  errors404LazyRoute: typeof errors404LazyRoute
  errors500LazyRoute: typeof errors500LazyRoute
  errors503LazyRoute: typeof errors503LazyRoute
  SharedShareIdLazyRoute: typeof SharedShareIdLazyRoute
  DemoTiptapAiChangesRoute: typeof DemoTiptapAiChangesRoute
  DemoTiptapAiSuggestionRoute: typeof DemoTiptapAiSuggestionRoute
  TrustAccessTokenRoute: typeof TrustAccessTokenRoute
  TrustNdaTokenRoute: typeof TrustNdaTokenRoute
  TrustResourcesResourceIdRoute: typeof TrustResourcesResourceIdRoute
  DemoTiptapIndexRoute: typeof DemoTiptapIndexRoute
  EvidenceVerifyIndexRoute: typeof EvidenceVerifyIndexRoute
  ExportEvidencePdfIndexRoute: typeof ExportEvidencePdfIndexRoute
  ExportOrgChartIndexRoute: typeof ExportOrgChartIndexRoute
  ExportPolicyPdfIndexRoute: typeof ExportPolicyPdfIndexRoute
  ExportTopicEmbedIndexRoute: typeof ExportTopicEmbedIndexRoute
  ExportTopicPdfIndexRoute: typeof ExportTopicPdfIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/extension-uninstalled': {
      id: '/extension-uninstalled'
      path: '/extension-uninstalled'
      fullPath: '/extension-uninstalled'
      preLoaderRoute: typeof ExtensionUninstalledLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(protected)': {
      id: '/(protected)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof protectedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)': {
      id: '/(auth)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof authRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(protected)/': {
      id: '/(protected)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof protectedIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/shared/$shareId': {
      id: '/shared/$shareId'
      path: '/shared/$shareId'
      fullPath: '/shared/$shareId'
      preLoaderRoute: typeof SharedShareIdLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401LazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/verify-otp': {
      id: '/(auth)/verify-otp'
      path: '/verify-otp'
      fullPath: '/verify-otp'
      preLoaderRoute: typeof authVerifyOtpLazyRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/verify-2fa': {
      id: '/(auth)/verify-2fa'
      path: '/verify-2fa'
      fullPath: '/verify-2fa'
      preLoaderRoute: typeof authVerify2faLazyRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/signup': {
      id: '/(auth)/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof authSignupLazyRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/setup-mfa': {
      id: '/(auth)/setup-mfa'
      path: '/setup-mfa'
      fullPath: '/setup-mfa'
      preLoaderRoute: typeof authSetupMfaLazyRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/login-2': {
      id: '/(auth)/login-2'
      path: '/login-2'
      fullPath: '/login-2'
      preLoaderRoute: typeof authLogin2LazyRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordLazyRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/trust/$slug': {
      id: '/trust/$slug'
      path: '/trust/$slug'
      fullPath: '/trust/$slug'
      preLoaderRoute: typeof TrustSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/consent': {
      id: '/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof OauthConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/github-app-callback': {
      id: '/integrations/github-app-callback'
      path: '/integrations/github-app-callback'
      fullPath: '/integrations/github-app-callback'
      preLoaderRoute: typeof IntegrationsGithubAppCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(protected)/auditor-center': {
      id: '/(protected)/auditor-center'
      path: '/auditor-center'
      fullPath: '/auditor-center'
      preLoaderRoute: typeof protectedAuditorCenterRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(auth)/verify-email': {
      id: '/(auth)/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof authVerifyEmailRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/share-invite': {
      id: '/(auth)/share-invite'
      path: '/share-invite'
      fullPath: '/share-invite'
      preLoaderRoute: typeof authShareInviteRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/reset-password': {
      id: '/(auth)/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof authResetPasswordRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/otp': {
      id: '/(auth)/otp'
      path: '/otp'
      fullPath: '/otp'
      preLoaderRoute: typeof authOtpRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/logout': {
      id: '/(auth)/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof authLogoutRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/login': {
      id: '/(auth)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof authLoginRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/invite': {
      id: '/(auth)/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof authInviteRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/accept-invitation': {
      id: '/(auth)/accept-invitation'
      path: '/accept-invitation'
      fullPath: '/accept-invitation'
      preLoaderRoute: typeof authAcceptInvitationRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(protected)/workspaces': {
      id: '/(protected)/workspaces'
      path: '/workspaces'
      fullPath: '/workspaces'
      preLoaderRoute: typeof protectedWorkspacesRouteRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/partner': {
      id: '/(protected)/partner'
      path: '/partner'
      fullPath: '/partner'
      preLoaderRoute: typeof protectedPartnerRouteRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/orgs': {
      id: '/(protected)/orgs'
      path: '/orgs'
      fullPath: '/orgs'
      preLoaderRoute: typeof protectedOrgsRouteRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(auth)/onboarding': {
      id: '/(auth)/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof authOnboardingRouteRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(protected)/workspaces/': {
      id: '/(protected)/workspaces/'
      path: '/'
      fullPath: '/workspaces/'
      preLoaderRoute: typeof protectedWorkspacesIndexLazyRouteImport
      parentRoute: typeof protectedWorkspacesRouteRoute
    }
    '/(protected)/orgs/': {
      id: '/(protected)/orgs/'
      path: '/'
      fullPath: '/orgs/'
      preLoaderRoute: typeof protectedOrgsIndexLazyRouteImport
      parentRoute: typeof protectedOrgsRouteRoute
    }
    '/(protected)/onboarding/': {
      id: '/(protected)/onboarding/'
      path: '/onboarding'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof protectedOnboardingIndexLazyRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/export/topic-pdf/': {
      id: '/export/topic-pdf/'
      path: '/export/topic-pdf'
      fullPath: '/export/topic-pdf/'
      preLoaderRoute: typeof ExportTopicPdfIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/export/topic-embed/': {
      id: '/export/topic-embed/'
      path: '/export/topic-embed'
      fullPath: '/export/topic-embed/'
      preLoaderRoute: typeof ExportTopicEmbedIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/export/policy-pdf/': {
      id: '/export/policy-pdf/'
      path: '/export/policy-pdf'
      fullPath: '/export/policy-pdf/'
      preLoaderRoute: typeof ExportPolicyPdfIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/export/org-chart/': {
      id: '/export/org-chart/'
      path: '/export/org-chart'
      fullPath: '/export/org-chart/'
      preLoaderRoute: typeof ExportOrgChartIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/export/evidence-pdf/': {
      id: '/export/evidence-pdf/'
      path: '/export/evidence-pdf'
      fullPath: '/export/evidence-pdf/'
      preLoaderRoute: typeof ExportEvidencePdfIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/evidence/verify/': {
      id: '/evidence/verify/'
      path: '/evidence/verify'
      fullPath: '/evidence/verify/'
      preLoaderRoute: typeof EvidenceVerifyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo/tiptap/': {
      id: '/demo/tiptap/'
      path: '/demo/tiptap'
      fullPath: '/demo/tiptap/'
      preLoaderRoute: typeof DemoTiptapIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(protected)/partner/': {
      id: '/(protected)/partner/'
      path: '/'
      fullPath: '/partner/'
      preLoaderRoute: typeof protectedPartnerIndexRouteImport
      parentRoute: typeof protectedPartnerRouteRoute
    }
    '/(protected)/auditor-center/': {
      id: '/(protected)/auditor-center/'
      path: '/'
      fullPath: '/auditor-center/'
      preLoaderRoute: typeof protectedAuditorCenterIndexRouteImport
      parentRoute: typeof protectedAuditorCenterRoute
    }
    '/trust/resources/$resourceId': {
      id: '/trust/resources/$resourceId'
      path: '/trust/resources/$resourceId'
      fullPath: '/trust/resources/$resourceId'
      preLoaderRoute: typeof TrustResourcesResourceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trust/nda/$token': {
      id: '/trust/nda/$token'
      path: '/trust/nda/$token'
      fullPath: '/trust/nda/$token'
      preLoaderRoute: typeof TrustNdaTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trust/access/$token': {
      id: '/trust/access/$token'
      path: '/trust/access/$token'
      fullPath: '/trust/access/$token'
      preLoaderRoute: typeof TrustAccessTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo/tiptap/ai-suggestion': {
      id: '/demo/tiptap/ai-suggestion'
      path: '/demo/tiptap/ai-suggestion'
      fullPath: '/demo/tiptap/ai-suggestion'
      preLoaderRoute: typeof DemoTiptapAiSuggestionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo/tiptap/ai-changes': {
      id: '/demo/tiptap/ai-changes'
      path: '/demo/tiptap/ai-changes'
      fullPath: '/demo/tiptap/ai-changes'
      preLoaderRoute: typeof DemoTiptapAiChangesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(protected)/workspaces/new': {
      id: '/(protected)/workspaces/new'
      path: '/new'
      fullPath: '/workspaces/new'
      preLoaderRoute: typeof protectedWorkspacesNewRouteImport
      parentRoute: typeof protectedWorkspacesRouteRoute
    }
    '/(protected)/partner/templates': {
      id: '/(protected)/partner/templates'
      path: '/templates'
      fullPath: '/partner/templates'
      preLoaderRoute: typeof protectedPartnerTemplatesRouteImport
      parentRoute: typeof protectedPartnerRouteRoute
    }
    '/(protected)/dev/plan-restrictions-test': {
      id: '/(protected)/dev/plan-restrictions-test'
      path: '/dev/plan-restrictions-test'
      fullPath: '/dev/plan-restrictions-test'
      preLoaderRoute: typeof protectedDevPlanRestrictionsTestRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/auditor-center/security': {
      id: '/(protected)/auditor-center/security'
      path: '/security'
      fullPath: '/auditor-center/security'
      preLoaderRoute: typeof protectedAuditorCenterSecurityRouteImport
      parentRoute: typeof protectedAuditorCenterRoute
    }
    '/(protected)/auditor-center/profile': {
      id: '/(protected)/auditor-center/profile'
      path: '/profile'
      fullPath: '/auditor-center/profile'
      preLoaderRoute: typeof protectedAuditorCenterProfileRouteImport
      parentRoute: typeof protectedAuditorCenterRoute
    }
    '/(auth)/onboarding/team': {
      id: '/(auth)/onboarding/team'
      path: '/team'
      fullPath: '/onboarding/team'
      preLoaderRoute: typeof authOnboardingTeamRouteImport
      parentRoute: typeof authOnboardingRouteRoute
    }
    '/(auth)/onboarding/quick-setup': {
      id: '/(auth)/onboarding/quick-setup'
      path: '/quick-setup'
      fullPath: '/onboarding/quick-setup'
      preLoaderRoute: typeof authOnboardingQuickSetupRouteImport
      parentRoute: typeof authOnboardingRouteRoute
    }
    '/(auth)/onboarding/preferences': {
      id: '/(auth)/onboarding/preferences'
      path: '/preferences'
      fullPath: '/onboarding/preferences'
      preLoaderRoute: typeof authOnboardingPreferencesRouteImport
      parentRoute: typeof authOnboardingRouteRoute
    }
    '/(auth)/onboarding/extension': {
      id: '/(auth)/onboarding/extension'
      path: '/extension'
      fullPath: '/onboarding/extension'
      preLoaderRoute: typeof authOnboardingExtensionRouteImport
      parentRoute: typeof authOnboardingRouteRoute
    }
    '/(auth)/native/login': {
      id: '/(auth)/native/login'
      path: '/native/login'
      fullPath: '/native/login'
      preLoaderRoute: typeof authNativeLoginRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/native/auth-callback': {
      id: '/(auth)/native/auth-callback'
      path: '/native/auth-callback'
      fullPath: '/native/auth-callback'
      preLoaderRoute: typeof authNativeAuthCallbackRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/auth-callback/$provider': {
      id: '/(auth)/auth-callback/$provider'
      path: '/auth-callback/$provider'
      fullPath: '/auth-callback/$provider'
      preLoaderRoute: typeof authAuthCallbackProviderRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(protected)/workspaces/$workspaceId': {
      id: '/(protected)/workspaces/$workspaceId'
      path: '/$workspaceId'
      fullPath: '/workspaces/$workspaceId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdRouteRouteImport
      parentRoute: typeof protectedWorkspacesRouteRoute
    }
    '/(protected)/orgs/$slug': {
      id: '/(protected)/orgs/$slug'
      path: '/$slug'
      fullPath: '/orgs/$slug'
      preLoaderRoute: typeof protectedOrgsSlugRouteRouteImport
      parentRoute: typeof protectedOrgsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/': {
      id: '/(protected)/workspaces/$workspaceId/'
      path: '/'
      fullPath: '/workspaces/$workspaceId/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspace/integrations/': {
      id: '/(protected)/workspace/integrations/'
      path: '/workspace/integrations'
      fullPath: '/workspace/integrations/'
      preLoaderRoute: typeof protectedWorkspaceIntegrationsIndexRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/onboarding/$organizationId/workspace': {
      id: '/(protected)/onboarding/$organizationId/workspace'
      path: '/onboarding/$organizationId/workspace'
      fullPath: '/onboarding/$organizationId/workspace'
      preLoaderRoute: typeof protectedOnboardingOrganizationIdWorkspaceLazyRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/vendors': {
      id: '/(protected)/workspaces/$workspaceId/vendors'
      path: '/vendors'
      fullPath: '/workspaces/$workspaceId/vendors'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdVendorsRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/trust-center': {
      id: '/(protected)/workspaces/$workspaceId/trust-center'
      path: '/trust-center'
      fullPath: '/workspaces/$workspaceId/trust-center'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdTrustCenterRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/tests': {
      id: '/(protected)/workspaces/$workspaceId/tests'
      path: '/tests'
      fullPath: '/workspaces/$workspaceId/tests'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdTestsRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/tasks': {
      id: '/(protected)/workspaces/$workspaceId/tasks'
      path: '/tasks'
      fullPath: '/workspaces/$workspaceId/tasks'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdTasksRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/system-description': {
      id: '/(protected)/workspaces/$workspaceId/system-description'
      path: '/system-description'
      fullPath: '/workspaces/$workspaceId/system-description'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSystemDescriptionRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/statement-of-applicability': {
      id: '/(protected)/workspaces/$workspaceId/statement-of-applicability'
      path: '/statement-of-applicability'
      fullPath: '/workspaces/$workspaceId/statement-of-applicability'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdStatementOfApplicabilityRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/setup': {
      id: '/(protected)/workspaces/$workspaceId/setup'
      path: '/setup'
      fullPath: '/workspaces/$workspaceId/setup'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSetupRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/runbooks': {
      id: '/(protected)/workspaces/$workspaceId/runbooks'
      path: '/runbooks'
      fullPath: '/workspaces/$workspaceId/runbooks'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdRunbooksRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/risks': {
      id: '/(protected)/workspaces/$workspaceId/risks'
      path: '/risks'
      fullPath: '/workspaces/$workspaceId/risks'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdRisksRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/readiness': {
      id: '/(protected)/workspaces/$workspaceId/readiness'
      path: '/readiness'
      fullPath: '/workspaces/$workspaceId/readiness'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdReadinessRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/questionnaires': {
      id: '/(protected)/workspaces/$workspaceId/questionnaires'
      path: '/questionnaires'
      fullPath: '/workspaces/$workspaceId/questionnaires'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdQuestionnairesRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/policies': {
      id: '/(protected)/workspaces/$workspaceId/policies'
      path: '/policies'
      fullPath: '/workspaces/$workspaceId/policies'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdPoliciesRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/people': {
      id: '/(protected)/workspaces/$workspaceId/people'
      path: '/people'
      fullPath: '/workspaces/$workspaceId/people'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdPeopleRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/onboarding': {
      id: '/(protected)/workspaces/$workspaceId/onboarding'
      path: '/onboarding'
      fullPath: '/workspaces/$workspaceId/onboarding'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdOnboardingRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/monitoring': {
      id: '/(protected)/workspaces/$workspaceId/monitoring'
      path: '/monitoring'
      fullPath: '/workspaces/$workspaceId/monitoring'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdMonitoringRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/integrations': {
      id: '/(protected)/workspaces/$workspaceId/integrations'
      path: '/integrations'
      fullPath: '/workspaces/$workspaceId/integrations'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdIntegrationsRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/inbox': {
      id: '/(protected)/workspaces/$workspaceId/inbox'
      path: '/inbox'
      fullPath: '/workspaces/$workspaceId/inbox'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdInboxRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/guide': {
      id: '/(protected)/workspaces/$workspaceId/guide'
      path: '/guide'
      fullPath: '/workspaces/$workspaceId/guide'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdGuideRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/evidence-slots': {
      id: '/(protected)/workspaces/$workspaceId/evidence-slots'
      path: '/evidence-slots'
      fullPath: '/workspaces/$workspaceId/evidence-slots'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdEvidenceSlotsRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/evidence': {
      id: '/(protected)/workspaces/$workspaceId/evidence'
      path: '/evidence'
      fullPath: '/workspaces/$workspaceId/evidence'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdEvidenceRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/documents': {
      id: '/(protected)/workspaces/$workspaceId/documents'
      path: '/documents'
      fullPath: '/workspaces/$workspaceId/documents'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdDocumentsRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/dashboard': {
      id: '/(protected)/workspaces/$workspaceId/dashboard'
      path: '/dashboard'
      fullPath: '/workspaces/$workspaceId/dashboard'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdDashboardRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/controls': {
      id: '/(protected)/workspaces/$workspaceId/controls'
      path: '/controls'
      fullPath: '/workspaces/$workspaceId/controls'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdControlsRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/connect-tools': {
      id: '/(protected)/workspaces/$workspaceId/connect-tools'
      path: '/connect-tools'
      fullPath: '/workspaces/$workspaceId/connect-tools'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdConnectToolsRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/connect-repo': {
      id: '/(protected)/workspaces/$workspaceId/connect-repo'
      path: '/connect-repo'
      fullPath: '/workspaces/$workspaceId/connect-repo'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdConnectRepoRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/assets': {
      id: '/(protected)/workspaces/$workspaceId/assets'
      path: '/assets'
      fullPath: '/workspaces/$workspaceId/assets'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAssetsRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/approvals': {
      id: '/(protected)/workspaces/$workspaceId/approvals'
      path: '/approvals'
      fullPath: '/workspaces/$workspaceId/approvals'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdApprovalsRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/anonymous-reports': {
      id: '/(protected)/workspaces/$workspaceId/anonymous-reports'
      path: '/anonymous-reports'
      fullPath: '/workspaces/$workspaceId/anonymous-reports'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAnonymousReportsRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspace/integrations/github': {
      id: '/(protected)/workspace/integrations/github'
      path: '/workspace/integrations/github'
      fullPath: '/workspace/integrations/github'
      preLoaderRoute: typeof protectedWorkspaceIntegrationsGithubRouteImport
      parentRoute: typeof protectedRouteRoute
    }
    '/(protected)/partner/clients/new': {
      id: '/(protected)/partner/clients/new'
      path: '/clients/new'
      fullPath: '/partner/clients/new'
      preLoaderRoute: typeof protectedPartnerClientsNewRouteImport
      parentRoute: typeof protectedPartnerRouteRoute
    }
    '/(protected)/partner/clients/$clientId': {
      id: '/(protected)/partner/clients/$clientId'
      path: '/clients/$clientId'
      fullPath: '/partner/clients/$clientId'
      preLoaderRoute: typeof protectedPartnerClientsClientIdRouteImport
      parentRoute: typeof protectedPartnerRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/settings': {
      id: '/(protected)/workspaces/$workspaceId/settings'
      path: '/settings'
      fullPath: '/workspaces/$workspaceId/settings'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSettingsRouteRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/employee-center': {
      id: '/(protected)/workspaces/$workspaceId/employee-center'
      path: '/employee-center'
      fullPath: '/workspaces/$workspaceId/employee-center'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterRouteRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/auditor-center': {
      id: '/(protected)/workspaces/$workspaceId/auditor-center'
      path: '/auditor-center'
      fullPath: '/workspaces/$workspaceId/auditor-center'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterRouteRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/automation/': {
      id: '/(protected)/workspaces/$workspaceId/automation/'
      path: '/automation'
      fullPath: '/workspaces/$workspaceId/automation/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAutomationIndexLazyRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/templates/': {
      id: '/(protected)/workspaces/$workspaceId/templates/'
      path: '/templates'
      fullPath: '/workspaces/$workspaceId/templates/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdTemplatesIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/settings/': {
      id: '/(protected)/workspaces/$workspaceId/settings/'
      path: '/'
      fullPath: '/workspaces/$workspaceId/settings/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSettingsIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/runs/': {
      id: '/(protected)/workspaces/$workspaceId/runs/'
      path: '/runs'
      fullPath: '/workspaces/$workspaceId/runs/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdRunsIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/populations/': {
      id: '/(protected)/workspaces/$workspaceId/populations/'
      path: '/populations'
      fullPath: '/workspaces/$workspaceId/populations/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdPopulationsIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/frameworks/': {
      id: '/(protected)/workspaces/$workspaceId/frameworks/'
      path: '/frameworks'
      fullPath: '/workspaces/$workspaceId/frameworks/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdFrameworksIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/employee-center/': {
      id: '/(protected)/workspaces/$workspaceId/employee-center/'
      path: '/'
      fullPath: '/workspaces/$workspaceId/employee-center/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/audits/': {
      id: '/(protected)/workspaces/$workspaceId/audits/'
      path: '/audits'
      fullPath: '/workspaces/$workspaceId/audits/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAuditsIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/auditor-center/': {
      id: '/(protected)/workspaces/$workspaceId/auditor-center/'
      path: '/'
      fullPath: '/workspaces/$workspaceId/auditor-center/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/deprecated/agent-reliability': {
      id: '/(protected)/workspaces/$workspaceId/deprecated/agent-reliability'
      path: '/deprecated/agent-reliability'
      fullPath: '/workspaces/$workspaceId/deprecated/agent-reliability'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdDeprecatedAgentReliabilityLazyRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/automation/identities': {
      id: '/(protected)/workspaces/$workspaceId/automation/identities'
      path: '/automation/identities'
      fullPath: '/workspaces/$workspaceId/automation/identities'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAutomationIdentitiesLazyRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/vendors_/$vendorId': {
      id: '/(protected)/workspaces/$workspaceId/vendors_/$vendorId'
      path: '/vendors/$vendorId'
      fullPath: '/workspaces/$workspaceId/vendors/$vendorId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdVendorsVendorIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/templates/public': {
      id: '/(protected)/workspaces/$workspaceId/templates/public'
      path: '/templates/public'
      fullPath: '/workspaces/$workspaceId/templates/public'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdTemplatesPublicRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/templates/new': {
      id: '/(protected)/workspaces/$workspaceId/templates/new'
      path: '/templates/new'
      fullPath: '/workspaces/$workspaceId/templates/new'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdTemplatesNewRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/tasks_/detail': {
      id: '/(protected)/workspaces/$workspaceId/tasks_/detail'
      path: '/tasks/detail'
      fullPath: '/workspaces/$workspaceId/tasks/detail'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdTasksDetailRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/tasks_/$taskId': {
      id: '/(protected)/workspaces/$workspaceId/tasks_/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/workspaces/$workspaceId/tasks/$taskId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdTasksTaskIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/submissions/$submissionId': {
      id: '/(protected)/workspaces/$workspaceId/submissions/$submissionId'
      path: '/submissions/$submissionId'
      fullPath: '/workspaces/$workspaceId/submissions/$submissionId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSubmissionsSubmissionIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/settings/writing': {
      id: '/(protected)/workspaces/$workspaceId/settings/writing'
      path: '/writing'
      fullPath: '/workspaces/$workspaceId/settings/writing'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSettingsWritingRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/settings/theme': {
      id: '/(protected)/workspaces/$workspaceId/settings/theme'
      path: '/theme'
      fullPath: '/workspaces/$workspaceId/settings/theme'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSettingsThemeRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/settings/templates': {
      id: '/(protected)/workspaces/$workspaceId/settings/templates'
      path: '/templates'
      fullPath: '/workspaces/$workspaceId/settings/templates'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSettingsTemplatesRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/settings/signing': {
      id: '/(protected)/workspaces/$workspaceId/settings/signing'
      path: '/signing'
      fullPath: '/workspaces/$workspaceId/settings/signing'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSettingsSigningRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/settings/security': {
      id: '/(protected)/workspaces/$workspaceId/settings/security'
      path: '/security'
      fullPath: '/workspaces/$workspaceId/settings/security'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSettingsSecurityRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/settings/review': {
      id: '/(protected)/workspaces/$workspaceId/settings/review'
      path: '/review'
      fullPath: '/workspaces/$workspaceId/settings/review'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSettingsReviewRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/settings/request-intake': {
      id: '/(protected)/workspaces/$workspaceId/settings/request-intake'
      path: '/request-intake'
      fullPath: '/workspaces/$workspaceId/settings/request-intake'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSettingsRequestIntakeRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/settings/properties': {
      id: '/(protected)/workspaces/$workspaceId/settings/properties'
      path: '/properties'
      fullPath: '/workspaces/$workspaceId/settings/properties'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSettingsPropertiesRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/settings/program': {
      id: '/(protected)/workspaces/$workspaceId/settings/program'
      path: '/program'
      fullPath: '/workspaces/$workspaceId/settings/program'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSettingsProgramRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/settings/profile': {
      id: '/(protected)/workspaces/$workspaceId/settings/profile'
      path: '/profile'
      fullPath: '/workspaces/$workspaceId/settings/profile'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSettingsProfileRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/settings/procedure-triggers': {
      id: '/(protected)/workspaces/$workspaceId/settings/procedure-triggers'
      path: '/procedure-triggers'
      fullPath: '/workspaces/$workspaceId/settings/procedure-triggers'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSettingsProcedureTriggersRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/settings/personas': {
      id: '/(protected)/workspaces/$workspaceId/settings/personas'
      path: '/personas'
      fullPath: '/workspaces/$workspaceId/settings/personas'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSettingsPersonasRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/settings/personal-tokens': {
      id: '/(protected)/workspaces/$workspaceId/settings/personal-tokens'
      path: '/personal-tokens'
      fullPath: '/workspaces/$workspaceId/settings/personal-tokens'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSettingsPersonalTokensRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/settings/notifications': {
      id: '/(protected)/workspaces/$workspaceId/settings/notifications'
      path: '/notifications'
      fullPath: '/workspaces/$workspaceId/settings/notifications'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSettingsNotificationsRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/settings/members': {
      id: '/(protected)/workspaces/$workspaceId/settings/members'
      path: '/members'
      fullPath: '/workspaces/$workspaceId/settings/members'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSettingsMembersRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/settings/mcp-server': {
      id: '/(protected)/workspaces/$workspaceId/settings/mcp-server'
      path: '/mcp-server'
      fullPath: '/workspaces/$workspaceId/settings/mcp-server'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSettingsMcpServerRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/settings/integrations': {
      id: '/(protected)/workspaces/$workspaceId/settings/integrations'
      path: '/integrations'
      fullPath: '/workspaces/$workspaceId/settings/integrations'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSettingsIntegrationsRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/settings/imports': {
      id: '/(protected)/workspaces/$workspaceId/settings/imports'
      path: '/imports'
      fullPath: '/workspaces/$workspaceId/settings/imports'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSettingsImportsRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/settings/governance': {
      id: '/(protected)/workspaces/$workspaceId/settings/governance'
      path: '/governance'
      fullPath: '/workspaces/$workspaceId/settings/governance'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSettingsGovernanceRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/settings/general': {
      id: '/(protected)/workspaces/$workspaceId/settings/general'
      path: '/general'
      fullPath: '/workspaces/$workspaceId/settings/general'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSettingsGeneralRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/settings/exceptions': {
      id: '/(protected)/workspaces/$workspaceId/settings/exceptions'
      path: '/exceptions'
      fullPath: '/workspaces/$workspaceId/settings/exceptions'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSettingsExceptionsRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/settings/email': {
      id: '/(protected)/workspaces/$workspaceId/settings/email'
      path: '/email'
      fullPath: '/workspaces/$workspaceId/settings/email'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSettingsEmailRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/settings/data-export': {
      id: '/(protected)/workspaces/$workspaceId/settings/data-export'
      path: '/data-export'
      fullPath: '/workspaces/$workspaceId/settings/data-export'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSettingsDataExportRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/settings/configuration': {
      id: '/(protected)/workspaces/$workspaceId/settings/configuration'
      path: '/configuration'
      fullPath: '/workspaces/$workspaceId/settings/configuration'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSettingsConfigurationRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/settings/compliance-roles': {
      id: '/(protected)/workspaces/$workspaceId/settings/compliance-roles'
      path: '/compliance-roles'
      fullPath: '/workspaces/$workspaceId/settings/compliance-roles'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSettingsComplianceRolesRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/settings/checks': {
      id: '/(protected)/workspaces/$workspaceId/settings/checks'
      path: '/checks'
      fullPath: '/workspaces/$workspaceId/settings/checks'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSettingsChecksRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/settings/chat': {
      id: '/(protected)/workspaces/$workspaceId/settings/chat'
      path: '/chat'
      fullPath: '/workspaces/$workspaceId/settings/chat'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSettingsChatRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/settings/browser-extension': {
      id: '/(protected)/workspaces/$workspaceId/settings/browser-extension'
      path: '/browser-extension'
      fullPath: '/workspaces/$workspaceId/settings/browser-extension'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSettingsBrowserExtensionRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/settings/billing': {
      id: '/(protected)/workspaces/$workspaceId/settings/billing'
      path: '/billing'
      fullPath: '/workspaces/$workspaceId/settings/billing'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSettingsBillingRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/settings/auth': {
      id: '/(protected)/workspaces/$workspaceId/settings/auth'
      path: '/auth'
      fullPath: '/workspaces/$workspaceId/settings/auth'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSettingsAuthRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/settings/audit-logs': {
      id: '/(protected)/workspaces/$workspaceId/settings/audit-logs'
      path: '/audit-logs'
      fullPath: '/workspaces/$workspaceId/settings/audit-logs'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSettingsAuditLogsRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/settings/api-keys': {
      id: '/(protected)/workspaces/$workspaceId/settings/api-keys'
      path: '/api-keys'
      fullPath: '/workspaces/$workspaceId/settings/api-keys'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdSettingsApiKeysRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdSettingsRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/runs/$executionId': {
      id: '/(protected)/workspaces/$workspaceId/runs/$executionId'
      path: '/runs/$executionId'
      fullPath: '/workspaces/$workspaceId/runs/$executionId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdRunsExecutionIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/runbooks_/new': {
      id: '/(protected)/workspaces/$workspaceId/runbooks_/new'
      path: '/runbooks/new'
      fullPath: '/workspaces/$workspaceId/runbooks/new'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdRunbooksNewRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/runbooks_/$runbookId': {
      id: '/(protected)/workspaces/$workspaceId/runbooks_/$runbookId'
      path: '/runbooks/$runbookId'
      fullPath: '/workspaces/$workspaceId/runbooks/$runbookId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdRunbooksRunbookIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/risks_/$riskId': {
      id: '/(protected)/workspaces/$workspaceId/risks_/$riskId'
      path: '/risks/$riskId'
      fullPath: '/workspaces/$workspaceId/risks/$riskId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdRisksRiskIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/reviews/access': {
      id: '/(protected)/workspaces/$workspaceId/reviews/access'
      path: '/reviews/access'
      fullPath: '/workspaces/$workspaceId/reviews/access'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdReviewsAccessRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/questionnaires_/$id': {
      id: '/(protected)/workspaces/$workspaceId/questionnaires_/$id'
      path: '/questionnaires/$id'
      fullPath: '/workspaces/$workspaceId/questionnaires/$id'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdQuestionnairesIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/policies_/$policySlug': {
      id: '/(protected)/workspaces/$workspaceId/policies_/$policySlug'
      path: '/policies/$policySlug'
      fullPath: '/workspaces/$workspaceId/policies/$policySlug'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdPoliciesPolicySlugRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/people_training/$programId': {
      id: '/(protected)/workspaces/$workspaceId/people_training/$programId'
      path: '/people_training/$programId'
      fullPath: '/workspaces/$workspaceId/people_training/$programId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdPeople_trainingProgramIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/people_groups/$groupId': {
      id: '/(protected)/workspaces/$workspaceId/people_groups/$groupId'
      path: '/people_groups/$groupId'
      fullPath: '/workspaces/$workspaceId/people_groups/$groupId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdPeople_groupsGroupIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/people_/$employeeId': {
      id: '/(protected)/workspaces/$workspaceId/people_/$employeeId'
      path: '/people/$employeeId'
      fullPath: '/workspaces/$workspaceId/people/$employeeId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdPeopleEmployeeIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/people/me': {
      id: '/(protected)/workspaces/$workspaceId/people/me'
      path: '/me'
      fullPath: '/workspaces/$workspaceId/people/me'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdPeopleMeRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdPeopleRoute
    }
    '/(protected)/workspaces/$workspaceId/integrations_/$providerSlug': {
      id: '/(protected)/workspaces/$workspaceId/integrations_/$providerSlug'
      path: '/integrations/$providerSlug'
      fullPath: '/workspaces/$workspaceId/integrations/$providerSlug'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdIntegrationsProviderSlugRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/evidence_/creating': {
      id: '/(protected)/workspaces/$workspaceId/evidence_/creating'
      path: '/evidence/creating'
      fullPath: '/workspaces/$workspaceId/evidence/creating'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdEvidenceCreatingRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/evidence-viewer/$evidencePackId': {
      id: '/(protected)/workspaces/$workspaceId/evidence-viewer/$evidencePackId'
      path: '/evidence-viewer/$evidencePackId'
      fullPath: '/workspaces/$workspaceId/evidence-viewer/$evidencePackId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdEvidenceViewerEvidencePackIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/employee-center/training': {
      id: '/(protected)/workspaces/$workspaceId/employee-center/training'
      path: '/training'
      fullPath: '/workspaces/$workspaceId/employee-center/training'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterTrainingRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/employee-center/tasks': {
      id: '/(protected)/workspaces/$workspaceId/employee-center/tasks'
      path: '/tasks'
      fullPath: '/workspaces/$workspaceId/employee-center/tasks'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterTasksRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/employee-center/requests': {
      id: '/(protected)/workspaces/$workspaceId/employee-center/requests'
      path: '/requests'
      fullPath: '/workspaces/$workspaceId/employee-center/requests'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterRequestsRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/employee-center/pending-policies': {
      id: '/(protected)/workspaces/$workspaceId/employee-center/pending-policies'
      path: '/pending-policies'
      fullPath: '/workspaces/$workspaceId/employee-center/pending-policies'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterPendingPoliciesRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/employee-center/org-chart': {
      id: '/(protected)/workspaces/$workspaceId/employee-center/org-chart'
      path: '/org-chart'
      fullPath: '/workspaces/$workspaceId/employee-center/org-chart'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterOrgChartRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/employee-center/inbox': {
      id: '/(protected)/workspaces/$workspaceId/employee-center/inbox'
      path: '/inbox'
      fullPath: '/workspaces/$workspaceId/employee-center/inbox'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterInboxRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/employee-center/devices': {
      id: '/(protected)/workspaces/$workspaceId/employee-center/devices'
      path: '/devices'
      fullPath: '/workspaces/$workspaceId/employee-center/devices'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterDevicesRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/employee-center/anonymous-reporting': {
      id: '/(protected)/workspaces/$workspaceId/employee-center/anonymous-reporting'
      path: '/anonymous-reporting'
      fullPath: '/workspaces/$workspaceId/employee-center/anonymous-reporting'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterAnonymousReportingRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/employee-center/acknowledgments': {
      id: '/(protected)/workspaces/$workspaceId/employee-center/acknowledgments'
      path: '/acknowledgments'
      fullPath: '/workspaces/$workspaceId/employee-center/acknowledgments'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterAcknowledgmentsRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/documents_/$docId': {
      id: '/(protected)/workspaces/$workspaceId/documents_/$docId'
      path: '/documents/$docId'
      fullPath: '/workspaces/$workspaceId/documents/$docId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdDocumentsDocIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/devices_/$deviceId': {
      id: '/(protected)/workspaces/$workspaceId/devices_/$deviceId'
      path: '/devices/$deviceId'
      fullPath: '/workspaces/$workspaceId/devices/$deviceId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdDevicesDeviceIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/dev/tool-ui': {
      id: '/(protected)/workspaces/$workspaceId/dev/tool-ui'
      path: '/dev/tool-ui'
      fullPath: '/workspaces/$workspaceId/dev/tool-ui'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdDevToolUiRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/deprecated/compliance-route-old': {
      id: '/(protected)/workspaces/$workspaceId/deprecated/compliance-route-old'
      path: '/deprecated/compliance-route-old'
      fullPath: '/workspaces/$workspaceId/deprecated/compliance-route-old'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdDeprecatedComplianceRouteOldRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/controls_/$controlDefId': {
      id: '/(protected)/workspaces/$workspaceId/controls_/$controlDefId'
      path: '/controls/$controlDefId'
      fullPath: '/workspaces/$workspaceId/controls/$controlDefId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdControlsControlDefIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/chat_/$threadId': {
      id: '/(protected)/workspaces/$workspaceId/chat_/$threadId'
      path: '/chat/$threadId'
      fullPath: '/workspaces/$workspaceId/chat/$threadId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdChatThreadIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/audits/$auditCycleId': {
      id: '/(protected)/workspaces/$workspaceId/audits/$auditCycleId'
      path: '/audits/$auditCycleId'
      fullPath: '/workspaces/$workspaceId/audits/$auditCycleId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAuditsAuditCycleIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/auditor-center/api-access': {
      id: '/(protected)/workspaces/$workspaceId/auditor-center/api-access'
      path: '/api-access'
      fullPath: '/workspaces/$workspaceId/auditor-center/api-access'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterApiAccessRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/assets_/$assetId': {
      id: '/(protected)/workspaces/$workspaceId/assets_/$assetId'
      path: '/assets/$assetId'
      fullPath: '/workspaces/$workspaceId/assets/$assetId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAssetsAssetIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/anonymous-reports_/$reportId': {
      id: '/(protected)/workspaces/$workspaceId/anonymous-reports_/$reportId'
      path: '/anonymous-reports/$reportId'
      fullPath: '/workspaces/$workspaceId/anonymous-reports/$reportId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAnonymousReportsReportIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId': {
      id: '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId'
      path: '/$auditCycleId'
      fullPath: '/workspaces/$workspaceId/auditor-center/$auditCycleId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/deprecated/integrations-old/': {
      id: '/(protected)/workspaces/$workspaceId/deprecated/integrations-old/'
      path: '/deprecated/integrations-old'
      fullPath: '/workspaces/$workspaceId/deprecated/integrations-old/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdDeprecatedIntegrationsOldIndexLazyRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/tests_/$testId/': {
      id: '/(protected)/workspaces/$workspaceId/tests_/$testId/'
      path: '/tests/$testId'
      fullPath: '/workspaces/$workspaceId/tests/$testId/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdTestsTestIdIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/templates/$templateId/': {
      id: '/(protected)/workspaces/$workspaceId/templates/$templateId/'
      path: '/templates/$templateId'
      fullPath: '/workspaces/$workspaceId/templates/$templateId/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdTemplatesTemplateIdIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/frameworks/$frameworkId/': {
      id: '/(protected)/workspaces/$workspaceId/frameworks/$frameworkId/'
      path: '/frameworks/$frameworkId'
      fullPath: '/workspaces/$workspaceId/frameworks/$frameworkId/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdFrameworksFrameworkIdIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/deprecated/sources/': {
      id: '/(protected)/workspaces/$workspaceId/deprecated/sources/'
      path: '/deprecated/sources'
      fullPath: '/workspaces/$workspaceId/deprecated/sources/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdDeprecatedSourcesIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/automation/$executionId/': {
      id: '/(protected)/workspaces/$workspaceId/automation/$executionId/'
      path: '/automation/$executionId'
      fullPath: '/workspaces/$workspaceId/automation/$executionId/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAutomationExecutionIdIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/': {
      id: '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/'
      path: '/'
      fullPath: '/workspaces/$workspaceId/auditor-center/$auditCycleId/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/tests_/$testId/submissions': {
      id: '/(protected)/workspaces/$workspaceId/tests_/$testId/submissions'
      path: '/tests/$testId/submissions'
      fullPath: '/workspaces/$workspaceId/tests/$testId/submissions'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdTestsTestIdSubmissionsRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/templates/$templateId/edit': {
      id: '/(protected)/workspaces/$workspaceId/templates/$templateId/edit'
      path: '/templates/$templateId/edit'
      fullPath: '/workspaces/$workspaceId/templates/$templateId/edit'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdTemplatesTemplateIdEditRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/risks_/assessments/$draftId': {
      id: '/(protected)/workspaces/$workspaceId/risks_/assessments/$draftId'
      path: '/risks/assessments/$draftId'
      fullPath: '/workspaces/$workspaceId/risks/assessments/$draftId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdRisksAssessmentsDraftIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/reviews/access_/roles': {
      id: '/(protected)/workspaces/$workspaceId/reviews/access_/roles'
      path: '/reviews/access/roles'
      fullPath: '/workspaces/$workspaceId/reviews/access/roles'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdReviewsAccessRolesRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/reviews/access_/$cycleId': {
      id: '/(protected)/workspaces/$workspaceId/reviews/access_/$cycleId'
      path: '/reviews/access/$cycleId'
      fullPath: '/workspaces/$workspaceId/reviews/access/$cycleId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdReviewsAccessCycleIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/recordings_/$flowId/edit': {
      id: '/(protected)/workspaces/$workspaceId/recordings_/$flowId/edit'
      path: '/recordings/$flowId/edit'
      fullPath: '/workspaces/$workspaceId/recordings/$flowId/edit'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdRecordingsFlowIdEditRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/integrations_/custom/$applicationId': {
      id: '/(protected)/workspaces/$workspaceId/integrations_/custom/$applicationId'
      path: '/integrations/custom/$applicationId'
      fullPath: '/workspaces/$workspaceId/integrations/custom/$applicationId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdIntegrationsCustomApplicationIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/employee-center/training_/$programId': {
      id: '/(protected)/workspaces/$workspaceId/employee-center/training_/$programId'
      path: '/training/$programId'
      fullPath: '/workspaces/$workspaceId/employee-center/training/$programId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterTrainingProgramIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/employee-center/tests_/$testId': {
      id: '/(protected)/workspaces/$workspaceId/employee-center/tests_/$testId'
      path: '/tests/$testId'
      fullPath: '/workspaces/$workspaceId/employee-center/tests/$testId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterTestsTestIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/employee-center/tasks_/$taskId': {
      id: '/(protected)/workspaces/$workspaceId/employee-center/tasks_/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/workspaces/$workspaceId/employee-center/tasks/$taskId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterTasksTaskIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/employee-center/requests_/$taskId': {
      id: '/(protected)/workspaces/$workspaceId/employee-center/requests_/$taskId'
      path: '/requests/$taskId'
      fullPath: '/workspaces/$workspaceId/employee-center/requests/$taskId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterRequestsTaskIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/employee-center/pending-policies_/$templateId': {
      id: '/(protected)/workspaces/$workspaceId/employee-center/pending-policies_/$templateId'
      path: '/pending-policies/$templateId'
      fullPath: '/workspaces/$workspaceId/employee-center/pending-policies/$templateId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterPendingPoliciesTemplateIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/vendors': {
      id: '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/vendors'
      path: '/vendors'
      fullPath: '/workspaces/$workspaceId/auditor-center/$auditCycleId/vendors'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdVendorsRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/timeline': {
      id: '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/timeline'
      path: '/timeline'
      fullPath: '/workspaces/$workspaceId/auditor-center/$auditCycleId/timeline'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdTimelineRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/risks': {
      id: '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/risks'
      path: '/risks'
      fullPath: '/workspaces/$workspaceId/auditor-center/$auditCycleId/risks'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRisksRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/request-list': {
      id: '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/request-list'
      path: '/request-list'
      fullPath: '/workspaces/$workspaceId/auditor-center/$auditCycleId/request-list'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRequestListRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/populations': {
      id: '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/populations'
      path: '/populations'
      fullPath: '/workspaces/$workspaceId/auditor-center/$auditCycleId/populations'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPopulationsRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/people': {
      id: '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/people'
      path: '/people'
      fullPath: '/workspaces/$workspaceId/auditor-center/$auditCycleId/people'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPeopleRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/open-requests': {
      id: '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/open-requests'
      path: '/open-requests'
      fullPath: '/workspaces/$workspaceId/auditor-center/$auditCycleId/open-requests'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdOpenRequestsRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations': {
      id: '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations'
      path: '/integrations'
      fullPath: '/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/evidence': {
      id: '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/evidence'
      path: '/evidence'
      fullPath: '/workspaces/$workspaceId/auditor-center/$auditCycleId/evidence'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdEvidenceRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/dashboard': {
      id: '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/dashboard'
      path: '/dashboard'
      fullPath: '/workspaces/$workspaceId/auditor-center/$auditCycleId/dashboard'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdDashboardRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/controls': {
      id: '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/controls'
      path: '/controls'
      fullPath: '/workspaces/$workspaceId/auditor-center/$auditCycleId/controls'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdControlsRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/assets': {
      id: '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/assets'
      path: '/assets'
      fullPath: '/workspaces/$workspaceId/auditor-center/$auditCycleId/assets'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAssetsRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/api-access': {
      id: '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/api-access'
      path: '/api-access'
      fullPath: '/workspaces/$workspaceId/auditor-center/$auditCycleId/api-access'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdApiAccessRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId_/policies': {
      id: '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId_/policies'
      path: '/$auditCycleId/policies'
      fullPath: '/workspaces/$workspaceId/auditor-center/$auditCycleId/policies'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesRouteRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/audit-evidence': {
      id: '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/audit-evidence'
      path: '/audit-evidence'
      fullPath: '/workspaces/$workspaceId/auditor-center/$auditCycleId/audit-evidence'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceRouteRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/templates/control/$controlId/': {
      id: '/(protected)/workspaces/$workspaceId/templates/control/$controlId/'
      path: '/templates/control/$controlId'
      fullPath: '/workspaces/$workspaceId/templates/control/$controlId/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdTemplatesControlControlIdIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/frameworks/$frameworkId/controls/': {
      id: '/(protected)/workspaces/$workspaceId/frameworks/$frameworkId/controls/'
      path: '/frameworks/$frameworkId/controls'
      fullPath: '/workspaces/$workspaceId/frameworks/$frameworkId/controls/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdFrameworksFrameworkIdControlsIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId_/policies/': {
      id: '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId_/policies/'
      path: '/'
      fullPath: '/workspaces/$workspaceId/auditor-center/$auditCycleId/policies/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/audit-evidence/': {
      id: '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/audit-evidence/'
      path: '/'
      fullPath: '/workspaces/$workspaceId/auditor-center/$auditCycleId/audit-evidence/'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceIndexRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/vendors_/$vendorId_/assessments/$assessmentId': {
      id: '/(protected)/workspaces/$workspaceId/vendors_/$vendorId_/assessments/$assessmentId'
      path: '/vendors/$vendorId/assessments/$assessmentId'
      fullPath: '/workspaces/$workspaceId/vendors/$vendorId/assessments/$assessmentId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdVendorsVendorIdAssessmentsAssessmentIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/reviews/access_/period/$periodKey': {
      id: '/(protected)/workspaces/$workspaceId/reviews/access_/period/$periodKey'
      path: '/reviews/access/period/$periodKey'
      fullPath: '/workspaces/$workspaceId/reviews/access/period/$periodKey'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdReviewsAccessPeriodPeriodKeyRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/integrations_/$providerSlug_/services/$serviceId': {
      id: '/(protected)/workspaces/$workspaceId/integrations_/$providerSlug_/services/$serviceId'
      path: '/integrations/$providerSlug/services/$serviceId'
      fullPath: '/workspaces/$workspaceId/integrations/$providerSlug/services/$serviceId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdIntegrationsProviderSlugServicesServiceIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/integrations_/$providerSlug_/accounts/$connectionId': {
      id: '/(protected)/workspaces/$workspaceId/integrations_/$providerSlug_/accounts/$connectionId'
      path: '/integrations/$providerSlug/accounts/$connectionId'
      fullPath: '/workspaces/$workspaceId/integrations/$providerSlug/accounts/$connectionId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdIntegrationsProviderSlugAccountsConnectionIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId_/policies/$policySlug': {
      id: '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId_/policies/$policySlug'
      path: '/$policySlug'
      fullPath: '/workspaces/$workspaceId/auditor-center/$auditCycleId/policies/$policySlug'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesPolicySlugRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/vendors_/$vendorId': {
      id: '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/vendors_/$vendorId'
      path: '/vendors/$vendorId'
      fullPath: '/workspaces/$workspaceId/auditor-center/$auditCycleId/vendors/$vendorId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdVendorsVendorIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/risks_/$riskId': {
      id: '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/risks_/$riskId'
      path: '/risks/$riskId'
      fullPath: '/workspaces/$workspaceId/auditor-center/$auditCycleId/risks/$riskId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRisksRiskIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/populations_/$populationId': {
      id: '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/populations_/$populationId'
      path: '/populations/$populationId'
      fullPath: '/workspaces/$workspaceId/auditor-center/$auditCycleId/populations/$populationId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPopulationsPopulationIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/people_/$employeeId': {
      id: '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/people_/$employeeId'
      path: '/people/$employeeId'
      fullPath: '/workspaces/$workspaceId/auditor-center/$auditCycleId/people/$employeeId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPeopleEmployeeIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations_/$providerSlug': {
      id: '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations_/$providerSlug'
      path: '/integrations/$providerSlug'
      fullPath: '/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations/$providerSlug'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsProviderSlugRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/assets_/$assetId': {
      id: '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/assets_/$assetId'
      path: '/assets/$assetId'
      fullPath: '/workspaces/$workspaceId/auditor-center/$auditCycleId/assets/$assetId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAssetsAssetIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/integrations_/custom/$applicationId_/datasets/$datasetId': {
      id: '/(protected)/workspaces/$workspaceId/integrations_/custom/$applicationId_/datasets/$datasetId'
      path: '/integrations/custom/$applicationId/datasets/$datasetId'
      fullPath: '/workspaces/$workspaceId/integrations/custom/$applicationId/datasets/$datasetId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdIntegrationsCustomApplicationIdDatasetsDatasetIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/deprecated/workflows/$workflowId/executions/$jobId': {
      id: '/(protected)/workspaces/$workspaceId/deprecated/workflows/$workflowId/executions/$jobId'
      path: '/deprecated/workflows/$workflowId/executions/$jobId'
      fullPath: '/workspaces/$workspaceId/deprecated/workflows/$workflowId/executions/$jobId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdDeprecatedWorkflowsWorkflowIdExecutionsJobIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/audit-evidence/$evidenceKind/$evidenceItemId': {
      id: '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/audit-evidence/$evidenceKind/$evidenceItemId'
      path: '/$evidenceKind/$evidenceItemId'
      fullPath: '/workspaces/$workspaceId/auditor-center/$auditCycleId/audit-evidence/$evidenceKind/$evidenceItemId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceEvidenceKindEvidenceItemIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/vendors_/$vendorId_/reviews/$assessmentId': {
      id: '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/vendors_/$vendorId_/reviews/$assessmentId'
      path: '/vendors/$vendorId/reviews/$assessmentId'
      fullPath: '/workspaces/$workspaceId/auditor-center/$auditCycleId/vendors/$vendorId/reviews/$assessmentId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdVendorsVendorIdReviewsAssessmentIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/populations_/$populationId_/rounds/$sampleId': {
      id: '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/populations_/$populationId_/rounds/$sampleId'
      path: '/populations/$populationId/rounds/$sampleId'
      fullPath: '/workspaces/$workspaceId/auditor-center/$auditCycleId/populations/$populationId/rounds/$sampleId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPopulationsPopulationIdRoundsSampleIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations_/$providerSlug_/services/$serviceId': {
      id: '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations_/$providerSlug_/services/$serviceId'
      path: '/integrations/$providerSlug/services/$serviceId'
      fullPath: '/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations/$providerSlug/services/$serviceId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsProviderSlugServicesServiceIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute
    }
    '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations_/$providerSlug_/accounts/$connectionId': {
      id: '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations_/$providerSlug_/accounts/$connectionId'
      path: '/integrations/$providerSlug/accounts/$connectionId'
      fullPath: '/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations/$providerSlug/accounts/$connectionId'
      preLoaderRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsProviderSlugAccountsConnectionIdRouteImport
      parentRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute
    }
  }
}

interface authOnboardingRouteRouteChildren {
  authOnboardingExtensionRoute: typeof authOnboardingExtensionRoute
  authOnboardingPreferencesRoute: typeof authOnboardingPreferencesRoute
  authOnboardingQuickSetupRoute: typeof authOnboardingQuickSetupRoute
  authOnboardingTeamRoute: typeof authOnboardingTeamRoute
}

const authOnboardingRouteRouteChildren: authOnboardingRouteRouteChildren = {
  authOnboardingExtensionRoute: authOnboardingExtensionRoute,
  authOnboardingPreferencesRoute: authOnboardingPreferencesRoute,
  authOnboardingQuickSetupRoute: authOnboardingQuickSetupRoute,
  authOnboardingTeamRoute: authOnboardingTeamRoute,
}

const authOnboardingRouteRouteWithChildren =
  authOnboardingRouteRoute._addFileChildren(authOnboardingRouteRouteChildren)

interface authRouteRouteChildren {
  authOnboardingRouteRoute: typeof authOnboardingRouteRouteWithChildren
  authAcceptInvitationRoute: typeof authAcceptInvitationRoute
  authInviteRoute: typeof authInviteRoute
  authLoginRoute: typeof authLoginRoute
  authLogoutRoute: typeof authLogoutRoute
  authOtpRoute: typeof authOtpRoute
  authResetPasswordRoute: typeof authResetPasswordRoute
  authShareInviteRoute: typeof authShareInviteRoute
  authVerifyEmailRoute: typeof authVerifyEmailRoute
  authForgotPasswordLazyRoute: typeof authForgotPasswordLazyRoute
  authLogin2LazyRoute: typeof authLogin2LazyRoute
  authSetupMfaLazyRoute: typeof authSetupMfaLazyRoute
  authSignupLazyRoute: typeof authSignupLazyRoute
  authVerify2faLazyRoute: typeof authVerify2faLazyRoute
  authVerifyOtpLazyRoute: typeof authVerifyOtpLazyRoute
  authAuthCallbackProviderRoute: typeof authAuthCallbackProviderRoute
  authNativeAuthCallbackRoute: typeof authNativeAuthCallbackRoute
  authNativeLoginRoute: typeof authNativeLoginRoute
}

const authRouteRouteChildren: authRouteRouteChildren = {
  authOnboardingRouteRoute: authOnboardingRouteRouteWithChildren,
  authAcceptInvitationRoute: authAcceptInvitationRoute,
  authInviteRoute: authInviteRoute,
  authLoginRoute: authLoginRoute,
  authLogoutRoute: authLogoutRoute,
  authOtpRoute: authOtpRoute,
  authResetPasswordRoute: authResetPasswordRoute,
  authShareInviteRoute: authShareInviteRoute,
  authVerifyEmailRoute: authVerifyEmailRoute,
  authForgotPasswordLazyRoute: authForgotPasswordLazyRoute,
  authLogin2LazyRoute: authLogin2LazyRoute,
  authSetupMfaLazyRoute: authSetupMfaLazyRoute,
  authSignupLazyRoute: authSignupLazyRoute,
  authVerify2faLazyRoute: authVerify2faLazyRoute,
  authVerifyOtpLazyRoute: authVerifyOtpLazyRoute,
  authAuthCallbackProviderRoute: authAuthCallbackProviderRoute,
  authNativeAuthCallbackRoute: authNativeAuthCallbackRoute,
  authNativeLoginRoute: authNativeLoginRoute,
}

const authRouteRouteWithChildren = authRouteRoute._addFileChildren(
  authRouteRouteChildren,
)

interface protectedOrgsRouteRouteChildren {
  protectedOrgsSlugRouteRoute: typeof protectedOrgsSlugRouteRoute
  protectedOrgsIndexLazyRoute: typeof protectedOrgsIndexLazyRoute
}

const protectedOrgsRouteRouteChildren: protectedOrgsRouteRouteChildren = {
  protectedOrgsSlugRouteRoute: protectedOrgsSlugRouteRoute,
  protectedOrgsIndexLazyRoute: protectedOrgsIndexLazyRoute,
}

const protectedOrgsRouteRouteWithChildren =
  protectedOrgsRouteRoute._addFileChildren(protectedOrgsRouteRouteChildren)

interface protectedPartnerRouteRouteChildren {
  protectedPartnerTemplatesRoute: typeof protectedPartnerTemplatesRoute
  protectedPartnerIndexRoute: typeof protectedPartnerIndexRoute
  protectedPartnerClientsClientIdRoute: typeof protectedPartnerClientsClientIdRoute
  protectedPartnerClientsNewRoute: typeof protectedPartnerClientsNewRoute
}

const protectedPartnerRouteRouteChildren: protectedPartnerRouteRouteChildren = {
  protectedPartnerTemplatesRoute: protectedPartnerTemplatesRoute,
  protectedPartnerIndexRoute: protectedPartnerIndexRoute,
  protectedPartnerClientsClientIdRoute: protectedPartnerClientsClientIdRoute,
  protectedPartnerClientsNewRoute: protectedPartnerClientsNewRoute,
}

const protectedPartnerRouteRouteWithChildren =
  protectedPartnerRouteRoute._addFileChildren(
    protectedPartnerRouteRouteChildren,
  )

interface protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceRouteRouteChildren {
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceIndexRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceIndexRoute
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceEvidenceKindEvidenceItemIdRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceEvidenceKindEvidenceItemIdRoute
}

const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceRouteRouteChildren: protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceRouteRouteChildren =
  {
    protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceIndexRoute:
      protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceIndexRoute,
    protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceEvidenceKindEvidenceItemIdRoute:
      protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceEvidenceKindEvidenceItemIdRoute,
  }

const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceRouteRouteWithChildren =
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceRouteRoute._addFileChildren(
    protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceRouteRouteChildren,
  )

interface protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRouteChildren {
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceRouteRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceRouteRouteWithChildren
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdApiAccessRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdApiAccessRoute
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAssetsRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAssetsRoute
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdControlsRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdControlsRoute
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdDashboardRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdDashboardRoute
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdEvidenceRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdEvidenceRoute
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsRoute
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdOpenRequestsRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdOpenRequestsRoute
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPeopleRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPeopleRoute
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPopulationsRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPopulationsRoute
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRequestListRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRequestListRoute
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRisksRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRisksRoute
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdTimelineRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdTimelineRoute
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdVendorsRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdVendorsRoute
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIndexRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIndexRoute
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAssetsAssetIdRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAssetsAssetIdRoute
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsProviderSlugRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsProviderSlugRoute
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPeopleEmployeeIdRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPeopleEmployeeIdRoute
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPopulationsPopulationIdRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPopulationsPopulationIdRoute
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRisksRiskIdRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRisksRiskIdRoute
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdVendorsVendorIdRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdVendorsVendorIdRoute
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsProviderSlugAccountsConnectionIdRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsProviderSlugAccountsConnectionIdRoute
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsProviderSlugServicesServiceIdRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsProviderSlugServicesServiceIdRoute
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPopulationsPopulationIdRoundsSampleIdRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPopulationsPopulationIdRoundsSampleIdRoute
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdVendorsVendorIdReviewsAssessmentIdRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdVendorsVendorIdReviewsAssessmentIdRoute
}

const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRouteChildren: protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRouteChildren =
  {
    protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceRouteRoute:
      protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAuditEvidenceRouteRouteWithChildren,
    protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdApiAccessRoute:
      protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdApiAccessRoute,
    protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAssetsRoute:
      protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAssetsRoute,
    protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdControlsRoute:
      protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdControlsRoute,
    protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdDashboardRoute:
      protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdDashboardRoute,
    protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdEvidenceRoute:
      protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdEvidenceRoute,
    protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsRoute:
      protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsRoute,
    protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdOpenRequestsRoute:
      protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdOpenRequestsRoute,
    protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPeopleRoute:
      protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPeopleRoute,
    protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPopulationsRoute:
      protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPopulationsRoute,
    protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRequestListRoute:
      protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRequestListRoute,
    protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRisksRoute:
      protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRisksRoute,
    protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdTimelineRoute:
      protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdTimelineRoute,
    protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdVendorsRoute:
      protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdVendorsRoute,
    protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIndexRoute:
      protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIndexRoute,
    protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAssetsAssetIdRoute:
      protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdAssetsAssetIdRoute,
    protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsProviderSlugRoute:
      protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsProviderSlugRoute,
    protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPeopleEmployeeIdRoute:
      protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPeopleEmployeeIdRoute,
    protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPopulationsPopulationIdRoute:
      protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPopulationsPopulationIdRoute,
    protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRisksRiskIdRoute:
      protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRisksRiskIdRoute,
    protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdVendorsVendorIdRoute:
      protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdVendorsVendorIdRoute,
    protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsProviderSlugAccountsConnectionIdRoute:
      protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsProviderSlugAccountsConnectionIdRoute,
    protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsProviderSlugServicesServiceIdRoute:
      protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdIntegrationsProviderSlugServicesServiceIdRoute,
    protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPopulationsPopulationIdRoundsSampleIdRoute:
      protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPopulationsPopulationIdRoundsSampleIdRoute,
    protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdVendorsVendorIdReviewsAssessmentIdRoute:
      protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdVendorsVendorIdReviewsAssessmentIdRoute,
  }

const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRouteWithChildren =
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute._addFileChildren(
    protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRouteChildren,
  )

interface protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesRouteRouteChildren {
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesPolicySlugRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesPolicySlugRoute
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesIndexRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesIndexRoute
}

const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesRouteRouteChildren: protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesRouteRouteChildren =
  {
    protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesPolicySlugRoute:
      protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesPolicySlugRoute,
    protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesIndexRoute:
      protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesIndexRoute,
  }

const protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesRouteRouteWithChildren =
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesRouteRoute._addFileChildren(
    protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesRouteRouteChildren,
  )

interface protectedWorkspacesWorkspaceIdAuditorCenterRouteRouteChildren {
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRouteWithChildren
  protectedWorkspacesWorkspaceIdAuditorCenterApiAccessRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterApiAccessRoute
  protectedWorkspacesWorkspaceIdAuditorCenterIndexRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterIndexRoute
  protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesRouteRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesRouteRouteWithChildren
}

const protectedWorkspacesWorkspaceIdAuditorCenterRouteRouteChildren: protectedWorkspacesWorkspaceIdAuditorCenterRouteRouteChildren =
  {
    protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRoute:
      protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdRouteRouteWithChildren,
    protectedWorkspacesWorkspaceIdAuditorCenterApiAccessRoute:
      protectedWorkspacesWorkspaceIdAuditorCenterApiAccessRoute,
    protectedWorkspacesWorkspaceIdAuditorCenterIndexRoute:
      protectedWorkspacesWorkspaceIdAuditorCenterIndexRoute,
    protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesRouteRoute:
      protectedWorkspacesWorkspaceIdAuditorCenterAuditCycleIdPoliciesRouteRouteWithChildren,
  }

const protectedWorkspacesWorkspaceIdAuditorCenterRouteRouteWithChildren =
  protectedWorkspacesWorkspaceIdAuditorCenterRouteRoute._addFileChildren(
    protectedWorkspacesWorkspaceIdAuditorCenterRouteRouteChildren,
  )

interface protectedWorkspacesWorkspaceIdEmployeeCenterRouteRouteChildren {
  protectedWorkspacesWorkspaceIdEmployeeCenterAcknowledgmentsRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterAcknowledgmentsRoute
  protectedWorkspacesWorkspaceIdEmployeeCenterAnonymousReportingRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterAnonymousReportingRoute
  protectedWorkspacesWorkspaceIdEmployeeCenterDevicesRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterDevicesRoute
  protectedWorkspacesWorkspaceIdEmployeeCenterInboxRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterInboxRoute
  protectedWorkspacesWorkspaceIdEmployeeCenterOrgChartRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterOrgChartRoute
  protectedWorkspacesWorkspaceIdEmployeeCenterPendingPoliciesRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterPendingPoliciesRoute
  protectedWorkspacesWorkspaceIdEmployeeCenterRequestsRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterRequestsRoute
  protectedWorkspacesWorkspaceIdEmployeeCenterTasksRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterTasksRoute
  protectedWorkspacesWorkspaceIdEmployeeCenterTrainingRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterTrainingRoute
  protectedWorkspacesWorkspaceIdEmployeeCenterIndexRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterIndexRoute
  protectedWorkspacesWorkspaceIdEmployeeCenterPendingPoliciesTemplateIdRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterPendingPoliciesTemplateIdRoute
  protectedWorkspacesWorkspaceIdEmployeeCenterRequestsTaskIdRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterRequestsTaskIdRoute
  protectedWorkspacesWorkspaceIdEmployeeCenterTasksTaskIdRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterTasksTaskIdRoute
  protectedWorkspacesWorkspaceIdEmployeeCenterTestsTestIdRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterTestsTestIdRoute
  protectedWorkspacesWorkspaceIdEmployeeCenterTrainingProgramIdRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterTrainingProgramIdRoute
}

const protectedWorkspacesWorkspaceIdEmployeeCenterRouteRouteChildren: protectedWorkspacesWorkspaceIdEmployeeCenterRouteRouteChildren =
  {
    protectedWorkspacesWorkspaceIdEmployeeCenterAcknowledgmentsRoute:
      protectedWorkspacesWorkspaceIdEmployeeCenterAcknowledgmentsRoute,
    protectedWorkspacesWorkspaceIdEmployeeCenterAnonymousReportingRoute:
      protectedWorkspacesWorkspaceIdEmployeeCenterAnonymousReportingRoute,
    protectedWorkspacesWorkspaceIdEmployeeCenterDevicesRoute:
      protectedWorkspacesWorkspaceIdEmployeeCenterDevicesRoute,
    protectedWorkspacesWorkspaceIdEmployeeCenterInboxRoute:
      protectedWorkspacesWorkspaceIdEmployeeCenterInboxRoute,
    protectedWorkspacesWorkspaceIdEmployeeCenterOrgChartRoute:
      protectedWorkspacesWorkspaceIdEmployeeCenterOrgChartRoute,
    protectedWorkspacesWorkspaceIdEmployeeCenterPendingPoliciesRoute:
      protectedWorkspacesWorkspaceIdEmployeeCenterPendingPoliciesRoute,
    protectedWorkspacesWorkspaceIdEmployeeCenterRequestsRoute:
      protectedWorkspacesWorkspaceIdEmployeeCenterRequestsRoute,
    protectedWorkspacesWorkspaceIdEmployeeCenterTasksRoute:
      protectedWorkspacesWorkspaceIdEmployeeCenterTasksRoute,
    protectedWorkspacesWorkspaceIdEmployeeCenterTrainingRoute:
      protectedWorkspacesWorkspaceIdEmployeeCenterTrainingRoute,
    protectedWorkspacesWorkspaceIdEmployeeCenterIndexRoute:
      protectedWorkspacesWorkspaceIdEmployeeCenterIndexRoute,
    protectedWorkspacesWorkspaceIdEmployeeCenterPendingPoliciesTemplateIdRoute:
      protectedWorkspacesWorkspaceIdEmployeeCenterPendingPoliciesTemplateIdRoute,
    protectedWorkspacesWorkspaceIdEmployeeCenterRequestsTaskIdRoute:
      protectedWorkspacesWorkspaceIdEmployeeCenterRequestsTaskIdRoute,
    protectedWorkspacesWorkspaceIdEmployeeCenterTasksTaskIdRoute:
      protectedWorkspacesWorkspaceIdEmployeeCenterTasksTaskIdRoute,
    protectedWorkspacesWorkspaceIdEmployeeCenterTestsTestIdRoute:
      protectedWorkspacesWorkspaceIdEmployeeCenterTestsTestIdRoute,
    protectedWorkspacesWorkspaceIdEmployeeCenterTrainingProgramIdRoute:
      protectedWorkspacesWorkspaceIdEmployeeCenterTrainingProgramIdRoute,
  }

const protectedWorkspacesWorkspaceIdEmployeeCenterRouteRouteWithChildren =
  protectedWorkspacesWorkspaceIdEmployeeCenterRouteRoute._addFileChildren(
    protectedWorkspacesWorkspaceIdEmployeeCenterRouteRouteChildren,
  )

interface protectedWorkspacesWorkspaceIdSettingsRouteRouteChildren {
  protectedWorkspacesWorkspaceIdSettingsApiKeysRoute: typeof protectedWorkspacesWorkspaceIdSettingsApiKeysRoute
  protectedWorkspacesWorkspaceIdSettingsAuditLogsRoute: typeof protectedWorkspacesWorkspaceIdSettingsAuditLogsRoute
  protectedWorkspacesWorkspaceIdSettingsAuthRoute: typeof protectedWorkspacesWorkspaceIdSettingsAuthRoute
  protectedWorkspacesWorkspaceIdSettingsBillingRoute: typeof protectedWorkspacesWorkspaceIdSettingsBillingRoute
  protectedWorkspacesWorkspaceIdSettingsBrowserExtensionRoute: typeof protectedWorkspacesWorkspaceIdSettingsBrowserExtensionRoute
  protectedWorkspacesWorkspaceIdSettingsChatRoute: typeof protectedWorkspacesWorkspaceIdSettingsChatRoute
  protectedWorkspacesWorkspaceIdSettingsChecksRoute: typeof protectedWorkspacesWorkspaceIdSettingsChecksRoute
  protectedWorkspacesWorkspaceIdSettingsComplianceRolesRoute: typeof protectedWorkspacesWorkspaceIdSettingsComplianceRolesRoute
  protectedWorkspacesWorkspaceIdSettingsConfigurationRoute: typeof protectedWorkspacesWorkspaceIdSettingsConfigurationRoute
  protectedWorkspacesWorkspaceIdSettingsDataExportRoute: typeof protectedWorkspacesWorkspaceIdSettingsDataExportRoute
  protectedWorkspacesWorkspaceIdSettingsEmailRoute: typeof protectedWorkspacesWorkspaceIdSettingsEmailRoute
  protectedWorkspacesWorkspaceIdSettingsExceptionsRoute: typeof protectedWorkspacesWorkspaceIdSettingsExceptionsRoute
  protectedWorkspacesWorkspaceIdSettingsGeneralRoute: typeof protectedWorkspacesWorkspaceIdSettingsGeneralRoute
  protectedWorkspacesWorkspaceIdSettingsGovernanceRoute: typeof protectedWorkspacesWorkspaceIdSettingsGovernanceRoute
  protectedWorkspacesWorkspaceIdSettingsImportsRoute: typeof protectedWorkspacesWorkspaceIdSettingsImportsRoute
  protectedWorkspacesWorkspaceIdSettingsIntegrationsRoute: typeof protectedWorkspacesWorkspaceIdSettingsIntegrationsRoute
  protectedWorkspacesWorkspaceIdSettingsMcpServerRoute: typeof protectedWorkspacesWorkspaceIdSettingsMcpServerRoute
  protectedWorkspacesWorkspaceIdSettingsMembersRoute: typeof protectedWorkspacesWorkspaceIdSettingsMembersRoute
  protectedWorkspacesWorkspaceIdSettingsNotificationsRoute: typeof protectedWorkspacesWorkspaceIdSettingsNotificationsRoute
  protectedWorkspacesWorkspaceIdSettingsPersonalTokensRoute: typeof protectedWorkspacesWorkspaceIdSettingsPersonalTokensRoute
  protectedWorkspacesWorkspaceIdSettingsPersonasRoute: typeof protectedWorkspacesWorkspaceIdSettingsPersonasRoute
  protectedWorkspacesWorkspaceIdSettingsProcedureTriggersRoute: typeof protectedWorkspacesWorkspaceIdSettingsProcedureTriggersRoute
  protectedWorkspacesWorkspaceIdSettingsProfileRoute: typeof protectedWorkspacesWorkspaceIdSettingsProfileRoute
  protectedWorkspacesWorkspaceIdSettingsProgramRoute: typeof protectedWorkspacesWorkspaceIdSettingsProgramRoute
  protectedWorkspacesWorkspaceIdSettingsPropertiesRoute: typeof protectedWorkspacesWorkspaceIdSettingsPropertiesRoute
  protectedWorkspacesWorkspaceIdSettingsRequestIntakeRoute: typeof protectedWorkspacesWorkspaceIdSettingsRequestIntakeRoute
  protectedWorkspacesWorkspaceIdSettingsReviewRoute: typeof protectedWorkspacesWorkspaceIdSettingsReviewRoute
  protectedWorkspacesWorkspaceIdSettingsSecurityRoute: typeof protectedWorkspacesWorkspaceIdSettingsSecurityRoute
  protectedWorkspacesWorkspaceIdSettingsSigningRoute: typeof protectedWorkspacesWorkspaceIdSettingsSigningRoute
  protectedWorkspacesWorkspaceIdSettingsTemplatesRoute: typeof protectedWorkspacesWorkspaceIdSettingsTemplatesRoute
  protectedWorkspacesWorkspaceIdSettingsThemeRoute: typeof protectedWorkspacesWorkspaceIdSettingsThemeRoute
  protectedWorkspacesWorkspaceIdSettingsWritingRoute: typeof protectedWorkspacesWorkspaceIdSettingsWritingRoute
  protectedWorkspacesWorkspaceIdSettingsIndexRoute: typeof protectedWorkspacesWorkspaceIdSettingsIndexRoute
}

const protectedWorkspacesWorkspaceIdSettingsRouteRouteChildren: protectedWorkspacesWorkspaceIdSettingsRouteRouteChildren =
  {
    protectedWorkspacesWorkspaceIdSettingsApiKeysRoute:
      protectedWorkspacesWorkspaceIdSettingsApiKeysRoute,
    protectedWorkspacesWorkspaceIdSettingsAuditLogsRoute:
      protectedWorkspacesWorkspaceIdSettingsAuditLogsRoute,
    protectedWorkspacesWorkspaceIdSettingsAuthRoute:
      protectedWorkspacesWorkspaceIdSettingsAuthRoute,
    protectedWorkspacesWorkspaceIdSettingsBillingRoute:
      protectedWorkspacesWorkspaceIdSettingsBillingRoute,
    protectedWorkspacesWorkspaceIdSettingsBrowserExtensionRoute:
      protectedWorkspacesWorkspaceIdSettingsBrowserExtensionRoute,
    protectedWorkspacesWorkspaceIdSettingsChatRoute:
      protectedWorkspacesWorkspaceIdSettingsChatRoute,
    protectedWorkspacesWorkspaceIdSettingsChecksRoute:
      protectedWorkspacesWorkspaceIdSettingsChecksRoute,
    protectedWorkspacesWorkspaceIdSettingsComplianceRolesRoute:
      protectedWorkspacesWorkspaceIdSettingsComplianceRolesRoute,
    protectedWorkspacesWorkspaceIdSettingsConfigurationRoute:
      protectedWorkspacesWorkspaceIdSettingsConfigurationRoute,
    protectedWorkspacesWorkspaceIdSettingsDataExportRoute:
      protectedWorkspacesWorkspaceIdSettingsDataExportRoute,
    protectedWorkspacesWorkspaceIdSettingsEmailRoute:
      protectedWorkspacesWorkspaceIdSettingsEmailRoute,
    protectedWorkspacesWorkspaceIdSettingsExceptionsRoute:
      protectedWorkspacesWorkspaceIdSettingsExceptionsRoute,
    protectedWorkspacesWorkspaceIdSettingsGeneralRoute:
      protectedWorkspacesWorkspaceIdSettingsGeneralRoute,
    protectedWorkspacesWorkspaceIdSettingsGovernanceRoute:
      protectedWorkspacesWorkspaceIdSettingsGovernanceRoute,
    protectedWorkspacesWorkspaceIdSettingsImportsRoute:
      protectedWorkspacesWorkspaceIdSettingsImportsRoute,
    protectedWorkspacesWorkspaceIdSettingsIntegrationsRoute:
      protectedWorkspacesWorkspaceIdSettingsIntegrationsRoute,
    protectedWorkspacesWorkspaceIdSettingsMcpServerRoute:
      protectedWorkspacesWorkspaceIdSettingsMcpServerRoute,
    protectedWorkspacesWorkspaceIdSettingsMembersRoute:
      protectedWorkspacesWorkspaceIdSettingsMembersRoute,
    protectedWorkspacesWorkspaceIdSettingsNotificationsRoute:
      protectedWorkspacesWorkspaceIdSettingsNotificationsRoute,
    protectedWorkspacesWorkspaceIdSettingsPersonalTokensRoute:
      protectedWorkspacesWorkspaceIdSettingsPersonalTokensRoute,
    protectedWorkspacesWorkspaceIdSettingsPersonasRoute:
      protectedWorkspacesWorkspaceIdSettingsPersonasRoute,
    protectedWorkspacesWorkspaceIdSettingsProcedureTriggersRoute:
      protectedWorkspacesWorkspaceIdSettingsProcedureTriggersRoute,
    protectedWorkspacesWorkspaceIdSettingsProfileRoute:
      protectedWorkspacesWorkspaceIdSettingsProfileRoute,
    protectedWorkspacesWorkspaceIdSettingsProgramRoute:
      protectedWorkspacesWorkspaceIdSettingsProgramRoute,
    protectedWorkspacesWorkspaceIdSettingsPropertiesRoute:
      protectedWorkspacesWorkspaceIdSettingsPropertiesRoute,
    protectedWorkspacesWorkspaceIdSettingsRequestIntakeRoute:
      protectedWorkspacesWorkspaceIdSettingsRequestIntakeRoute,
    protectedWorkspacesWorkspaceIdSettingsReviewRoute:
      protectedWorkspacesWorkspaceIdSettingsReviewRoute,
    protectedWorkspacesWorkspaceIdSettingsSecurityRoute:
      protectedWorkspacesWorkspaceIdSettingsSecurityRoute,
    protectedWorkspacesWorkspaceIdSettingsSigningRoute:
      protectedWorkspacesWorkspaceIdSettingsSigningRoute,
    protectedWorkspacesWorkspaceIdSettingsTemplatesRoute:
      protectedWorkspacesWorkspaceIdSettingsTemplatesRoute,
    protectedWorkspacesWorkspaceIdSettingsThemeRoute:
      protectedWorkspacesWorkspaceIdSettingsThemeRoute,
    protectedWorkspacesWorkspaceIdSettingsWritingRoute:
      protectedWorkspacesWorkspaceIdSettingsWritingRoute,
    protectedWorkspacesWorkspaceIdSettingsIndexRoute:
      protectedWorkspacesWorkspaceIdSettingsIndexRoute,
  }

const protectedWorkspacesWorkspaceIdSettingsRouteRouteWithChildren =
  protectedWorkspacesWorkspaceIdSettingsRouteRoute._addFileChildren(
    protectedWorkspacesWorkspaceIdSettingsRouteRouteChildren,
  )

interface protectedWorkspacesWorkspaceIdPeopleRouteChildren {
  protectedWorkspacesWorkspaceIdPeopleMeRoute: typeof protectedWorkspacesWorkspaceIdPeopleMeRoute
}

const protectedWorkspacesWorkspaceIdPeopleRouteChildren: protectedWorkspacesWorkspaceIdPeopleRouteChildren =
  {
    protectedWorkspacesWorkspaceIdPeopleMeRoute:
      protectedWorkspacesWorkspaceIdPeopleMeRoute,
  }

const protectedWorkspacesWorkspaceIdPeopleRouteWithChildren =
  protectedWorkspacesWorkspaceIdPeopleRoute._addFileChildren(
    protectedWorkspacesWorkspaceIdPeopleRouteChildren,
  )

interface protectedWorkspacesWorkspaceIdRouteRouteChildren {
  protectedWorkspacesWorkspaceIdAuditorCenterRouteRoute: typeof protectedWorkspacesWorkspaceIdAuditorCenterRouteRouteWithChildren
  protectedWorkspacesWorkspaceIdEmployeeCenterRouteRoute: typeof protectedWorkspacesWorkspaceIdEmployeeCenterRouteRouteWithChildren
  protectedWorkspacesWorkspaceIdSettingsRouteRoute: typeof protectedWorkspacesWorkspaceIdSettingsRouteRouteWithChildren
  protectedWorkspacesWorkspaceIdAnonymousReportsRoute: typeof protectedWorkspacesWorkspaceIdAnonymousReportsRoute
  protectedWorkspacesWorkspaceIdApprovalsRoute: typeof protectedWorkspacesWorkspaceIdApprovalsRoute
  protectedWorkspacesWorkspaceIdAssetsRoute: typeof protectedWorkspacesWorkspaceIdAssetsRoute
  protectedWorkspacesWorkspaceIdConnectRepoRoute: typeof protectedWorkspacesWorkspaceIdConnectRepoRoute
  protectedWorkspacesWorkspaceIdConnectToolsRoute: typeof protectedWorkspacesWorkspaceIdConnectToolsRoute
  protectedWorkspacesWorkspaceIdControlsRoute: typeof protectedWorkspacesWorkspaceIdControlsRoute
  protectedWorkspacesWorkspaceIdDashboardRoute: typeof protectedWorkspacesWorkspaceIdDashboardRoute
  protectedWorkspacesWorkspaceIdDocumentsRoute: typeof protectedWorkspacesWorkspaceIdDocumentsRoute
  protectedWorkspacesWorkspaceIdEvidenceRoute: typeof protectedWorkspacesWorkspaceIdEvidenceRoute
  protectedWorkspacesWorkspaceIdEvidenceSlotsRoute: typeof protectedWorkspacesWorkspaceIdEvidenceSlotsRoute
  protectedWorkspacesWorkspaceIdGuideRoute: typeof protectedWorkspacesWorkspaceIdGuideRoute
  protectedWorkspacesWorkspaceIdInboxRoute: typeof protectedWorkspacesWorkspaceIdInboxRoute
  protectedWorkspacesWorkspaceIdIntegrationsRoute: typeof protectedWorkspacesWorkspaceIdIntegrationsRoute
  protectedWorkspacesWorkspaceIdMonitoringRoute: typeof protectedWorkspacesWorkspaceIdMonitoringRoute
  protectedWorkspacesWorkspaceIdOnboardingRoute: typeof protectedWorkspacesWorkspaceIdOnboardingRoute
  protectedWorkspacesWorkspaceIdPeopleRoute: typeof protectedWorkspacesWorkspaceIdPeopleRouteWithChildren
  protectedWorkspacesWorkspaceIdPoliciesRoute: typeof protectedWorkspacesWorkspaceIdPoliciesRoute
  protectedWorkspacesWorkspaceIdQuestionnairesRoute: typeof protectedWorkspacesWorkspaceIdQuestionnairesRoute
  protectedWorkspacesWorkspaceIdReadinessRoute: typeof protectedWorkspacesWorkspaceIdReadinessRoute
  protectedWorkspacesWorkspaceIdRisksRoute: typeof protectedWorkspacesWorkspaceIdRisksRoute
  protectedWorkspacesWorkspaceIdRunbooksRoute: typeof protectedWorkspacesWorkspaceIdRunbooksRoute
  protectedWorkspacesWorkspaceIdSetupRoute: typeof protectedWorkspacesWorkspaceIdSetupRoute
  protectedWorkspacesWorkspaceIdStatementOfApplicabilityRoute: typeof protectedWorkspacesWorkspaceIdStatementOfApplicabilityRoute
  protectedWorkspacesWorkspaceIdSystemDescriptionRoute: typeof protectedWorkspacesWorkspaceIdSystemDescriptionRoute
  protectedWorkspacesWorkspaceIdTasksRoute: typeof protectedWorkspacesWorkspaceIdTasksRoute
  protectedWorkspacesWorkspaceIdTestsRoute: typeof protectedWorkspacesWorkspaceIdTestsRoute
  protectedWorkspacesWorkspaceIdTrustCenterRoute: typeof protectedWorkspacesWorkspaceIdTrustCenterRoute
  protectedWorkspacesWorkspaceIdVendorsRoute: typeof protectedWorkspacesWorkspaceIdVendorsRoute
  protectedWorkspacesWorkspaceIdIndexRoute: typeof protectedWorkspacesWorkspaceIdIndexRoute
  protectedWorkspacesWorkspaceIdAnonymousReportsReportIdRoute: typeof protectedWorkspacesWorkspaceIdAnonymousReportsReportIdRoute
  protectedWorkspacesWorkspaceIdAssetsAssetIdRoute: typeof protectedWorkspacesWorkspaceIdAssetsAssetIdRoute
  protectedWorkspacesWorkspaceIdAuditsAuditCycleIdRoute: typeof protectedWorkspacesWorkspaceIdAuditsAuditCycleIdRoute
  protectedWorkspacesWorkspaceIdChatThreadIdRoute: typeof protectedWorkspacesWorkspaceIdChatThreadIdRoute
  protectedWorkspacesWorkspaceIdControlsControlDefIdRoute: typeof protectedWorkspacesWorkspaceIdControlsControlDefIdRoute
  protectedWorkspacesWorkspaceIdDeprecatedComplianceRouteOldRoute: typeof protectedWorkspacesWorkspaceIdDeprecatedComplianceRouteOldRoute
  protectedWorkspacesWorkspaceIdDevToolUiRoute: typeof protectedWorkspacesWorkspaceIdDevToolUiRoute
  protectedWorkspacesWorkspaceIdDevicesDeviceIdRoute: typeof protectedWorkspacesWorkspaceIdDevicesDeviceIdRoute
  protectedWorkspacesWorkspaceIdDocumentsDocIdRoute: typeof protectedWorkspacesWorkspaceIdDocumentsDocIdRoute
  protectedWorkspacesWorkspaceIdEvidenceViewerEvidencePackIdRoute: typeof protectedWorkspacesWorkspaceIdEvidenceViewerEvidencePackIdRoute
  protectedWorkspacesWorkspaceIdEvidenceCreatingRoute: typeof protectedWorkspacesWorkspaceIdEvidenceCreatingRoute
  protectedWorkspacesWorkspaceIdIntegrationsProviderSlugRoute: typeof protectedWorkspacesWorkspaceIdIntegrationsProviderSlugRoute
  protectedWorkspacesWorkspaceIdPeopleEmployeeIdRoute: typeof protectedWorkspacesWorkspaceIdPeopleEmployeeIdRoute
  protectedWorkspacesWorkspaceIdPeople_groupsGroupIdRoute: typeof protectedWorkspacesWorkspaceIdPeople_groupsGroupIdRoute
  protectedWorkspacesWorkspaceIdPeople_trainingProgramIdRoute: typeof protectedWorkspacesWorkspaceIdPeople_trainingProgramIdRoute
  protectedWorkspacesWorkspaceIdPoliciesPolicySlugRoute: typeof protectedWorkspacesWorkspaceIdPoliciesPolicySlugRoute
  protectedWorkspacesWorkspaceIdQuestionnairesIdRoute: typeof protectedWorkspacesWorkspaceIdQuestionnairesIdRoute
  protectedWorkspacesWorkspaceIdReviewsAccessRoute: typeof protectedWorkspacesWorkspaceIdReviewsAccessRoute
  protectedWorkspacesWorkspaceIdRisksRiskIdRoute: typeof protectedWorkspacesWorkspaceIdRisksRiskIdRoute
  protectedWorkspacesWorkspaceIdRunbooksRunbookIdRoute: typeof protectedWorkspacesWorkspaceIdRunbooksRunbookIdRoute
  protectedWorkspacesWorkspaceIdRunbooksNewRoute: typeof protectedWorkspacesWorkspaceIdRunbooksNewRoute
  protectedWorkspacesWorkspaceIdRunsExecutionIdRoute: typeof protectedWorkspacesWorkspaceIdRunsExecutionIdRoute
  protectedWorkspacesWorkspaceIdSubmissionsSubmissionIdRoute: typeof protectedWorkspacesWorkspaceIdSubmissionsSubmissionIdRoute
  protectedWorkspacesWorkspaceIdTasksTaskIdRoute: typeof protectedWorkspacesWorkspaceIdTasksTaskIdRoute
  protectedWorkspacesWorkspaceIdTasksDetailRoute: typeof protectedWorkspacesWorkspaceIdTasksDetailRoute
  protectedWorkspacesWorkspaceIdTemplatesNewRoute: typeof protectedWorkspacesWorkspaceIdTemplatesNewRoute
  protectedWorkspacesWorkspaceIdTemplatesPublicRoute: typeof protectedWorkspacesWorkspaceIdTemplatesPublicRoute
  protectedWorkspacesWorkspaceIdVendorsVendorIdRoute: typeof protectedWorkspacesWorkspaceIdVendorsVendorIdRoute
  protectedWorkspacesWorkspaceIdAutomationIdentitiesLazyRoute: typeof protectedWorkspacesWorkspaceIdAutomationIdentitiesLazyRoute
  protectedWorkspacesWorkspaceIdDeprecatedAgentReliabilityLazyRoute: typeof protectedWorkspacesWorkspaceIdDeprecatedAgentReliabilityLazyRoute
  protectedWorkspacesWorkspaceIdAuditsIndexRoute: typeof protectedWorkspacesWorkspaceIdAuditsIndexRoute
  protectedWorkspacesWorkspaceIdFrameworksIndexRoute: typeof protectedWorkspacesWorkspaceIdFrameworksIndexRoute
  protectedWorkspacesWorkspaceIdPopulationsIndexRoute: typeof protectedWorkspacesWorkspaceIdPopulationsIndexRoute
  protectedWorkspacesWorkspaceIdRunsIndexRoute: typeof protectedWorkspacesWorkspaceIdRunsIndexRoute
  protectedWorkspacesWorkspaceIdTemplatesIndexRoute: typeof protectedWorkspacesWorkspaceIdTemplatesIndexRoute
  protectedWorkspacesWorkspaceIdAutomationIndexLazyRoute: typeof protectedWorkspacesWorkspaceIdAutomationIndexLazyRoute
  protectedWorkspacesWorkspaceIdIntegrationsCustomApplicationIdRoute: typeof protectedWorkspacesWorkspaceIdIntegrationsCustomApplicationIdRoute
  protectedWorkspacesWorkspaceIdRecordingsFlowIdEditRoute: typeof protectedWorkspacesWorkspaceIdRecordingsFlowIdEditRoute
  protectedWorkspacesWorkspaceIdReviewsAccessCycleIdRoute: typeof protectedWorkspacesWorkspaceIdReviewsAccessCycleIdRoute
  protectedWorkspacesWorkspaceIdReviewsAccessRolesRoute: typeof protectedWorkspacesWorkspaceIdReviewsAccessRolesRoute
  protectedWorkspacesWorkspaceIdRisksAssessmentsDraftIdRoute: typeof protectedWorkspacesWorkspaceIdRisksAssessmentsDraftIdRoute
  protectedWorkspacesWorkspaceIdTemplatesTemplateIdEditRoute: typeof protectedWorkspacesWorkspaceIdTemplatesTemplateIdEditRoute
  protectedWorkspacesWorkspaceIdTestsTestIdSubmissionsRoute: typeof protectedWorkspacesWorkspaceIdTestsTestIdSubmissionsRoute
  protectedWorkspacesWorkspaceIdAutomationExecutionIdIndexRoute: typeof protectedWorkspacesWorkspaceIdAutomationExecutionIdIndexRoute
  protectedWorkspacesWorkspaceIdDeprecatedSourcesIndexRoute: typeof protectedWorkspacesWorkspaceIdDeprecatedSourcesIndexRoute
  protectedWorkspacesWorkspaceIdFrameworksFrameworkIdIndexRoute: typeof protectedWorkspacesWorkspaceIdFrameworksFrameworkIdIndexRoute
  protectedWorkspacesWorkspaceIdTemplatesTemplateIdIndexRoute: typeof protectedWorkspacesWorkspaceIdTemplatesTemplateIdIndexRoute
  protectedWorkspacesWorkspaceIdTestsTestIdIndexRoute: typeof protectedWorkspacesWorkspaceIdTestsTestIdIndexRoute
  protectedWorkspacesWorkspaceIdDeprecatedIntegrationsOldIndexLazyRoute: typeof protectedWorkspacesWorkspaceIdDeprecatedIntegrationsOldIndexLazyRoute
  protectedWorkspacesWorkspaceIdIntegrationsProviderSlugAccountsConnectionIdRoute: typeof protectedWorkspacesWorkspaceIdIntegrationsProviderSlugAccountsConnectionIdRoute
  protectedWorkspacesWorkspaceIdIntegrationsProviderSlugServicesServiceIdRoute: typeof protectedWorkspacesWorkspaceIdIntegrationsProviderSlugServicesServiceIdRoute
  protectedWorkspacesWorkspaceIdReviewsAccessPeriodPeriodKeyRoute: typeof protectedWorkspacesWorkspaceIdReviewsAccessPeriodPeriodKeyRoute
  protectedWorkspacesWorkspaceIdVendorsVendorIdAssessmentsAssessmentIdRoute: typeof protectedWorkspacesWorkspaceIdVendorsVendorIdAssessmentsAssessmentIdRoute
  protectedWorkspacesWorkspaceIdFrameworksFrameworkIdControlsIndexRoute: typeof protectedWorkspacesWorkspaceIdFrameworksFrameworkIdControlsIndexRoute
  protectedWorkspacesWorkspaceIdTemplatesControlControlIdIndexRoute: typeof protectedWorkspacesWorkspaceIdTemplatesControlControlIdIndexRoute
  protectedWorkspacesWorkspaceIdDeprecatedWorkflowsWorkflowIdExecutionsJobIdRoute: typeof protectedWorkspacesWorkspaceIdDeprecatedWorkflowsWorkflowIdExecutionsJobIdRoute
  protectedWorkspacesWorkspaceIdIntegrationsCustomApplicationIdDatasetsDatasetIdRoute: typeof protectedWorkspacesWorkspaceIdIntegrationsCustomApplicationIdDatasetsDatasetIdRoute
}

const protectedWorkspacesWorkspaceIdRouteRouteChildren: protectedWorkspacesWorkspaceIdRouteRouteChildren =
  {
    protectedWorkspacesWorkspaceIdAuditorCenterRouteRoute:
      protectedWorkspacesWorkspaceIdAuditorCenterRouteRouteWithChildren,
    protectedWorkspacesWorkspaceIdEmployeeCenterRouteRoute:
      protectedWorkspacesWorkspaceIdEmployeeCenterRouteRouteWithChildren,
    protectedWorkspacesWorkspaceIdSettingsRouteRoute:
      protectedWorkspacesWorkspaceIdSettingsRouteRouteWithChildren,
    protectedWorkspacesWorkspaceIdAnonymousReportsRoute:
      protectedWorkspacesWorkspaceIdAnonymousReportsRoute,
    protectedWorkspacesWorkspaceIdApprovalsRoute:
      protectedWorkspacesWorkspaceIdApprovalsRoute,
    protectedWorkspacesWorkspaceIdAssetsRoute:
      protectedWorkspacesWorkspaceIdAssetsRoute,
    protectedWorkspacesWorkspaceIdConnectRepoRoute:
      protectedWorkspacesWorkspaceIdConnectRepoRoute,
    protectedWorkspacesWorkspaceIdConnectToolsRoute:
      protectedWorkspacesWorkspaceIdConnectToolsRoute,
    protectedWorkspacesWorkspaceIdControlsRoute:
      protectedWorkspacesWorkspaceIdControlsRoute,
    protectedWorkspacesWorkspaceIdDashboardRoute:
      protectedWorkspacesWorkspaceIdDashboardRoute,
    protectedWorkspacesWorkspaceIdDocumentsRoute:
      protectedWorkspacesWorkspaceIdDocumentsRoute,
    protectedWorkspacesWorkspaceIdEvidenceRoute:
      protectedWorkspacesWorkspaceIdEvidenceRoute,
    protectedWorkspacesWorkspaceIdEvidenceSlotsRoute:
      protectedWorkspacesWorkspaceIdEvidenceSlotsRoute,
    protectedWorkspacesWorkspaceIdGuideRoute:
      protectedWorkspacesWorkspaceIdGuideRoute,
    protectedWorkspacesWorkspaceIdInboxRoute:
      protectedWorkspacesWorkspaceIdInboxRoute,
    protectedWorkspacesWorkspaceIdIntegrationsRoute:
      protectedWorkspacesWorkspaceIdIntegrationsRoute,
    protectedWorkspacesWorkspaceIdMonitoringRoute:
      protectedWorkspacesWorkspaceIdMonitoringRoute,
    protectedWorkspacesWorkspaceIdOnboardingRoute:
      protectedWorkspacesWorkspaceIdOnboardingRoute,
    protectedWorkspacesWorkspaceIdPeopleRoute:
      protectedWorkspacesWorkspaceIdPeopleRouteWithChildren,
    protectedWorkspacesWorkspaceIdPoliciesRoute:
      protectedWorkspacesWorkspaceIdPoliciesRoute,
    protectedWorkspacesWorkspaceIdQuestionnairesRoute:
      protectedWorkspacesWorkspaceIdQuestionnairesRoute,
    protectedWorkspacesWorkspaceIdReadinessRoute:
      protectedWorkspacesWorkspaceIdReadinessRoute,
    protectedWorkspacesWorkspaceIdRisksRoute:
      protectedWorkspacesWorkspaceIdRisksRoute,
    protectedWorkspacesWorkspaceIdRunbooksRoute:
      protectedWorkspacesWorkspaceIdRunbooksRoute,
    protectedWorkspacesWorkspaceIdSetupRoute:
      protectedWorkspacesWorkspaceIdSetupRoute,
    protectedWorkspacesWorkspaceIdStatementOfApplicabilityRoute:
      protectedWorkspacesWorkspaceIdStatementOfApplicabilityRoute,
    protectedWorkspacesWorkspaceIdSystemDescriptionRoute:
      protectedWorkspacesWorkspaceIdSystemDescriptionRoute,
    protectedWorkspacesWorkspaceIdTasksRoute:
      protectedWorkspacesWorkspaceIdTasksRoute,
    protectedWorkspacesWorkspaceIdTestsRoute:
      protectedWorkspacesWorkspaceIdTestsRoute,
    protectedWorkspacesWorkspaceIdTrustCenterRoute:
      protectedWorkspacesWorkspaceIdTrustCenterRoute,
    protectedWorkspacesWorkspaceIdVendorsRoute:
      protectedWorkspacesWorkspaceIdVendorsRoute,
    protectedWorkspacesWorkspaceIdIndexRoute:
      protectedWorkspacesWorkspaceIdIndexRoute,
    protectedWorkspacesWorkspaceIdAnonymousReportsReportIdRoute:
      protectedWorkspacesWorkspaceIdAnonymousReportsReportIdRoute,
    protectedWorkspacesWorkspaceIdAssetsAssetIdRoute:
      protectedWorkspacesWorkspaceIdAssetsAssetIdRoute,
    protectedWorkspacesWorkspaceIdAuditsAuditCycleIdRoute:
      protectedWorkspacesWorkspaceIdAuditsAuditCycleIdRoute,
    protectedWorkspacesWorkspaceIdChatThreadIdRoute:
      protectedWorkspacesWorkspaceIdChatThreadIdRoute,
    protectedWorkspacesWorkspaceIdControlsControlDefIdRoute:
      protectedWorkspacesWorkspaceIdControlsControlDefIdRoute,
    protectedWorkspacesWorkspaceIdDeprecatedComplianceRouteOldRoute:
      protectedWorkspacesWorkspaceIdDeprecatedComplianceRouteOldRoute,
    protectedWorkspacesWorkspaceIdDevToolUiRoute:
      protectedWorkspacesWorkspaceIdDevToolUiRoute,
    protectedWorkspacesWorkspaceIdDevicesDeviceIdRoute:
      protectedWorkspacesWorkspaceIdDevicesDeviceIdRoute,
    protectedWorkspacesWorkspaceIdDocumentsDocIdRoute:
      protectedWorkspacesWorkspaceIdDocumentsDocIdRoute,
    protectedWorkspacesWorkspaceIdEvidenceViewerEvidencePackIdRoute:
      protectedWorkspacesWorkspaceIdEvidenceViewerEvidencePackIdRoute,
    protectedWorkspacesWorkspaceIdEvidenceCreatingRoute:
      protectedWorkspacesWorkspaceIdEvidenceCreatingRoute,
    protectedWorkspacesWorkspaceIdIntegrationsProviderSlugRoute:
      protectedWorkspacesWorkspaceIdIntegrationsProviderSlugRoute,
    protectedWorkspacesWorkspaceIdPeopleEmployeeIdRoute:
      protectedWorkspacesWorkspaceIdPeopleEmployeeIdRoute,
    protectedWorkspacesWorkspaceIdPeople_groupsGroupIdRoute:
      protectedWorkspacesWorkspaceIdPeople_groupsGroupIdRoute,
    protectedWorkspacesWorkspaceIdPeople_trainingProgramIdRoute:
      protectedWorkspacesWorkspaceIdPeople_trainingProgramIdRoute,
    protectedWorkspacesWorkspaceIdPoliciesPolicySlugRoute:
      protectedWorkspacesWorkspaceIdPoliciesPolicySlugRoute,
    protectedWorkspacesWorkspaceIdQuestionnairesIdRoute:
      protectedWorkspacesWorkspaceIdQuestionnairesIdRoute,
    protectedWorkspacesWorkspaceIdReviewsAccessRoute:
      protectedWorkspacesWorkspaceIdReviewsAccessRoute,
    protectedWorkspacesWorkspaceIdRisksRiskIdRoute:
      protectedWorkspacesWorkspaceIdRisksRiskIdRoute,
    protectedWorkspacesWorkspaceIdRunbooksRunbookIdRoute:
      protectedWorkspacesWorkspaceIdRunbooksRunbookIdRoute,
    protectedWorkspacesWorkspaceIdRunbooksNewRoute:
      protectedWorkspacesWorkspaceIdRunbooksNewRoute,
    protectedWorkspacesWorkspaceIdRunsExecutionIdRoute:
      protectedWorkspacesWorkspaceIdRunsExecutionIdRoute,
    protectedWorkspacesWorkspaceIdSubmissionsSubmissionIdRoute:
      protectedWorkspacesWorkspaceIdSubmissionsSubmissionIdRoute,
    protectedWorkspacesWorkspaceIdTasksTaskIdRoute:
      protectedWorkspacesWorkspaceIdTasksTaskIdRoute,
    protectedWorkspacesWorkspaceIdTasksDetailRoute:
      protectedWorkspacesWorkspaceIdTasksDetailRoute,
    protectedWorkspacesWorkspaceIdTemplatesNewRoute:
      protectedWorkspacesWorkspaceIdTemplatesNewRoute,
    protectedWorkspacesWorkspaceIdTemplatesPublicRoute:
      protectedWorkspacesWorkspaceIdTemplatesPublicRoute,
    protectedWorkspacesWorkspaceIdVendorsVendorIdRoute:
      protectedWorkspacesWorkspaceIdVendorsVendorIdRoute,
    protectedWorkspacesWorkspaceIdAutomationIdentitiesLazyRoute:
      protectedWorkspacesWorkspaceIdAutomationIdentitiesLazyRoute,
    protectedWorkspacesWorkspaceIdDeprecatedAgentReliabilityLazyRoute:
      protectedWorkspacesWorkspaceIdDeprecatedAgentReliabilityLazyRoute,
    protectedWorkspacesWorkspaceIdAuditsIndexRoute:
      protectedWorkspacesWorkspaceIdAuditsIndexRoute,
    protectedWorkspacesWorkspaceIdFrameworksIndexRoute:
      protectedWorkspacesWorkspaceIdFrameworksIndexRoute,
    protectedWorkspacesWorkspaceIdPopulationsIndexRoute:
      protectedWorkspacesWorkspaceIdPopulationsIndexRoute,
    protectedWorkspacesWorkspaceIdRunsIndexRoute:
      protectedWorkspacesWorkspaceIdRunsIndexRoute,
    protectedWorkspacesWorkspaceIdTemplatesIndexRoute:
      protectedWorkspacesWorkspaceIdTemplatesIndexRoute,
    protectedWorkspacesWorkspaceIdAutomationIndexLazyRoute:
      protectedWorkspacesWorkspaceIdAutomationIndexLazyRoute,
    protectedWorkspacesWorkspaceIdIntegrationsCustomApplicationIdRoute:
      protectedWorkspacesWorkspaceIdIntegrationsCustomApplicationIdRoute,
    protectedWorkspacesWorkspaceIdRecordingsFlowIdEditRoute:
      protectedWorkspacesWorkspaceIdRecordingsFlowIdEditRoute,
    protectedWorkspacesWorkspaceIdReviewsAccessCycleIdRoute:
      protectedWorkspacesWorkspaceIdReviewsAccessCycleIdRoute,
    protectedWorkspacesWorkspaceIdReviewsAccessRolesRoute:
      protectedWorkspacesWorkspaceIdReviewsAccessRolesRoute,
    protectedWorkspacesWorkspaceIdRisksAssessmentsDraftIdRoute:
      protectedWorkspacesWorkspaceIdRisksAssessmentsDraftIdRoute,
    protectedWorkspacesWorkspaceIdTemplatesTemplateIdEditRoute:
      protectedWorkspacesWorkspaceIdTemplatesTemplateIdEditRoute,
    protectedWorkspacesWorkspaceIdTestsTestIdSubmissionsRoute:
      protectedWorkspacesWorkspaceIdTestsTestIdSubmissionsRoute,
    protectedWorkspacesWorkspaceIdAutomationExecutionIdIndexRoute:
      protectedWorkspacesWorkspaceIdAutomationExecutionIdIndexRoute,
    protectedWorkspacesWorkspaceIdDeprecatedSourcesIndexRoute:
      protectedWorkspacesWorkspaceIdDeprecatedSourcesIndexRoute,
    protectedWorkspacesWorkspaceIdFrameworksFrameworkIdIndexRoute:
      protectedWorkspacesWorkspaceIdFrameworksFrameworkIdIndexRoute,
    protectedWorkspacesWorkspaceIdTemplatesTemplateIdIndexRoute:
      protectedWorkspacesWorkspaceIdTemplatesTemplateIdIndexRoute,
    protectedWorkspacesWorkspaceIdTestsTestIdIndexRoute:
      protectedWorkspacesWorkspaceIdTestsTestIdIndexRoute,
    protectedWorkspacesWorkspaceIdDeprecatedIntegrationsOldIndexLazyRoute:
      protectedWorkspacesWorkspaceIdDeprecatedIntegrationsOldIndexLazyRoute,
    protectedWorkspacesWorkspaceIdIntegrationsProviderSlugAccountsConnectionIdRoute:
      protectedWorkspacesWorkspaceIdIntegrationsProviderSlugAccountsConnectionIdRoute,
    protectedWorkspacesWorkspaceIdIntegrationsProviderSlugServicesServiceIdRoute:
      protectedWorkspacesWorkspaceIdIntegrationsProviderSlugServicesServiceIdRoute,
    protectedWorkspacesWorkspaceIdReviewsAccessPeriodPeriodKeyRoute:
      protectedWorkspacesWorkspaceIdReviewsAccessPeriodPeriodKeyRoute,
    protectedWorkspacesWorkspaceIdVendorsVendorIdAssessmentsAssessmentIdRoute:
      protectedWorkspacesWorkspaceIdVendorsVendorIdAssessmentsAssessmentIdRoute,
    protectedWorkspacesWorkspaceIdFrameworksFrameworkIdControlsIndexRoute:
      protectedWorkspacesWorkspaceIdFrameworksFrameworkIdControlsIndexRoute,
    protectedWorkspacesWorkspaceIdTemplatesControlControlIdIndexRoute:
      protectedWorkspacesWorkspaceIdTemplatesControlControlIdIndexRoute,
    protectedWorkspacesWorkspaceIdDeprecatedWorkflowsWorkflowIdExecutionsJobIdRoute:
      protectedWorkspacesWorkspaceIdDeprecatedWorkflowsWorkflowIdExecutionsJobIdRoute,
    protectedWorkspacesWorkspaceIdIntegrationsCustomApplicationIdDatasetsDatasetIdRoute:
      protectedWorkspacesWorkspaceIdIntegrationsCustomApplicationIdDatasetsDatasetIdRoute,
  }

const protectedWorkspacesWorkspaceIdRouteRouteWithChildren =
  protectedWorkspacesWorkspaceIdRouteRoute._addFileChildren(
    protectedWorkspacesWorkspaceIdRouteRouteChildren,
  )

interface protectedWorkspacesRouteRouteChildren {
  protectedWorkspacesWorkspaceIdRouteRoute: typeof protectedWorkspacesWorkspaceIdRouteRouteWithChildren
  protectedWorkspacesNewRoute: typeof protectedWorkspacesNewRoute
  protectedWorkspacesIndexLazyRoute: typeof protectedWorkspacesIndexLazyRoute
}

const protectedWorkspacesRouteRouteChildren: protectedWorkspacesRouteRouteChildren =
  {
    protectedWorkspacesWorkspaceIdRouteRoute:
      protectedWorkspacesWorkspaceIdRouteRouteWithChildren,
    protectedWorkspacesNewRoute: protectedWorkspacesNewRoute,
    protectedWorkspacesIndexLazyRoute: protectedWorkspacesIndexLazyRoute,
  }

const protectedWorkspacesRouteRouteWithChildren =
  protectedWorkspacesRouteRoute._addFileChildren(
    protectedWorkspacesRouteRouteChildren,
  )

interface protectedAuditorCenterRouteChildren {
  protectedAuditorCenterProfileRoute: typeof protectedAuditorCenterProfileRoute
  protectedAuditorCenterSecurityRoute: typeof protectedAuditorCenterSecurityRoute
  protectedAuditorCenterIndexRoute: typeof protectedAuditorCenterIndexRoute
}

const protectedAuditorCenterRouteChildren: protectedAuditorCenterRouteChildren =
  {
    protectedAuditorCenterProfileRoute: protectedAuditorCenterProfileRoute,
    protectedAuditorCenterSecurityRoute: protectedAuditorCenterSecurityRoute,
    protectedAuditorCenterIndexRoute: protectedAuditorCenterIndexRoute,
  }

const protectedAuditorCenterRouteWithChildren =
  protectedAuditorCenterRoute._addFileChildren(
    protectedAuditorCenterRouteChildren,
  )

interface protectedRouteRouteChildren {
  protectedOrgsRouteRoute: typeof protectedOrgsRouteRouteWithChildren
  protectedPartnerRouteRoute: typeof protectedPartnerRouteRouteWithChildren
  protectedWorkspacesRouteRoute: typeof protectedWorkspacesRouteRouteWithChildren
  protectedAuditorCenterRoute: typeof protectedAuditorCenterRouteWithChildren
  protectedIndexRoute: typeof protectedIndexRoute
  protectedDevPlanRestrictionsTestRoute: typeof protectedDevPlanRestrictionsTestRoute
  protectedOnboardingIndexLazyRoute: typeof protectedOnboardingIndexLazyRoute
  protectedWorkspaceIntegrationsGithubRoute: typeof protectedWorkspaceIntegrationsGithubRoute
  protectedOnboardingOrganizationIdWorkspaceLazyRoute: typeof protectedOnboardingOrganizationIdWorkspaceLazyRoute
  protectedWorkspaceIntegrationsIndexRoute: typeof protectedWorkspaceIntegrationsIndexRoute
}

const protectedRouteRouteChildren: protectedRouteRouteChildren = {
  protectedOrgsRouteRoute: protectedOrgsRouteRouteWithChildren,
  protectedPartnerRouteRoute: protectedPartnerRouteRouteWithChildren,
  protectedWorkspacesRouteRoute: protectedWorkspacesRouteRouteWithChildren,
  protectedAuditorCenterRoute: protectedAuditorCenterRouteWithChildren,
  protectedIndexRoute: protectedIndexRoute,
  protectedDevPlanRestrictionsTestRoute: protectedDevPlanRestrictionsTestRoute,
  protectedOnboardingIndexLazyRoute: protectedOnboardingIndexLazyRoute,
  protectedWorkspaceIntegrationsGithubRoute:
    protectedWorkspaceIntegrationsGithubRoute,
  protectedOnboardingOrganizationIdWorkspaceLazyRoute:
    protectedOnboardingOrganizationIdWorkspaceLazyRoute,
  protectedWorkspaceIntegrationsIndexRoute:
    protectedWorkspaceIntegrationsIndexRoute,
}

const protectedRouteRouteWithChildren = protectedRouteRoute._addFileChildren(
  protectedRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  authRouteRoute: authRouteRouteWithChildren,
  protectedRouteRoute: protectedRouteRouteWithChildren,
  ExtensionUninstalledLazyRoute: ExtensionUninstalledLazyRoute,
  IntegrationsGithubAppCallbackRoute: IntegrationsGithubAppCallbackRoute,
  OauthConsentRoute: OauthConsentRoute,
  TrustSlugRoute: TrustSlugRoute,
  errors401LazyRoute: errors401LazyRoute,
  errors403LazyRoute: errors403LazyRoute,
  errors404LazyRoute: errors404LazyRoute,
  errors500LazyRoute: errors500LazyRoute,
  errors503LazyRoute: errors503LazyRoute,
  SharedShareIdLazyRoute: SharedShareIdLazyRoute,
  DemoTiptapAiChangesRoute: DemoTiptapAiChangesRoute,
  DemoTiptapAiSuggestionRoute: DemoTiptapAiSuggestionRoute,
  TrustAccessTokenRoute: TrustAccessTokenRoute,
  TrustNdaTokenRoute: TrustNdaTokenRoute,
  TrustResourcesResourceIdRoute: TrustResourcesResourceIdRoute,
  DemoTiptapIndexRoute: DemoTiptapIndexRoute,
  EvidenceVerifyIndexRoute: EvidenceVerifyIndexRoute,
  ExportEvidencePdfIndexRoute: ExportEvidencePdfIndexRoute,
  ExportOrgChartIndexRoute: ExportOrgChartIndexRoute,
  ExportPolicyPdfIndexRoute: ExportPolicyPdfIndexRoute,
  ExportTopicEmbedIndexRoute: ExportTopicEmbedIndexRoute,
  ExportTopicPdfIndexRoute: ExportTopicPdfIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
